const zhSC = {
  // 登录相关
  login: {
    title: 'SS.AI 客服',
    platformTitle: 'CUI 工作平台',
    platformTitlePrefix: '中小企的 ',
    platformTitleHighlight: 'CUI',
    platformTitleSuffix: ' 工作平台',
    userId: '用户 ID',
    email: 'Email',
    accountOrEmail: '账号或 Email',
    password: '密码',
    loginButton: '登录',
    loginSuccess: '登录成功！',
    loginFailed: '登录失败',
    userIdRequired: '请输入用户 ID！',
    passwordRequired: '请输入密码！',
    accountPasswordError: '账号或密码错误',
    networkError: '登录失败，请检查网络连接',
    welcome: '欢迎使用 SS.AI 客服，{name}！',
    userIdLabel: '用户 ID',
    logout: '登出',
    logoutSuccess: '已登出'
  },
  wpaLogin: {
    loginName: '登录账号',
    password: '密码',
    passwordPlaceholder: '请输入密码',
    rememberLogin: '自动登录',
    rememberLoginHint: '会记住此设备上的登录账号（密码不会由网页保存，请用浏览器密码管理或自行输入）。若上次未登出，进入此页将自动进入商店。',
    sessionRestoring: '正在恢复登录…',
    forgotPassword: '忘记密码',
    forgotPasswordTitle: '忘记密码',
    login: '登录',
    loggingIn: '登录中...',
    validatingWhatsappLink: '正在验证 WhatsApp 链接...',
    otpSentTo: '验证码已发送至',
    otpCode: '验证码 (OTP)',
    verify: '验证',
    verifying: '验证中...',
    useAccountPassword: '改用账号密码登录',
    backToLogin: '返回登录',
    selectCompany: '请选择公司',
    whatsappOtpLogin: 'WhatsApp 验证登录',
    networkError: '网络错误，请稍后再试',
    loginFailed: '登录失败，请确认账号密码',
    otpFailed: 'OTP 验证失败，请重新输入',
    companySelectFailed: '公司选择失败',
    linkValidateFailed: '链接验证失败，请重新从 WhatsApp 打开',
    enterLoginNameFirst: '请先输入登录账号，再按忘记密码',
    forgotPasswordGuide: '请先在登录页输入「登录账号」，再选择下方重设方式（仅显示您账号已登记的 WhatsApp 电话或邮箱）。',
    forgotPasswordNoChannels: '此账号未登记电话或邮箱，无法重设密码。请联系管理员。',
    forgotPasswordChooseMethod: '选择重设方式',
    forgotPasswordPhoneOnlyHint: '请输入登录帐号后，系统将以已登记电话发送 OTP 验证码',
    forgotPasswordByEmail: '电邮收取验证码',
    forgotPasswordEmailUnavailable: '此账号不存在、未绑定电邮，或电邮 OTP 模板尚未设置。请改试 WhatsApp 或联系管理员。',
    forgotPasswordByPhone: '电话接收验证码',
    forgotPasswordEmailDone: '若此账号存在且已登记邮箱，您将收到重设密码链接。',
    forgotPasswordPhoneUnavailable: '此账号不存在、未绑定电话，或无法发送验证码。请改试电子邮件或联系管理员。',
    forgotPasswordNewPassword: '新密码',
    forgotPasswordConfirmPassword: '确认新密码',
    forgotPasswordSubmitPhone: '验证并重设密码',
    forgotPasswordPhoneSuccess: '密码已重设，请返回登录。',
    forgotPasswordMismatch: '两次输入的密码不一致',
    resetPasswordTitle: '重设密码',
    resetPasswordSubmit: '设置新密码',
    resetPasswordSuccess: '密码已更新，请返回登录。',
    resetPasswordBackToLogin: '返回登录',
    resetPasswordTokenMissing: '链接无效或已过期，请重新申请重设。',
    passwordMinLength: '密码至少需 8 个字符',
    brandSubtitle: 'WhatoCommerce',
    languageAria: '界面语言',
    otpLoginSeparator: '或通过以下方式登录',
    sendWhatsappOtp: '以 WhatsApp 发送验证码',
    sendEmailOtp: '以电邮发送验证码',
    emailOtpLogin: '电邮验证码登录',
    sendingOtp: '正在发送...',
    emailOtpSentTo: '验证码已发至电邮',
  },
  wpa: {
    changePassword: {
      title: '修改密码',
      currentPassword: '当前密码',
      newPassword: '新密码',
      confirmPassword: '确认新密码',
      submit: '保存新密码',
      success: '密码已成功更新。',
      errorMismatch: '两次输入的密码不一致',
      errorMinLength: '密码至少需 8 个字符',
      errorWrongCurrent: '当前密码不正确',
      errorNetwork: '网络错误，请稍后再试',
    },
    common: {
      loading: '加载中...',
      loadMore: '加载更多...',
      noProducts: '暂无商品',
      noCategories: '暂无分类',
      noOrders: '暂无订单',
      priceInquire: '价格请询',
      outOfStock: '没有库存',
      noStock: '没有库存',
      addToCartAria: '加入购物车',
      search: '搜索',
      allCategories: '所有分类',
      searchPlaceholder: '搜索商品...',
      noSearchResults: '暂无匹配商品',
      cannotOrderOutOfStock: '此商品库存为「没有库存」，无法下单。',
      cannotOrderInactiveStatus: '此商品状态为「{status}」，无法下单。',
      catalogStatusDisplay: '状态：{status}',
      catalogStatusLabels: {
        outOfStock: '断货',
        stopOrdering: '停止订购',
        suspend: '暂停',
      },
      emDash: '—',
      forbiddenAction: '无权执行此操作',
      requestFailedStatus: '请求失败（{status}）',
      cannotAddToCartTitle: '无法加入购物车',
      customerSuspendedBlock:
        '很抱歉，您的帐户已暂停，请联络业务员了解详情。\n\n业务：{sales}\n业务代码：{code}\nWhatsApp：{whatsapp}\n\n错误代码：C',
      moqSubmitBlocked: '以下品项数量未达最少订购量（MOQ），请调整后再提交：',
      moqSubmitLineFmt: '{label}：最少 {moq}，目前 {qty}',
      moqSubmitDocPrefix: '单据 {cartNo}',
    },
    titles: {
      home: '首页',
      categories: '商品分类',
      products: '商品列表',
      cart: '购物车',
      cartDetail: '订单资料',
      orders: '订单记录',
      account: '账户信息',
      orderDetail: '订单详情',
    },
    layout: {
      menuHome: '首页',
      menuCategories: '分类',
      menuCart: '购物车',
      menuOrders: '订单记录',
      menuAccount: '账户信息',
      menuChangePassword: '修改密码',
      ariaMenu: '菜单',
      ariaBack: '返回',
      ariaSearch: '搜索',
      ariaCart: '购物车',
      logout: '登出',
      selectCustomer: '选择客户身份',
      current: '当前',
      cancel: '取消',
      installTitle: '安装 WhatoCommerce 到手机桌面',
      installBodyAndroid: '为获得最佳体验，请先安装到主屏幕。点击下方「立即安装」。',
      installBodyIos: '为获得最佳体验，请先安装到主屏幕。iPhone 请使用 Safari 的分享按钮，选择「添加到主屏幕」。',
      installBodyAndroidManual: '若未出现「立即安装」，请点击 Chrome 右上角 ⋮ →「安装应用」或「添加到主屏幕」。安装后会从本商店登录页打开。',
      installLater: '稍后',
      installNow: '立即安装',
      installGotIt: '我知道了',
    },
    home: {
      banner: '精选推荐商品',
      recommended: '推荐商品',
      allCategoriesBtn: '所有商品分类',
      toastAddedLatest: '已加入最新购物车: {name} x{qty}',
      toastNewCart: '已新建购物车并加入: {name} x{qty}',
      promoClose: '关闭',
      promoAddToCart: '加入购物车',
      promoNoProduct: '此广告未链接可购买商品',
      promoOutOfStock: '暂不可加购',
      ariaFullscreenAd: '全屏广告',
      promoCarouselDots: '广告轮播',
      promoPrev: '上一张广告',
      promoNext: '下一张广告',
      recommendDelete: '删除',
      recommendDeleted: '已从推荐列表移除：{name}',
      recommendDeleteFailed: '无法删除推荐价格表',
      recommendDeleteConfirmTitle: '确认删除？',
      recommendDeleteConfirmMsg: '确定要从推荐列表移除「{name}」吗？此操作无法复原。',
      recommendDeleteConfirmBtn: '确认删除',
    },
    addToCart: {
      defaultUnit: '件',
      perQtyFmt: '每{unit} {price}',
      qtyWithUnitFmt: '{qty} {unit}',
      fastStepMinus: '- {step}',
      fastStepPlus: '+ {step}',
      unitStepMinus: '-1',
      unitStepPlus: '+1',
      createNewOrder: '建立新订单',
      cancel: '取消',
      addToCart: '加入购物车',
    },
    productList: {
      recommendAdded: '已加入推荐价格表（Order App）：{name}',
      recommendFailed: '加入推荐失败',
      recommendNeedCustomer: '请先在菜单选择客户身份',
      addRecommendAria: '加入推荐价格表',
      backToRecommended: '返回推荐商品',
    },
    categories: {
      itemsCount: '{count} 项商品',
      featuredBtn: '推荐商品',
    },
    cartDocs: {
      section: '购物车单据 ({count})',
      notSubmitted: '未提交',
      empty: '尚未建立购物车单据',
      submitAll: '全部提交',
      submitting: '提交中...',
      toastSubmitted: '已提交 {count} 张订单',
      toastNothing: '没有可提交的购物车',
      toastFail: '提交失败，请重试',
    },
    cartDetail: {
      orderSubmitted: '订单已提交',
      submitFail: '提交失败',
      notFound: '找不到购物车单据',
      orderNo: '订单编号',
      total: '合计',
      deliveryDate: '送货日期',
      poNo: '采购单号',
      remark: '备注',
      address: '地址',
      addressPlaceholder: '送货地址（可填多行）',
      errorTitle: '无法提交',
      errorOk: '确定',
      updated: '已更新',
      update: '更新',
      submit: '提交',
      submitting: '提交中...',
      deleteOrder: '删除订单',
      confirmRemoveItemTitle: '移除此项目？',
      confirmRemoveItemMsg: '是否要将此商品从购物车中移除？',
      confirmDeleteOrderTitle: '将会删除整张订单',
      confirmDeleteOrderMsg: '这是订单中最后一项商品，移除后整张订单将会删除。是否继续？',
      confirmDeleteOrderBtnTitle: '确定删除订单？',
      confirmDeleteOrderBtnMsg: '此订单将会被删除，且无法复原。',
      confirmLeaveTitle: '尚未保存更改',
      confirmLeaveMsg: '您刚才的修改尚未点「更新」保存，离开将会丢失。是否仍要离开？',
      confirmYes: '确定',
      confirmNo: '取消',
      confirmLeave: '离开',
      confirmStay: '继续编辑',
      confirmRemove: '移除',
      confirmDelete: '删除',
      confirmKeep: '保留',
    },
    orders: {
      tabAll: '全部',
      tabSubmitted: '已提交',
      tabProcessing: '处理中',
      statusPending: '待确认',
      statusSubmitted: '已提交',
      statusProcessing: '处理中',
      statusCompleted: '已完成',
      statusCancelled: '已取消',
    },
    orderDetail: {
      orderUpdated: '订单已更新',
      updateFailed: '更新失败',
      orderSubmitted: '订单已提交',
      submitFailed: '提交失败',
      orderDeleted: '订单已删除',
      deleteFailed: '删除失败',
      loading: '加载中...',
      notFound: '找不到订单',
      orderInfo: '订单信息',
      orderNo: '订单编号',
      status: '状态',
      orderDate: '提交时间',
      deliveryDate: '交货日期',
      customerNo: '客户编号',
      poNo: 'PO 号码',
      poPlaceholder: '输入 PO 号码',
      remark: '备注',
      remarkPlaceholder: '输入备注',
      address: '地址',
      addressPlaceholder: '输入地址',
      orderLines: '订单明细',
      lineSubtotal: '小计',
      deleteLineAria: '删除品项',
      total: '合计',
      processing: '处理中...',
      updateOrder: '更新订单',
      submitOrder: '提交订单',
      deleteOrder: '删除订单',
      confirmDelete: '确认删除',
      confirmDeleteMsg: '确定要删除此订单吗？此操作无法恢复。',
      cancel: '取消',
      confirmDeleteBtn: '确认删除',
      titleWithNo: '订单 {orderNo}',
      lineSubtotalFmt: '小计: {amount}',
      errorTitle: '无法操作',
      errorOk: '确定',
    },
    account: {
      basicInfo: '基本资料',
      customerNo: '客户编号',
      name1: '名称',
      name2: '分店名称',
      displayName: '显示名称（当前语言）',
      nameEn: '英文名称',
      nameCn: '繁体名称',
      nameSc: '简体名称',
      deliveryAddress: '送货地址',
      addressEn: '英文地址',
      addressCn: '中文地址',
      salesman: '业务员',
      deliveryDays: '送货日',
      holiday: '假日',
      loadFailed: '无法载入账户信息',
      sectionDelivery: '送货地址',
      sectionSales: '业务员',
      sectionDeliveryDays: '送货日',
      weekdays: {
        Mon: '一', Tue: '二', Wed: '三', Thu: '四', Fri: '五', Sat: '六', Sun: '日',
      },
    },
    legacyCart: {
      cartItems: '购物车商品 ({count})',
      pendingOrders: '待确认订单 ({count})',
      pendingConfirm: '待确认',
      subtotal: '小计',
      empty: '购物车是空的',
      submitAll: '提交所有订单',
      submitting: '提交中...',
      toastNoCustomer: '无法取得客户资料，请联系管理员',
      toastNoLink: '未设置关联客户，请联系管理员',
      toastCreateFail: '建立订单失败',
      toastSuccess: '订单已提交成功！',
      toastFail: '提交失败，请重试',
    },
  },
  
  // 菜单项目
  menu: {
    dashboard: '仪表板',
    application: '应用',
    publishedApps: '已发布应用',
    pendingTasks: '运行中的表单',
    studio: '工作室',
    unsigned: '已送货未签收',
    customerSigned: '客户已签收',
    signedPending: '已签收待确认',
    logout: '登出',
    dashboardRecentActivity: '最近活动',
    whatsappWorkflow: '工作流程设计',
    companyUserAdmin: '公司/用户管理',
    eformList: '表单管理',
    whatsappTemplates: '消息模板',
    workflowMonitor: '运行中的应用',
    runningApps: '运行中的应用',
    chatBotInbox: 'ChatBot 对话',
    calendar: '日历',
    documentLibrary: '文档中心',
    phoneVerificationAdmin: '电话号码验证',
    permissionManagement: '权限管理',
    apiProviders: 'API 管理',
    commerce: '商务管理',
    commerceCustomers: '客户主档',
    commercePriceCards: '价格表',
    commerceSalesOrders: '销售订单',
    commerceCollections: '商品集合',
    commerceProducts: '商品列表',
    commerceWpaHomePromotions: 'PWA 首页广告',
    commerceImport: '数据交换',
    commerceImportSchedule: '导入排程',
    commerceCatalogAdmin: '目录管理',
    commerceWpaPermissions: 'PWA 权限管理',
    reports: '报表',
    dailyReports: '每日报表',
    monthlyReports: '每月报表',
    realtimeReports: '实时报表',
    appsMediaReports: '应用媒体报表',
    eformInstanceReports: '表单实例报表',
    eformPivotReports: '表单枢纽分析',
    commerceReports: '商务管理报表',
    reportsBillingSystem: '全系统用量计费',
    usageBillingSettings: '用量计费单价',
    aiEmployeeProfiles: 'AI 员工档案',
    dataSets: '数据集管理',
    workflowPackage: 'CUI 应用套件',
    knowledgeBase: '知识库',
    reportTemplates: '报表范本库',
    templateReport: '范本报表',
  },

  workflowPackage: {
    title: 'CUI 应用套件',
    cuiDefinition: 'CUI 为 Conversational User Interface（对话式用户界面）的缩写，指以自然语言对话互动为核心的应用。',
    subtitle: '在此导出或导入流程及其依赖（表单、数据集、模板、AI 员工、Studio 知识库文件等）。',
    tabExport: '导出',
    tabImport: '导入',
    stepSelectWorkflow: '选择流程',
    stepReviewDeps: '检视依赖',
    stepBuilding: '生成 ZIP',
    stepDownload: '下载',
    stepUpload: '上传套件',
    stepPreview: '预览',
    stepImporting: '导入中',
    stepDone: '完成',
    selectWorkflow: '选择要导出的流程',
    selectWorkflowFirst: '请先选择流程',
    prev: '上一步',
    dropdownColName: '流程名称',
    dropdownColCompany: '公司',
    dropdownColStatus: '发布状态',
    dropdownColUpdated: '更新',
    exportAiStaff: '一并导出',
    next: '下一步：扫描依赖',
    previewLoaded: '已加载依赖列表',
    colKind: '类型',
    kindEform: '表单',
    kindDataset: '数据集',
    kindTemplate: '模板',
    kindMetaTemplate: 'Meta 模板',
    kindAiStaff: 'AI 员工',
    kindKnowledgeDoc: '知识库文件',
    kindWorkflow: '流程',
    colName: '名称',
    colInclude: '包含',
    included: '已包含',
    excluded: '已排除',
    startExportZip: '开始生成 ZIP',
    downloadZip: '下载 ZIP',
    selectZip: '选择 .zip 套件',
    importPreviewOk: '已解析套件预览',
    metaNotice: '此套件含 Meta 相关资源；导入后请在 WhatsApp／表单设置完成 WABA 同步并必要时填写 Meta 对照。',
    renameFrom: '原名',
    renameTo: '导入为',
    confirmImport: '确认导入',
    importDone: '导入完成',
    metaWarningsTitle: 'Meta 模板导入注意事项',
    exportMetaWarningsTitle: 'Meta 模板导出注意事项',
    exportAgain: '再次导出',
    importAgain: '再次导入',
    goImport: '前往导入',
    goExport: '前往导出',
  },

  knowledgeBase: {
    title: 'Studio 知识库',
    subtitle: '上传 Office／PDF 等文件，自动转为可供 AI 使用的文字与预览图，并支持版本与发布。',
    viewTile: '大图标',
    viewList: '列表',
    filterCategory: '分类',
    allCategories: '全部分类',
    searchPlaceholder: '搜索标题或正文关键词',
    search: '搜索',
    uploadNew: '上传新文件',
    uploadSelectCategory: '选择分类（选填）',
    newCategory: '新增分类',
    uploadOk: '上传成功，正在处理…',
    versionAdded: '已新增版本',
    publishOk: '已设为发布版本',
    deleteVersionOk: '已删除版本',
    deleteDocumentOk: '已删除文件（从列表移除）',
    deleteDocument: '删除整份文件',
    confirmDeleteDocument: '确定删除整份文件？将从知识库列表隐藏；各版本记录仍保留于系统以供审计。',
    publish: '发布',
    delete: '删除',
    confirmDeleteVersion: '确定删除此版本？若为发布版本将一并取消发布。',
    empty: '尚无文件',
    noPreview: '无预览',
    published: '已发布',
    draft: '未发布',
    detailTitle: '文件详情',
    addVersion: '上传新版本',
    metaPublished: '当前发布版本',
    none: '无',
    categoryCreated: '已建立分类',
    categoryName: '分类名称',
    parentCategory: '上层分类（选填）',
    sortOrder: '排序',
    colVersion: '版号',
    colFileName: '文件名',
    colStatus: '状态',
    colIndexStatus: '向量索引',
    colChunks: 'Chunks',
    indexNone: '未索引',
    reindex: '重建索引',
    reindexQueued: '已加入向量索引队列',
    ragWorkflowHint: '「向量检索 (RAG)」在流程设计器节点的「使用知识库」设置中启用：先开启总开关、选取本文件，即可看到 RAG 开关。本页「重建索引」仅负责建立向量索引。',
    ragXaiHint: '已启用 xAI Collections 托管 RAG。请先为分类建立 Collection（左侧分类树），再「发布」版本即可同步至 xAI，Chatbot 将自动搜索已同步内容。',
    xaiNotSyncedHint: '尚未同步至 xAI Collection，请确认分类已建立 Collection 后重新发布版本。',
    colCreated: '创建时间',
    colActions: '操作',
    colDocumentActions: '文件',
    colTitle: '标题',
    colPublished: '已发布',
    colUpdated: '更新',
    yes: '是',
    no: '否',
    prev: '上一页',
    next: '下一页',
    download: '下载',
    downloadLatest: '下载最新版本',
    downloadAllVersionsZip: '下载全部版本（ZIP）',
    downloadNoVersions: '尚无版本可下载',
    colXaiSync: 'xAI 同步',
    xaiSynced: '已同步',
    xaiNotSynced: '未同步',
    xaiCategoryCollections: 'xAI Collections（各分类）',
    xaiCollectionStatus: 'xAI Collection 状态',
    xaiCollectionReady: '已创建',
    xaiCollectionNotCreated: '未创建',
    xaiCollectionCreate: '创建 Collection',
    xaiCollectionRemove: '移除 Collection',
    xaiCollectionConfirmRemove: '确定要移除 xAI Collection 吗？此操作将删除 xAI 上的所有已上传文件，无法还原。',
    xaiCollectionCreated: 'xAI Collection 创建成功',
    xaiCollectionRemoved: 'xAI Collection 已移除',
    xaiCollectionNoMgmtKey: '请由 Tenant Admin 在「API 供应商」页面设定 xAI Management API Key',
    allCategories: '全部文件',
    noCategoryYet: '暂无分类',
    noCategorySet: '未设定分类',
    categoryLabel: '分类',
    moveCategoryOk: '分类已更新',
    deleteCategory: '删除分类',
    categoryDeleted: '分类已删除',
    confirmDeleteCategory: '确定删除此分类？（分类下不可有文件或子分类）',
    catDeleteBlockedXai: '此分类仍连接 xAI Collection，请先点击「移除 Collection」再删除分类',
    catDeleteBlockedDocs: '分类下仍有文件，请先移动或删除所有文件',
    catDeleteBlockedChildren: '请先删除子分类',
  },

  reportTemplates: {
    title: '报表范本库',
    subtitle: '管理 Word / Excel / PowerPoint 范本，设定 Placeholder 与流程变量绑定',
    refresh: '刷新',
    uploadTemplate: '上传范本',
    categories: '分类',
    all: '全部',
    uncategorized: '未分类',
    searchPlaceholder: '搜索名称 / 描述 / 分类…',
    searchResultCount: '共 {count} 笔结果',
    selectedCount: '已选取 {count} 个范本',
    batchDelete: '批量删除',
    batchDownload: '批量下载',
    clearSelection: '取消选取',
    colName: '名称',
    colFormat: '格式',
    colCategory: '分类',
    colPlaceholder: 'Placeholder',
    colUploadDate: '上传日期',
    colActions: '操作',
    textCount: '{count} 文字',
    photoCount: '{count} 相片',
    viewPlaceholder: '查看 Placeholder',
    download: '下载范本',
    edit: '编辑',
    delete: '删除',
    cancel: '取消',
    save: '保存',
    close: '关闭',
    confirmDeleteOne: '确定删除此范本？',
    confirmBatchDelete: '确定删除已选取的 {count} 个范本？',
    emptyInCategory: '此分类尚无范本。',
    loadFailed: '加载范本库失败：',
    loadDetailFailed: '加载详情失败：',
    deleteSuccess: '已删除范本',
    deleteFailed: '删除失败：',
    batchDeleteSuccess: '已删除 {count} 个范本',
    batchDeleteFailed: '批量删除失败：',
    downloadFailed: '下载失败：',
    batchDownloadSuccess: '已完成下载 {done} 个范本',
    batchDownloadFailed: '批量下载部分失败：{error} 个错误',
    updateSuccess: '已更新',
    updateFailed: '更新失败：',
    batchCategoryLabel: '分类（全部文件套用）',
    categoryPlaceholder: '输入或选择分类（选填）',
    dragHint: '拖曳或点击选择 .docx / .xlsx / .pptx / .zip 文件',
    dragSubHint: '支持一次选取多个文件；ZIP 文件将自动解压，以原始文件名作为范本名称',
    uploadComplete: '上传完成：{done} 成功 / {error} 失败',
    fileCount: '{count} 个文件',
    pendingUpload: '{count} 个待上传',
    uploading: '上传中…',
    completed: '已完成',
    uploadingProgress: '上传中… ({done}/{total})',
    uploadAll: '上传全部 ({count} 个)',
    photoSlotCount: '{count} 相片位',
    placeholderFormatHint: 'Placeholder 格式：',
    placeholderFormatExamples: '{{PV:xxx}} / {{EFORM:表单.字段}} / {{SYS:DATE}} / {{PHOTO:槽位|cols=5}}',
    detailTitle: '范本详情',
    detailTitleWithName: '{name} — Placeholder',
    editTitle: '编辑范本信息',
    nameRequired: '请输入名称',
    description: '说明',
    bindingsSaved: '变量绑定已保存',
    saveFailed: '保存失败：',
    textPlaceholders: '文字 Placeholder',
    saveBindings: '保存绑定',
    location: '位置：{location}',
    displayLabelPlaceholder: '显示标签（选填）',
    photoSlots: '相片插入位置',
    noPlaceholdersDetected: '此范本未检测到任何 Placeholder。请确认范本中有使用 {{TYPE:key}} 格式。',
  },

  usageBilling: {
    title: '用量计费',
    joinDate: '计费周期起点（加入日）',
    period: '计费期间',
    workflowExecution: '流程执行',
    metaOutbound: 'Meta 对外',
    aiCall: 'AI 调用',
    rates: '单价',
    totalAmount: '小计',
    loadFailed: '无法载入用量',
    noPermission: '无权查看此报表',
    systemReportTitle: '全系统用量计费',
    settingsTitle: '用量计费单价设定',
    selectCompany: '选择公司',
    currency: '币别',
    metaTemplatePrice: 'Meta 对外（每条）',
    aiCallPrice: 'AI（每次）',
    workflowExecPrice: '流程执行（每次）',
    saveSuccess: '已保存',
    saveFailed: '保存失败',
    loadCompaniesFailed: '无法载入公司列表',
    loadSettingsFailed: '无法载入计价设定',
  },

  commerceDeliveryRules: {
    hint: '特殊送货日以列表为准；未列日期则依每周截单秒数。公司时区请于公司资料设定（IANA timezone）。PWA 下单时会依公司时区与上表验证截单。',
    companyFilter: '公司',
    tabCalendar: '特殊送货日／截单',
    tabWeekly: '每周截单（秒）',
    addWeekday: '新增星期',
    colDeliveryDate: '送货日',
    colDeliveryWeekday: '星期',
    yearFilter: '送货日年份',
    yearFilterAll: '全部年份',
    colHoliday: '假日',
    colCutoff: '截单日时',
    colWeekday: '星期',
    descriptionEn: '英文说明',
    descriptionZh: '中文说明',
    noPermission: '无权限',
    loadFailed: '载入失败',
    saved: '已保存',
    deleted: '已删除',
    orderCutoffDate: '截单日',
    orderCutoffTime: '截单时间',
    editWeek: '编辑周截单',
    addWeekdayTitle: '新增星期截单',
    cutoffOffsetSeconds: '截单偏移（秒）',
    weekdayField: '星期（0=周日～6=周六）',
    weekdaySelectPlaceholder: '0=周日 … 6=周六',
    deleteCalendarConfirm: '确定删除此特殊送货日？',
  },

  aiEmployeeProfiles: {
    title: 'AI 员工档案',
    loadFailed: '加载失败',
    searchPlaceholder: '搜索姓名、编号、部门',
    viewList: '列表',
    viewTile: '图块',
    create: '新增',
    createTitle: '新增 AI 员工',
    editTitle: '编辑 AI 员工',
    employeeNumber: '员工编号',
    employeeNumberAuto: '员工编号将在创建后自动生成',
    avatar: '头像',
    gender: '性别',
    genderMale: '男',
    genderFemale: '女',
    genderOther: '其他',
    displayName: '姓名',
    nameRequired: '请输入姓名',
    department: '部门',
    jobTitle: '职位',
    jobDescription: '职务说明',
    responsibilities: '职责（技能拟人化）',
    responsibilitiesHint: '输入后按 Enter 或逗号新增',
    birthDate: '生日',
    age: '年龄',
    birthplace: '出生地',
    industry: '行业',
    background: '背景',
    workExperience: '工作经验',
    professionalSkills: '专业能力',
    personality: '性格',
    tabWork: '职务与头像',
    tabPersonal: '个人资料',
    tabMemory: '我的回忆',
    memoryLabel: '回忆／日志（Markdown）',
    memoryHelp:
      '此栏会累积此 AI 员工的互动脉络：包含流程中 wait 验证、eForm 填表、HTML／Office 产生等每次成功 AI 调用的输入／输出摘要，以及扩写、生成头像等操作。内容会在下次组装角色 prompt 时一并带入，亦可手动编修。',
    memoryPlaceholder: '尚无记录。流程与 AI 填表成功后会自动附加摘要；扩写或生成头像亦会写入；您也可自行贴上备注。',
    memoryWizardHint: '创建完成后，可在编辑模式的「我的回忆」分页查看与维护互动日志。',
    loadDetailPartial: '无法载入完整明细，已显示列表数据（回忆可能未同步）。',
    createdAt: '创建时间',
    actions: '操作',
    save: '保存',
    saved: '已保存',
    created: '已创建',
    deleted: '已删除',
    confirmDelete: '确定删除此员工档案？',
    randomAvatar: 'AI 生成头像',
    avatarProvider: '头像用 AI Provider',
    expandProvider: '扩写用 Provider',
    selectAiProvider: '请先选择 AI Provider',
    avatarOk: '头像已更新',
    aiModalTitle: 'AI 按字段扩写',
    aiHintPlaceholder: '简短说明期望（可留空）',
    aiApplied: '已套用 AI 内容',
    prev: '上一步',
    next: '下一步',
    submitCreate: '创建',
    wizardStepOrg: '部门与职位',
    wizardStepProfile: '理想同事',
    wizardStepBio: '背景与特质',
    wizardStepRole: '职务内容',
    wizardReviewHint: '确认无误后点击「创建」。',
    lookupLabels: {
      departments: {
        客服部: '客服部',
        營運部: '营运部',
        資訊部: '资讯部',
        人資部: '人资部',
        財務部: '财务部',
        行銷部: '行销部',
        業務部: '业务部',
        產品部: '产品部',
        研發部: '研发部',
        法務部: '法务部',
        總經理室: '总经理室'
      },
      jobTitles: {
        專員: '专员',
        資深專員: '资深专员',
        主任: '主任',
        副理: '副理',
        經理: '经理',
        副總經理: '副总经理',
        顧問: '顾问',
        實習生: '实习生',
        助理: '助理',
        組長: '组长',
        課長: '课长',
        總監: '总监'
      },
      birthplaces: {
        香港: '香港',
        台北: '台北',
        新北: '新北',
        桃園: '桃园',
        台中: '台中',
        台南: '台南',
        高雄: '高雄',
        新加坡: '新加坡',
        上海: '上海',
        北京: '北京',
        深圳: '深圳',
        廣州: '广州',
        東京: '东京',
        首爾: '首尔',
        吉隆坡: '吉隆坡',
        倫敦: '伦敦',
        雪梨: '悉尼'
      },
      industries: {
        金融服務: '金融服务',
        保險: '保险',
        地產與物業: '地产与物业',
        建築與工程: '建筑与工程',
        物流與運輸: '物流与运输',
        零售與批發: '零售与批发',
        餐飲與酒店: '餐饮与酒店',
        科技與資訊: '科技与资讯',
        電訊: '电讯',
        專業服務: '专业服务',
        醫療與健康: '医疗与健康',
        教育與培訓: '教育与培训',
        政府與公共機構: '政府与公共机构',
        傳媒與廣告: '传媒与广告',
        製造業: '制造业',
        能源與公用事業: '能源与公用事业',
        非牟利與社福: '非营利与社福',
        航空與旅遊: '航空与旅游',
        其他: '其他'
      }
    }
  },

  // Dashboard 仪表板
  dashboard: {
    applicationTitle: '应用',
    applicationDescription: '已发布的工作流程应用，可直接启动使用',
    studioTitle: '工作室',
    studioDescription: '管理和设计工具，打造您的专属工作流程',
    adminToolsTitle: '管理工具',
    adminToolsDescription: '系统管理和用户管理工具',
    contactManagement: '联系人管理',
    contactManagementDescription: '管理 WhatsApp 联系人资料',
    broadcastGroups: '广播群组',
    broadcastGroupsDescription: '管理广播群组和成员',
    hashtagManagement: '标签管理',
    hashtagManagementDescription: '管理系统标签和分类',
    companyUserManagement: '公司/用户管理',
    companyUserManagementDescription: '管理公司账户和用户权限',
    totalContacts: '总联系人',
    totalGroups: '总群组',
    totalMembers: '总成员',
    totalHashtags: '总标签',
    hashtagUsage: '使用次数',
    totalUsers: '总用户',
    admins: '管理员',
    totalCompanies: '总公司',
    publishedApps: '已发布应用',
    publishedAppsDescription: '可用的工作流程应用',
    runningApps: '运行中的应用',
    runningAppsDescription: '当前正在执行的流程实例',
    pendingTasks: '待处理事项',
    pendingTasksDescription: '需要您处理的审批和回复',
    formManagement: '表单管理',
    formManagementDescription: '电子表单设计与管理',
    messageTemplates: '消息模板',
    messageTemplatesDescription: 'WhatsApp 消息模板管理',
    workflowDesign: '工作流程设计',
    workflowDesignDescription: '设计和配置工作流程',
    datasetManagement: '数据集管理',
    datasetManagementDescription: '数据源和数据集管理',
    aiEmployeeProfiles: 'AI 员工档案',
    aiEmployeeProfilesDescription: '虚拟 AI 同事人事档与头像',
    userManagement: '用户管理',
    userManagementDescription: '公司用户和权限管理',
    systemMonitoring: '系统监控',
    systemMonitoringDescription: '流程执行监控和分析',
    workflowMonitor: '运行中的应用',
    workflowMonitorDescription: '工作流程执行监控和分析',
    totalCount: '总数',
    recentlyAdded: '最近新增',
    loading: '加载中...',
    loadingDashboard: '加载仪表板中...',
    active: '活跃',
    draft: '草稿',
    disabled: '停用',
    running: '运行中',
    completed: '已完成',
    failed: '失败',
    pendingApproval: '待审批',
    processed: '已处理',
    today: '今日',
    enabled: '启用',
    inactive: '停用',
    published: '已发布',
    test: '测试',
    totalDatasets: '总数据集',
    error: '错误',
    totalUsers: '总用户',
    online: '在线',
    admin: '管理员',
    successRate: '成功率',
    averageTime: '平均时间',
    minutes: '分',
    // 数据分析相关
    dataAnalysis: '数据分析',
    dataAnalysisDescription: '系统运行数据即时概览',
    messageTrend: '消息趋势',
    hotWorkflows: '热门流程',
    formStatus: '表单状态',
    systemHealth: '系统健康',
    messageSuccessRate: '消息成功率',
    workflowSuccessRate: '流程成功率',
    avgExecutionTime: '平均执行时间',
    pendingTasksCount: '待处理任务',
    seconds: '秒',
    past7Days: '过去 7 天',
    executionCount: '执行次数',
    pending: '待处理',
    approved: '已批准',
    rejected: '已拒绝'
  },

  // 待处理事项页面
  pendingTasks: {
    // 展开行双区块（Form 字段 / 流程变量）
    expandedSection: {
      formFields: 'Form 字段',
      processVariables: '流程变量 (PV)'
    },
    title: '待处理事项',
    description: '处理等待决策的表单申请',
    totalPending: '总待处理',
    pendingApproval: '待审批',
    overdueItems: '逾期项目',
    urgentItems: '紧急项目',
    formName: '表单名称',
    processInstanceId: '流程实例 ID',
    status: '状态',
    fillType: '填写类型',
    priority: '优先级',
    applicant: '申请人',
    applicationTime: '申请时间',
    dueDate: '截止时间',
    action: '操作',
    approve: '批准',
    reject: '拒绝',
    approveTooltip: '批准',
    rejectTooltip: '拒绝',
    submitForm: '提交表单',
    submitFormTooltip: '提交表单',
    submitFormMessage: '表单提交功能开发中...',
    formOpenedForSubmission: '表单已在新标签页中打开，请填写并提交',
    resubmitForm: '重新提交',
    searchPlaceholder: '搜索表单名称、申请人...',
    priorityPlaceholder: '优先级',
    all: '全部',
    high: '高',
    medium: '中',
    low: '低',
    manualFill: '手动填写',
    aiFill: 'AI 填写',
    dataFill: '数据填写',
    aiDataFill: 'AI/数据填写',
    inhouseForm: 'In-house Form',
    inhouseFormDescription: '认证电话号码或登录操作<br/>例如：内部系统运作',
    publicForm: 'Public Form',
    publicFormDescription: '一般电话号码，不需登录操作<br/>例如：推广、意见收集',
    manualPendingForms: '待回应表单',
    manualRespondedForms: '已收到回应表单',
    noManualPendingForms: '暂无待回应的手动填写表单',
    noManualRespondedForms: '暂无已收到回应的手动填写表单',
    overdue: '逾期',
    pending: '待处理',
    approved: '已批准',
    rejected: '已拒绝',
    submitted: '已提交',
    changeToApproved: '更改为已批准',
    changeToRejected: '更改为已拒绝',
    statusChangeConfirmation: '状态更改确认',
    statusChangeWarning: '状态更改警告',
    currentStatus: '当前状态',
    decidedBy: '决定人',
    decidedAt: '决定时间',
    changeTo: '更改为',
    confirmStatusChange: '确认更改',
    confirmStatusChangeQuestion: '您确定要更改此表单的状态吗？',
    noPendingTasks: '暂无待处理事项',
    approveApplication: '批准申请',
    rejectApplication: '拒绝申请',
    confirmApprove: '确认批准',
    confirmReject: '确认拒绝',
    cancel: '取消',
    confirmApproval: '确认批准',
    confirmRejection: '确认拒绝',
    applicantLabel: '申请人：',
    applicationTimeLabel: '申请时间：',
    approvalNote: '批准备注',
    approvalNotePlaceholder: '请输入批准备注（可选）',
    rejectionReason: '拒绝原因',
    rejectionReasonPlaceholder: '请输入拒绝原因（必填）',
    rejectionReasonRequired: '请输入拒绝原因',
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    approveSuccess: '批准成功',
    rejectSuccess: '拒绝成功',
    approveFailed: '批准失败',
    rejectFailed: '拒绝失败',
    save: '保存',
    saveSuccess: '表单内容已保存',
    saveFailed: '保存失敗',
    loadPendingTasksFailed: '加载待处理事项失败',
    loadStatisticsFailed: '加载统计数据失败',
    refresh: '刷新',
    clearFilters: '清空',
    exportExcel: '导出 Excel',
    exportDisabledTip: '请先在下拉菜单选择一种表单定义（Process Definition），才能导出 Excel',
    noDataToExport: '没有可导出的数据',
    exportSuccess: '导出成功',
    exportFailed: '导出失败',
    definitionPlaceholder: '选择表单定义',
    workflowInstanceId: '工作流实例 ID',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    approvalAt: '批准时间',
    pendingTasksList: '待处理表单',
    pendingForms: '待处理表单',
    approvedForms: '已批准表单',
    rejectedForms: '已拒绝表单',
    approvedBy: '已批准',
    rejectedBy: '已拒绝',
    noApprovedForms: '没有已批准的表单',
    noRejectedForms: '没有已拒绝的表单',
    pageRange: '第 {start}-{end} 项，共 {total} 项',
    itemsPerPage: '条/页',
    jumpTo: '跳至',
    page: '页',
    confirm: '确定',
    loading: '加载中...',
    error: '错误',
    success: '成功',
    viewFormInstance: '查看表单实例',
    loadingFormInstance: '加载表单实例中...',
    close: '关闭',
    openInNewTab: '在新标签页中打开',
    noFormData: '无表单数据',
    userMessage: '用户消息',
    
    // 批量处理相关翻译
    select: '选择',
    selectAll: '全选',
    deselectAll: '取消全选',
    selectedItems: '已选择 {count} 项',
    clearSelection: '清除选择',
    batchApprove: '批量批准',
    batchReject: '批量拒绝',
    batchChangeToApproved: '批量改为批准',
    batchChangeToRejected: '批量改为拒绝',
    batchOperationConfirmation: '批量操作确认',
    batchOperationType: '操作类型',
    selectedFormsCount: '选择的表单数量',
    formsList: '表单列表',
    confirmBatchOperation: '确认执行此批量操作吗？',
    operationNote: '操作备注',
    operationNotePlaceholder: '请输入操作原因...',
    confirmExecute: '确认执行',
    batchOperationSuccess: '批量操作成功',
    batchOperationFailed: '批量操作失败',
    batchApprovalSuccess: '成功批准 {count} 个表单',
    batchRejectionSuccess: '成功拒绝 {count} 个表单',
    batchStatusChangeSuccess: '成功更改 {count} 个表单状态'
  },
  
  // 未签收管理
  unsigned: {
    title: '已送货未签收',
    totalRecords: '总记录数',
    totalProcessed: '总处理量',
    currentPageRecords: '当前页记录数',
    search: '搜索',
    searchPlaceholder: '搜索发票号、客户名称、电话...',
    filterAll: '全部',
    filterUnconfirmed: '未确定',
    filterConfirmed: '已确定',
    confirm: '确认',
    confirmSelected: '确认选中',
    confirmSuccess: '确认成功',
    confirmFailed: '确认失败',
    downloadPdf: '下载 PDF',
    previewImage: '预览图片',
    customerTel: '客户电话',
    invoiceNo: '发票号',
    customerNo: '客户编号',
    customerName: '客户名称',
    orderLines: '订单明细',
    noData: '暂无数据',
    loading: '加载中...',
    pageSize: '每页笔数',
    receiptDate: '收据日期',
    uploadDate: '上传日期',
    remarks: '备注',
    status: '状态',
    confirmed: '已确认',
    unconfirmed: '未确认',
    action: '操作',
    customerSignedPending: '已签收待确认',
    customerSignedConfirmed: '已确认',
    manualReview: '人工复核',
  },
  
  // Workflow
  workflow: {
    title: '流程管理',
    add: '新增流程',
    name: '流程名称',
    createdBy: '建立人',
    createdAt: '建立日期',
    updatedAt: '最后修改',
    status: '状态',
    action: '操作',
    design: '设计',
    copy: '复制',
    delete: '删除',
    confirmDeleteTitle: '确定要删除此流程吗？',
    confirmDeleteContent: '流程名称：{name}',
    confirmDeleteOk: '删除',
    confirmDeleteCancel: '取消',
    copySuccess: '已复制流程',
    deleteSuccess: '已删除流程',
    deleteFailed: '删除失败',
    copyFailed: '复制失败',
    save: '保存流程',
    saveSuccess: '流程已保存！',
    saveFailed: '保存失败',
    nameRequired: '请输入流程名称',
    mustHaveStartEnd: '流程必须包含 Start 和 End 节点',
    mustHaveEdge: '请建立节点连线',
    description: '描述（可选）',
    back: '返回列表',
    new: '新增流程',
    edit: '编辑流程',
    searchPlaceholder: '搜索流程名称、建立人...',
    search: '搜索',
    nodeTypes: '节点类型',
    to: '收件人',
    message: '消息内容',
    timeout: '超时时间',
    sql: 'SQL 查询',
    apiUrl: 'API 网址',
    formName: '表单名称',
    result: '结果',
    approved: '已核准',
    rejected: '已拒绝',
    deleteEdge: '删除连线',
    startNodeCannotEdit: 'Start 节点无法编辑'
  },
  
  // 通用
  common: {
    loading: '加载中...',
    error: '错误',
    success: '成功',
    cancel: '取消',
    confirm: '确认',
    save: '保存',
    delete: '删除',
    edit: '编辑',
    add: '添加',
    search: '搜索',
    configure: '设置',
    configured: '已配置',
    notConfigured: '未配置',
    all: '全部',
    action: '操作',
    refresh: '刷新',
    clear: '清除',
    submit: '提交',
    back: '返回',
    next: '下一步',
    previous: '上一步',
    close: '关闭',
    open: '打开',
    on: '开',
    off: '关',
    yes: '是',
    no: '否',
    ok: '确定',
    required: '必填',
    minLength: '至少 {min} 码',
    pageRange: '第 {start}-{end} 项，共 {total} 项',
    status: '状态',
    actions: '操作',
    every: '每',
    minutes: '分钟',
    active: '启用',
    inactive: '停用',
    paused: '已暂停',
    activate: '启用',
    deactivate: '停用',
    systemDefault: '系统默认',
    editingCompany: '编辑公司',
    unauthorized: '未授权',
    reset: '重置',
    createdAt: '创建时间',
    createdDate: '创建日期',
    createdBy: '创建人',
    updatedAt: '更新时间',
    updatedDate: '更新日期',
    updatedBy: '更新人',
    recipientName: '收件人姓名',
    recipientWhatsApp: '收件人 WhatsApp',
    userMessage: '用户消息'
  },

  // 收件人选择器
  recipientSelector: {
    title: '选择收件人',
    placeholder: '选择收件人',
    clearAll: '清除全部',
    confirmSelection: '确认选择',
    clear: '清除',
    
    // Tabs
    users: '用户',
    contacts: '联系人',
    processVariables: '流程变量',
    initiators: '流程启动人',
    
    // Search placeholders
    searchUsers: '搜索用户...',
    searchContacts: '搜索联系人...',
    
    // Selected recipients display
    selectedRecipients: '已选收件人',
    usersCount: '{count} 位用户',
    contactsCount: '{count} 个联系人',
    groupsCount: '{count} 个群组',
    hashtagsCount: '{count} 个标签',
    variablesCount: '{count} 个变量',
    processInitiator: '流程启动人',
    
    // Users tab
    usersTab: {
      title: '用户',
      noUsersFound: '找不到用户',
      userPhone: '电话：{phone}',
      userEmail: '邮箱：{email}'
    },
    
    // Contacts tab
    contactsTab: {
      title: '联系人',
      broadcastGroups: '广播群组',
      noGroupsData: '无广播群组资料',
      hashtags: '标签',
      noHashtagsData: '无标签资料',
      contactList: '联系人列表',
      totalContacts: '共 {count} 个联系人',
      noContactsFound: '找不到联系人',
      whatsAppNumber: 'WhatsApp：{number}',
      email: '邮箱：{email}',
      pageRange: '第 {start}-{end} 项，共 {total} 项'
    },
    
    // Process Datas tab
    processVariablesTab: {
      title: '流程变量',
      description: '选择流程变量，系统将在执行时自动替换为实际值（建议选择包含电话号码的变量）',
      noVariablesFound: '找不到流程变量',
      value: '值：{value}',
      dataType: '类型：{type}',
      instructions: {
        title: '使用说明',
        items: [
          '显示所有类型的流程变量',
          '建议选择包含电话号码的变量',
          '选中的变量将以 ${variableName} 格式保存',
          '系统将在工作流执行时自动替换为实际值',
          '适合与外部系统（如 ERP）集成'
        ]
      }
    },
    
    // Process Initiator tab
    initiatorsTab: {
      title: '流程启动人',
      useInitiator: '使用流程启动人',
      description: '勾选后，系统将在执行时自动使用启动此工作流实例的用户作为收件人',
      instructions: {
        title: '使用说明',
        items: [
          '此选项将在工作流执行时自动替换为实际的流程启动人',
          '适合需要向流程启动人发送消息或等待其回复的场景',
          '系统将自动从 workflow_executions 表的 InitiatedBy 字段获取启动人信息'
        ]
      }
    },
    
    // Tags and labels
    tagLabels: {
      user: '用户',
      contact: '联系人',
      group: '群组',
      hashtag: '标签',
      variable: '变量',
      initiator: '流程启动人'
    },
    
    // Fallback texts
    fallbackTexts: {
      unknownGroup: '未知群组',
      unknownTag: '未知标签',
      unknownVariable: '未知变量',
      autoReplace: '运行时自动替换',
      noBroadcastGroupsData: '无广播群组资料',
      noHashtagsData: '无标签资料',
      noUsersData: '无用户资料',
      noContactListsData: '无联系人列表资料'
    }
  },

  // 联系人管理
  contactList: {
    title: '联系人管理',
    management: '联系人管理',
    description: '管理您的联系人列表和广播群组',
    searchPlaceholder: '搜索联系人...',
    allGroups: '所有群组',
    allTags: '所有标签',
    reset: '重置',
    import: '导入',
    addContact: '新增联系人',
    editContact: '编辑联系人',
    deleteContact: '删除联系人',
    batchDelete: '批量删除',
    selectedContacts: '已选择 {count} 个联系人',
    noContactsFound: '找不到联系人',
    noContactsDescription: '请新增联系人或调整搜索条件',
    name: '姓名',
    title: '职称',
    contactInfo: '联系信息',
    company: '公司/部门',
    group: '群组',
    tags: '标签',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    confirmDelete: '确认删除',
    confirmDeleteMessage: '您确定要删除联系人 "{name}" 吗？此操作无法复原。',
    cancel: '取消',
    deleteSuccess: '联系人删除成功',
    deleteError: '删除联系人失败',
    batchDeleteSuccess: '成功删除 {count} 个联系人',
    batchDeleteError: '批量删除联系人失败',
    loadError: '载入联系人列表失败',
    updateSuccess: '联系人已更新',
    createSuccess: '联系人已创建',
    updateError: '更新联系人失败',
    createError: '创建联系人失败',
    // 表单字段
    occupation: '职业',
    position: '职位',
    whatsappNumber: 'WhatsApp 号码',
    email: '电子邮件',
    companyName: '公司名称',
    department: '部门',
    broadcastGroup: '广播群组',
    hashtags: '标签',
    // 表单提示
    namePlaceholder: '请输入姓名',
    titlePlaceholder: '请输入职称',
    occupationPlaceholder: '请输入职业',
    positionPlaceholder: '请输入职位',
    whatsappPlaceholder: '请输入 WhatsApp 号码',
    emailPlaceholder: '请输入电子邮件',
    companyPlaceholder: '请输入公司名称',
    departmentPlaceholder: '请输入部门',
    broadcastGroupPlaceholder: '选择广播群组',
    hashtagsPlaceholder: '输入标签，用逗号分隔',
    // 验证消息
    nameRequired: '请输入姓名',
    whatsappNumberRequired: '请输入 WhatsApp 号码',
    broadcastGroupRequired: '请选择广播群组',
    formValidationFailed: '表单验证失败，请检查必填字段',
    // 按钮
    back: '返回',
    save: '保存',
    update: '更新',
    create: '创建',
    // 侧边栏
    quickAddTags: '快速添加标签',
    preview: '预览',
    currentTags: '当前标签：',
    tagsLabel: '标签：',
    tabBasic: '基本',
    tabAttachments: '附件',
    contactAvatar: '联系人头像',
    uploadAvatar: '上传头像',
    changeAvatar: '更换头像',
    attachmentHint: '可上传证件、证书等个人文件（PNG、JPG、PDF）',
    saveBeforeUpload: '请先保存联系人，即可上传头像与附件',
    attachmentUpload: '上传附件',
    openFile: '打开',
    removeFile: '移除',
    uploadSuccess: '上传成功',
    uploadError: '上传失败',
    removeSuccess: '已移除',
    removeError: '移除失败',
    imageOnlyHint: '仅支持图片（jpg、png、gif、webp）',
    docTypesHint: '仅支持 PNG、JPG、PDF'
  },

  // 广播群组管理
  broadcastGroups: {
    title: '广播群组管理',
    description: '管理联系人分组，方便分类和广播',
    addGroup: '新增群组',
    editGroup: '编辑群组',
    deleteGroup: '删除群组',
    groupName: '群组名称',
    groupDescription: '群组描述',
    groupColor: '群组颜色',
    contactCount: '联系人数量',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    confirmDelete: '确认删除',
    confirmDeleteMessage: '确定要删除群组「{name}」吗？此操作无法复原。',
    cancel: '取消',
    create: '创建',
    update: '更新',
    createSuccess: '群组已创建',
    updateSuccess: '群组已更新',
    deleteSuccess: '群组已删除',
    createError: '创建群组失败',
    updateError: '更新群组失败',
    deleteError: '删除群组失败',
    loadError: '载入群组列表失败',
    noGroupsFound: '没有找到群组',
    noGroupsDescription: '请新增群组',
    quickSelect: '快速选择：',
    namePlaceholder: '请输入群组名称',
    descriptionPlaceholder: '请输入群组描述',
    nameRequired: '请输入群组名称',
    formValidationFailed: '表单验证失败，请检查必填字段'
  },

  // 联系人导入
  contactImport: {
    title: '联系人导入',
    selectSource: '选择数据源',
    selectSourceDesc: '选择要导入的数据来源',
    mapFields: '字段映射',
    mapFieldsDesc: '将数据字段映射到联系人字段',
    importData: '导入数据',
    importDataDesc: '确认并开始导入',
    
    // 数据源选项
    selectDataSource: '选择数据源',
    excelFile: 'Excel 文件',
    excelFileDesc: '从 Excel 文件导入数据',
    googleSheets: 'Google Sheets',
    sqlDatabase: 'SQL 数据库',
    uploadExcel: '上传 Excel 文件',
    uploadExcelFile: '上传 Excel 文件',
    connectGoogle: '连接 Google Sheets',
    connectSQL: '连接 SQL 数据库',
    supportedFormats: '支持 .xlsx, .xls, .csv 格式',
    googleSheetsDesc: '从 Google Sheets 导入数据',
    sqlDatabaseDesc: '从 SQL 数据库导入数据',
    
    // Excel 配置
    excelConfig: 'Excel 文件配置',
    excelFilePath: 'Excel 文件路径',
    selectSheet: '选择工作表',
    
    // Google Docs 配置
    googleDocsConfig: 'Google Docs 配置',
    googleDocsUrl: 'Google Docs URL',
    
    // SQL 配置
    sqlConfig: 'SQL 连接配置',
    server: '服务器',
    database: '数据库',
    username: '用户名',
    password: '密码',
    tableName: '表名',
    customQuery: '自定义查询',
    testConnection: '测试连接',
    loadData: '加载数据',
    sqlPreviewTotalRows: '符合条件的总笔数：{count}',
    sqlPreviewTopNote: '为加快预览已自动加上 TOP {n}；正式导入会载入全部符合条件的数据。',
    sqlPreviewWithCteNote: '此查询含 WITH/CTE，无法自动加 TOP，预览可能较久。',
    sqlLoadingFullForImport: '正在从 SQL 载入完整数据以执行导入…',
    sqlFullLoadFailed: '无法载入完整 SQL 数据',
    nextStep: '下一步',
    
    // 字段映射
    dataPreview: '数据预览',
    fieldMapping: '字段映射',
    selectColumn: '选择字段',
    selectGroup: '选择群组',
    dataSourceType: '数据源类型',
    sheetName: '工作表名称',
    
    // 导入过程
    importing: '正在导入...',
    importSuccess: '导入成功！',
    successCount: '成功导入 {count} 位联系人',
    failedCount: '失败 {count} 笔',
    errors: '错误详情',
    backToList: '返回联系人列表',
    importMore: '继续导入',
    previous: '上一步',
    startImport: '开始导入',
    
    // 重复确认
    duplicateConfirmation: '重复记录确认',
    duplicateWarning: '发现重复的 WhatsApp 号码',
    duplicateDescription: '以下记录的 WhatsApp 号码已存在于系统中。如果继续，将会覆盖现有记录。请确认是否要更新这些记录。',
    confirmUpdate: '确认更新',
    rowNumber: '行号',
    newData: '新数据',
    existingData: '现有数据',
    
    // 定时导入设定
    saveAsSchedule: '保存为定时导入',
    scheduleNamePlaceholder: '请输入排程名称',
    scheduleNameRequired: '请输入排程名称',
    everyXMinutes: '每 N 分钟',
    daily: '每天',
    weekly: '每周',
    scheduleName: '排程名称',
    manageSchedule: '管理定时导入',
    scheduleManagement: '联系人定时导入排程',
    executionFrequency: '执行频率',
    importType: '导入类型',
    lastExecution: '上次执行',
    nextExecution: '下次执行',
    editSchedule: '编辑排程',
    manualExecute: '手动执行',
    importExecutionProgress: '导入进度',
    confirmDeleteSchedule: '确定要删除这个排程吗？',
    scheduleSaved: '已保存为定时导入排程！',
    scheduleSavedDesc: '您的导入已保存为定时任务。您可以在「管理定时导入」区域中查看和管理。',
    saveScheduleFailed: '保存排程失败',
    pleaseEnterGoogleSheetsUrl: '请先输入 Google Sheets URL',
    detectedExcelFile: '检测到 Excel 文件，将使用默认工作表',
    googleSheetsVerified: 'Google Sheets URL 验证成功！',
    googleSheetsVerificationFailed: 'Google Sheets URL 验证失败：',
    pleaseUploadExcelFile: '请先上传 Excel 文件',
    urlVerified: 'URL 已验证',
    fileUploaded: '文件已上传',
    useDefaultSheet: '系统将自动使用默认工作表进行数据导入，无需选择工作表名称。',
    basicSettings: '基本设定',
    loadingPreview: '载入预览数据中...',
    noPreviewData: '无法载入预览数据，可以手动编辑字段映射',
    pleaseConnectGoogleSheets: '请先连接 Google Sheets',
    getSheetsList: '请先连接 Google Sheets 获取工作表列表',
    noMatchingSheet: '没有找到匹配的工作表',
    scheduleNameExists: '排程名称已存在，请使用其他名称',
    name: '姓名',
    title: '职称',
    occupation: '职业',
    position: '职位',
    whatsappNumber: 'WhatsApp 号码',
    email: '电子邮件',
    companyName: '公司名称',
    department: '部门',
    hashtags: '标签',
    broadcastGroup: '广播群组'
  },

  // 标签管理
  hashtags: {
    title: '标签管理',
    description: '管理联系人标签，方便分类和筛选',
    addTag: '新增标签',
    editTag: '编辑标签',
    deleteTag: '删除标签',
    tagName: '标签名称',
    description: '描述',
    color: '颜色',
    usageCount: '使用次数',
    createdAt: '创建时间',
    updatedAt: '更新时间',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    confirmDelete: '确认删除',
    confirmDeleteMessage: '确定要删除标签「{name}」吗？',
    cannotDeleteMessage: '此标签还有 {count} 位联系人使用，无法删除。',
    cancel: '取消',
    create: '创建',
    update: '更新',
    createSuccess: '标签已创建',
    updateSuccess: '标签已更新',
    deleteSuccess: '标签已删除',
    createError: '创建标签失败',
    updateError: '更新标签失败',
    deleteError: '删除标签失败',
    loadError: '载入标签列表失败',
    noTagsFound: '没有找到标签',
    adjustSearch: '请调整搜索条件',
    searchPlaceholder: '搜索标签...',
    quickSelect: '快速选择：',
    namePlaceholder: '请输入标签名称',
    descriptionPlaceholder: '请输入标签描述',
    nameRequired: '请输入标签名称',
    formValidationFailed: '表单验证失败，请检查必填字段'
  },
  
  // 语言切换
  language: {
    zhTC: '繁體中文',
    zhSC: '简体中文', 
    en: 'English',
    language: '语言'
  },
  
  // 用户偏好设置
  preferences: {
    title: '我的偏好设置',
    basicInfo: '基本资料',
    usageBillingTab: '用量计费',
    avatar: '头像',
    uploadAvatar: '上传头像',
    account: '账号',
    name: '名称',
    email: 'Email',
    phone: '电话',
    language: '语言',
    timezone: '时区',
    password: '密码',
    passwordPlaceholder: '如需修改请输入新密码',
    isActive: '启用',
    isOwner: '主账号',
    save: '保存',
    cancel: '取消',
    updateSuccess: '个人资料已更新',
    updateFailed: '更新用户信息失败',
    avatarUploadSuccess: '头像上传成功',
    avatarUploadFailed: '头像上传失败'
  },
  
  // 公司用户管理
  companyUserAdmin: {
    companyName: "公司名称",
    email: "Email",
    address: "地址",
    phone: "电话",
    website: "网站",
    createdAt: "建立时间",
    updatedAt: "更新时间",
    action: "操作",
    edit: "编辑",
    delete: "删除",
    name: "名称",
    account: "账号",
    isActive: "启用",
    isOwner: "主账号",
    active: "启用",
    inactive: "停用",
    owner: "主",
    addUser: "新增用户",
    searchUser: "搜索账号、Email、名称...",
    batchEnable: "批量启用",
    batchDisable: "批量停用",
    timezone: "时区",
    selectTimezone: "请选择时区",
    language: "语言",
    addCompany: "新增公司",
    platformWabaBadge: "Platform WABA",
    platformWabaTooltip: "此公司为平台 WABA：其 WhatsApp／WABA 相关设定会作为新注册公司复制设定的来源。",
    roles: "角色",
    selectRoles: "选择角色",
    roleManagement: "角色管理",
    tenantAdmin: "租户管理员",
    companyAdmin: "公司管理员",
    designer: "设计师",
    approver: "审批者",
    addRole: "新增角色",
    removeRole: "移除角色",
    noRoles: "无角色",
    currentRoles: "当前角色",
    selectedRoles: "已选角色",
    userInfo: "用户信息",
    avatar: "头像",
    status: "状态",
    isMainAccount: "是否为主账号",
    enabled: "启用",
    disabled: "停用",
    yes: "是",
    no: "否",
    editUser: "编辑用户",
    mainAccountNote: "（在 SaaS 版本中，主账号是指付款账号）",
    password: "密码",
    passwordPlaceholder: "如需修改请输入新密码（留空则不修改）",
    confirmPassword: "确认密码",
    confirmPasswordPlaceholder: "请再次输入密码",
    confirmPasswordRequired: "请再次输入密码以确认",
    passwordMismatch: "两次输入的密码不一致",
    passwordMinLength: "密码长度至少为 6 个字符",
    company: "公司",
    selectCompany: "请选择公司",
    companyRequired: "请选择公司",
    phoneDuplicate: "手机号码已存在，请使用其他号码",
    emailDuplicate: "Email 已存在，请使用其他 Email",
    userCreateSuccess: "用户信息创建成功",
    userUpdateSuccess: "用户信息更新成功",
    roleUpdateSuccess: "角色更新成功",
    roleUpdateFailed: "角色更新失败",
    userCreateSuccessButRoleFailed: "用户创建成功，但角色设置失败，请稍后手动设置"
  },
  
  // 公司编辑
  companyEdit: {
    uploadLogo: "点击上传公司头像",
    basicInfo: "公司基本资料",
    companyId: "公司 ID",
    copyCompanyId: "复制公司 ID",
    companyIdCopied: "公司 ID 已复制到剪贴板",
    name: "公司名称",
    nameLocalesHint: "主栏位与 JSON 内 en 同步；繁／简可选填。",
    nameLocaleZhTc: "公司名称（繁体中文）",
    nameLocaleZhSc: "公司名称（简体中文）",
    email: "Email",
    address: "地址",
    phone: "电话",
    website: "网站",
    createdAt: "建立时间",
    updatedAt: "更新时间",
    timezone: "时区",
    timezonePlaceholder: "选择时区",
    whatsappSetting: "WhatsApp 设置",
    waApiKey: "wA_API_Key",
    waPhoneNoId: "wA_PhoneNo_ID",
    waVerifyToken: "wA_VerifyToken",
    back: "返回",
    save: "保存",
    cancel: "取消",
    saveSuccess: "保存成功",
    saveFailed: "保存失败",
    uploadSuccess: "上传成功",
    uploadFailed: "上传失败",
    // WhatsApp API 设置
    waBusinessAccountId: "WhatsApp Business Account ID",
    waBusinessAccountIdTooltip: "用于管理 Meta 官方模板",
    waBusinessAccountIdSuffix: "模板管理",
    waMetaBusinessId: "Meta Business ID（商家资产管理组合编号）",
    waMetaBusinessIdPlaceholder: "例如: 1420491162404755",
    waMetaBusinessIdTooltip: "用于目录管理：建立新目录、列出 Business 底下所有目录。可于 Meta 企业管理平台 > 企业设定 > 商家资讯 查看",
    waMetaBusinessIdSuffix: "目录管理",
    phoneNoIdPlaceholder: "例如: 690383010830837",
    businessAccountIdPlaceholder: "例如: 1102096678464098",
    configWarningTitle: "⚠️ 重要配置提醒",
    configWarningDescription: "请确保 Phone Number ID 属于 Business Account ID 指定的 WABA：",
    configWarningPhoneIdUse: "• Phone Number ID 用于发送消息（必须属于正确的 WABA）",
    configWarningBusinessIdUse: "• Business Account ID 用于查询模板列表",
    configWarningMismatchTitle: "⚠️ 如果这两个 ID 不匹配，会导致：",
    configWarningMismatchItem1: "能看到模板列表，但发送消息时找不到模板",
    configWarningMismatchItem2: "模板属于不同的 WABA 而无法使用",
    configWarningSolution: "💡 解决方法：在 Meta Business Suite 中确认 Phone Number ID 属于哪个 WABA，然后更新 Business Account ID 为该 WABA 的 ID",
    validateTokenButton: "验证 Token 权限",
    validateTokenHint: "输入 API Key 和 Business Account ID 后点击验证",
    validateTokenLoading: "正在验证 Token 权限...",
    validateTokenError: "❌ 验证失败",
    validateTokenFailed: "❌ 权限检查失败",
    validateTokenErrorMsg: "无法验证 Token 权限，请检查您的设置",
    validateTokenCheckResult: "🔐 Token 权限检查结果",
    tokenStatus: "Token 状态：",
    tokenValid: "✅ 有效",
    tokenInvalid: "❌ 无效",
    companyLabel: "公司：",
    capabilitiesTitle: "功能权限：",
    sendMessageLabel: "发送消息：",
    available: "✅ 可用",
    unavailable: "❌ 不可用",
    receiveWebhookLabel: "接收 Webhook：",
    manageTemplatesLabel: "管理 Meta 模板：",
    createFlowLabel: "建立 WhatsApp Flow：",
    permissionsTitle: "详细权限：",
    recommendationsTitle: "建议：",
    permissionCheckFailed: "无法验证 Token 权限，请检查您的设置",
    validateTokenPermissionError: "检查 Token 权限时发生错误，请稍后重试",
    validateTokenCheckError: "检查 Token 权限时发生错误，请稍后重试",
    apiKeyRequired: "请先输入 WA API Key (Access Token)",
    businessAccountIdRequired: "请先输入 WhatsApp Business Account ID",
    webhookToken: "Webhook Token",
    webhookTokenPlaceholder: "自动生成的唯一 Token",
    regenerateToken: "重新生成",
    tokenGenerated: "新的 Token 已生成，URL 已更新",
    webhookUrl: "Meta Webhook URL",
    webhookUrlPlaceholder: "例如: https://your-domain.com/api/MetaWebhook/your-token",
    copyWebhookUrl: "复制",
    webhookUrlCopied: "Webhook URL 已复制到剪贴板",
    generateTokenFirst: "请先生成 Webhook Token",
    // WhatsApp 菜单设置
    chatbotMenuConfig: "聊天机器人菜单设置",
    apiSettings: "API 设置",
    menuConfigHint: "这些设置用于自定义 WhatsApp 聊天机器人的菜单文字。留空将使用系统默认值。",
    welcomeMessage: "欢迎消息",
    welcomeMessageTooltip: "用户首次使用时显示的欢迎文字",
    noFunctionMessage: "无功能提示",
    noFunctionMessageTooltip: "当没有可用工作流程时显示的消息",
    menuTitle: "菜单标题",
    menuTitleTooltip: "WhatsApp 列表菜单的标题",
    menuButton: "查看按钮",
    menuButtonTooltip: "菜单的查看选项按钮文字",
    menuFooter: "菜单底部文字",
    menuFooterTooltip: "WhatsApp 列表菜单的底部提示",
    sectionTitle: "区段标题",
    sectionTitleTooltip: "服务选项的分类标题",
    defaultOptionDescription: "预设选项描述",
    defaultOptionDescriptionTooltip: "工作流程没有描述时的预设文字",
    inputErrorMessage: "输入错误提示",
    inputErrorMessageTooltip: "用户输入格式错误时的提示消息",
    fallbackMessage: "回退提示",
    fallbackMessageTooltip: "当 WhatsApp 交互式消息失败时的回退提示",
    systemErrorMessage: "系统错误提示",
    systemErrorMessageTooltip: "系统发生错误时的一般性提示消息",
    // Placeholders
    welcomeMessagePlaceholder: "欢迎使用我们的服务！\n\n请选择您需要的功能：",
    noFunctionMessagePlaceholder: "欢迎使用我们的服务！\n\n目前没有可用的功能，请联系管理员。",
    menuTitlePlaceholder: "服务菜单",
    menuButtonPlaceholder: "查看选项",
    menuFooterPlaceholder: "请选择您需要的服务",
    sectionTitlePlaceholder: "服务选项",
    defaultOptionDescriptionPlaceholder: "点击选择此服务",
    inputErrorMessagePlaceholder: "输入不正确，请重新输入。",
    fallbackMessagePlaceholder: "\n\n回复数字选择功能，或输入「菜单」重新显示菜单。",
    systemErrorMessagePlaceholder: "系统错误：无法找到 QR Code 节点配置。",
    subscribeWebhookButton: "订阅 Webhook",
    subscribeWebhookLoading: "正在订阅 Webhook...",
    subscribeWebhookSuccessTitle: "Webhook 订阅结果",
    subscribeWebhookSuccess: "Webhook 订阅成功，Meta 将把通知发送到您的回调网址。",
    subscribeWebhookErrorTitle: "Webhook 订阅失败",
    subscribeWebhookError: "无法订阅 Webhook，请确认 Access Token、Business Account ID 及权限设定。",
    // 破冰问题 / 指令
    iceBreakersTab: '破冰问题',
    commandsTab: '指令',
    iceBreakersDesc: '破冰问题是用户轻松询问你的常见问题，会在首次开启对话时显示为可点选的提示。',
    commandsDesc: '指令是可用来指示 WhatsApp Bot 采取动作的特殊关键字。你必须在每个关键字之前使用「/」。',
    convNotSaved: '请先保存公司资料后再设定对话组件',
    iceBreakersLabel: '破冰问题 {index}',
    iceBreakersInputPlaceholder: '输入破冰问题（最多 80 字，不支持 Emoji）',
    addIceBreaker: '新增破冰问题',
    saveIceBreakersSuccess: '破冰问题已保存至 WhatsApp',
    cmdNameLabel: '指令文字',
    cmdNamePlaceholder: '例如：/imagine、/generate',
    cmdDescLabel: '指令说明',
    cmdDescPlaceholder: '为这个指令新增说明。(例如：生成图像)',
    addCommand: '新增指令',
    saveCommandsSuccess: '指令已保存至 WhatsApp',
    convLoadFailed: '载入对话组件失败',
    convSaveFailed: '保存失败',
    delete: "删除公司",
    deleteTenantAdminOnly: "只有 Tenant_Admin 可以删除公司",
    deleteConfirmTitle: "删除公司前请小心确认",
    deleteConfirmOk: "我已备份并确认删除",
    deleteConfirmCancel: "取消",
    deleteBackupWarningTitle: "此操作可能永久删除或影响此公司的相关数据",
    deleteBackupWarningDesc: "删除前请先完成数据库及文件备份，并确认不再需要此公司的流程、表单、商务及 WhatsApp 记录。部分数据表可能因外键限制而阻止删除，系统会回报错误。",
    deleteImpactTitle: "可能受影响的数据范围：",
    deleteImpactUsers: "公司使用者、角色、权限设定",
    deleteImpactWorkflows: "工作流程定义、执行记录、步骤记录",
    deleteImpactForms: "电子表单、表单实例、审批、报表及文件输出",
    deleteImpactDatasets: "DataSet、数据列、导入排程及处理记录",
    deleteImpactContacts: "联络人、广播群组、标签、日历事件及相关资源",
    deleteImpactWhatsapp: "WhatsApp 模板、消息、Webhook / Flow 相关设定",
    deleteImpactCommerce: "Commerce 客户、商品、目录、订单、价格卡及 WPA 权限数据",
    deleteImpactAiBilling: "AI 员工、API Provider 设定、用量计费、Wix 开通记录",
    deleteImpactKnowledge: "知识库分类、文件及版本",
    deleteTypeCompanyName: "请输入公司名称「{name}」以确认删除。",
    deleteConfirmTextMismatch: "确认文字不正确，已取消删除",
    deleteFailed: "删除失败",
    deleteSuccess: "已删除"
  },

  commerceCustomers: {
    title: '客户主档管理',
    addCustomer: '新增客户',
    editCustomer: '编辑客户',
    customerNo: '客户编号',
    branchNo: '分店编号',
    nameCn: '中文名称',
    nameEn: '英文名称',
    nameCn1: '中文名称 1',
    nameCn2: '中文名称 2',
    nameCn3: '中文名称 3',
    nameEn1: '英文名称 1',
    nameEn2: '英文名称 2',
    nameEn3: '英文名称 3',
    customerNameCol: '客户名称（界面语言）',
    nameLine: '客户名称',
    nameLocaleZhTc: '客户名称（繁体）',
    nameLocaleZhSc: '客户名称（简体）',
    customerNameLocalesHint: '各行下方可填繁体、简体；英文以上方字段为准（对应后端 en）。',
    contactName: '联络人',
    tel: '电话',
    fax: '传真',
    email: '电邮',
    whatsappNo: 'WhatsApp',
    salesmanName: '销售员',
    salesmanCode: '销售员代码',
    salesmanCodePlaceholder: '与 ERP／内部编号核对用',
    salesmanWhatsapp: '销售员 WhatsApp',
    creditLimit: '信用额度',
    priceType: '价格类型',
    priceTypePlaceholder: '自由输入',
    paymentTerm: '付款条款',
    paymentTermPlaceholder: 'COD / 30日数期月结 / 60日数期月结 …',
    remark: '备注',
    remarkPlaceholder: '客户备注',
    customerStatus: '客户状态',
    statusActive: '启用',
    statusSuspended: '暂停',
    statusPending: '待审',
    tabBasic: '基本资料',
    tabAddress: '地址',
    tabDeliverySchedule: '车期设置',
    tabSalesman: '销售员',
    billingAddressCn: '账单地址（中文）',
    billingAddressEn: '账单地址（英文）',
    deliveryAddressCn: '送货地址（中文）',
    deliveryAddressEn: '送货地址（英文）',
    addressLine1: '地址行 1',
    addressLine2: '地址行 2',
    addressLine3: '地址行 3',
    deliveryMon: '一',
    deliveryTue: '二',
    deliveryWed: '三',
    deliveryThu: '四',
    deliveryFri: '五',
    deliverySat: '六',
    deliverySun: '日',
    deliveryScheduleHolidayTag: '假',
    deliveryHoliday: '公众假期送货',
    importExcel: '导入 Excel',
    importPreview: '导入预览',
    confirmImport: '确认导入',
    importSuccess: '导入成功',
    search: '搜索客户...',
    deleteConfirm: '确定删除此客户？',
    created: '已建立',
    updated: '已更新',
    noData: '尚无客户数据',
    subtitle: '管理客户主档、地址与车期设置',
    loadFailed: '加载客户数据失败',
    saved: '客户已更新',
    saveFailed: '保存失败',
    deleted: '客户已删除',
    deleteFailed: '删除失败',
    importParseFailed: '导入文件解析失败',
    importFailed: '导入失败',
    whatsapp: 'WhatsApp',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    confirmDelete: '确定删除此客户？',
    required: '必填',
    addressLine: '地址行',
    deliveryScheduleHint: '请选择可送货日期',
    holidayDelivery: '公众假期送货',
    import: '导入',
    refresh: '刷新',
    searchPlaceholder: '搜索客户编号 / 名称 / 联络人',
    filterByCompany: '按公司筛选',
    company: '公司',
    selectCompany: '请选择公司',
    cancel: '取消',
    save: '保存',
  },

  commercePriceCards: {
    title: '价格表管理',
    addPriceCard: '新增价格卡',
    editPriceCard: '编辑价格卡',
    customerNo: '客户编号',
    branchNo: '分店编号',
    itemNo: '产品编号',
    unitPrice: '单价',
    showPrice: '显示价格',
    validFrom: '生效日期',
    validTo: '结束日期',
    source: '来源',
    priceType: '价格类型',
    priceTypePlaceholder: '自由输入',
    importCsv: '导入 CSV',
    importPreview: '导入预览',
    confirmImport: '确认导入',
    importSuccess: '导入成功',
    deleteConfirm: '确定删除此价格卡？',
    overlapError: '日期范围与已有价格卡重叠',
    yes: '是',
    no: '否',
    noData: '尚无价格表数据',
    description: '管理客户分店商品价格与生效日期',
    loadFailed: '加载价格表失败',
    created: '价格卡已新增',
    saved: '价格卡已更新',
    saveFailed: '保存失败',
    deleted: '价格卡已删除',
    deleteFailed: '删除失败',
    importEmpty: '没有可导入数据',
    importParseFailed: 'CSV 解析失败',
    importFailed: '导入失败',
    actions: '操作',
    edit: '编辑',
    delete: '删除',
    confirmDelete: '确定删除此价格卡？',
    refresh: '刷新',
    filterCustomerNo: '筛选客户编号',
    filterCustomerName: '筛选客户名称（含各语系）',
    filterBranchNo: '筛选分店编号',
    filterItemNo: '筛选商品编号',
    filterByCompany: '按公司筛选',
    company: '公司',
    required: '必填',
    selectCompany: '请选择公司',
    selectCompanyFirst: '请先选择公司',
    customerPickerTitle: '选择客户',
    customerPickerSearchPlaceholder: '搜索客户编号、分店、公司名、联系人、电话',
    customerPickerLoadFailed: '加载客户列表失败',
    openCustomerList: '查询',
    chooseCustomer: '选择',
    productPickerTitle: '选择商品',
    productPickerSearchPlaceholder: '搜索 Content ID／品名／说明',
    productPickerLoadFailed: '加载商品列表失败',
    openProductList: '查询',
    chooseProduct: '选择',
    customerName: '客户名称',
    productName: '产品名称',
    productNameColUiLocale: '商品名称（界面语言）',
    productNameList: '品名',
    productListPrice: '原价（商品标价）',
    pickerNameCn: '公司名称（中）',
    pickerContactName: '联系人',
    pickerContactTel: '电话',
    customerNoPlaceholder: '可手动输入或从列表选择',
    branchNoPlaceholder: '选择客户后会自动带入，可再修改',
    importPreviewTitle: '价格卡导入预览',
    cancel: '取消',
    save: '保存',
  },

  commerceSalesOrders: {
    title: '销售订单管理',
    addOrder: '新增订单',
    editOrder: '编辑订单',
    orderNo: '订单编号',
    orderDate: '订单日期',
    customerNo: '客户编号',
    branchNo: '分店编号',
    companyNameCn: '公司名称（中文）',
    companyNameEn: '公司名称（英文）',
    billingAddress: '账单地址',
    deliveryAddress: '送货地址',
    deliveryDate: '送货日期',
    contactName: '联络人',
    contactTel: '联络电话',
    salesmanName: '销售员',
    purchaseOrderNo: 'PO 号码',
    paymentTerm: '付款条款',
    paymentTermPlaceholder: 'COD / 30日数期月结 / 60日数期月结 …',
    remark: '备注',
    currency: '币别',
    totalAmount: '总金额',
    status: '状态',
    thirdPartyReadStatus: '第三方读取',
    thirdPartyReadPending: '未处理',
    thirdPartyReadDone: '已读入',
    source: '来源',
    statusPending: '待处理',
    statusConfirmed: '已确认',
    statusProcessing: '处理中',
    statusCompleted: '已完成',
    statusCancelled: '已取消',
    sourceManual: '手动',
    sourceWhatsapp: 'WhatsApp',
    confirm: '确认',
    complete: '完成',
    cancel: '取消',
    customerInfo: '客户信息',
    anonymousOrder: '匿名 WhatsApp 下单',
    waId: 'WhatsApp 号码',
    remark: '备注',
    deliverySchedule: '车期表',
    orderDetails: '订单明细',
    seq: '序号',
    itemNo: '产品编号',
    productName: '品名',
    unitPrice: '单价',
    quantity: '数量',
    unit: '单位',
    amount: '金额',
    addLine: '新增明细',
    selectCustomer: '选择客户',
    search: '搜索订单...',
    deleteConfirm: '确定删除此订单？',
    noData: '尚无订单数据',
    allStatus: '所有状态',
    deliveryMon: '一',
    deliveryTue: '二',
    deliveryWed: '三',
    deliveryThu: '四',
    deliveryFri: '五',
    deliverySat: '六',
    deliverySun: '日',
    deliveryHoliday: '公众假期',
    subtitle: '管理销售订单 Header / Details',
    loadFailed: '加载订单失败',
    loadDetailFailed: '加载订单详情失败',
    customerRequired: '请先选择客户',
    created: '订单已新增',
    saved: '订单已更新',
    saveFailed: '保存失败',
    statusUpdated: '状态已更新',
    statusUpdateFailed: '更新状态失败',
    deleted: '订单已删除',
    deleteFailed: '删除失败',
    confirmCancel: '确定要取消此订单？',
    lineRemark: '明细备注',
    confirmDeleteLine: '确定删除此明细？',
    customer: '客户',
    companyName: '公司名称',
    detail: '详情',
    actions: '操作',
    delete: '删除',
    confirmDelete: '确定删除此订单？',
    refresh: '刷新',
    searchPlaceholder: '搜索订单编号 / 客户 / 公司',
    filterByStatus: '按状态筛选',
    filterByCompany: '按公司筛选',
    deliveryDateFrom: '交货日 由',
    deliveryDateTo: '交货日 至',
    close: '关闭',
    create: '建立',
    save: '保存',
    orderDetail: '订单详情',
    newOrder: '新建订单',
    selectCustomerPlaceholder: '请选择客户',
    customerPickerTitle: '选择客户',
    customerPickerSearchPlaceholder: '搜索客户编号、分店、公司名称、联系人、电话',
    customerPickerLoadFailed: '加载客户列表失败',
    openCustomerList: '打开列表',
    clearCustomer: '清除',
    chooseCustomer: '选择',
    selectCompanyFirst: '请先选择公司（租户管理员）',
    searchProductPlaceholder: '搜索或选择商品（Content ID）',
    searchMoreProducts: '搜索更多…',
    productPickerTitle: '搜索商品',
    productPickerSearchPlaceholder: '搜索 Content ID／品名／说明',
    productPickerLoadFailed: '加载商品失败',
    chooseProduct: '选择',
    productListPrice: '标价',
    holidayFlag: '公众假期可送',
    purchaseOrderNoPlaceholder: '输入 PO 号码',
    remarkPlaceholder: '输入备注',
  },

  commerceCatalogAdmin: {
    title: "Meta 目录管理（目录 CRUD）",
    alertInfo: "此页仅供具备「目录管理」权限的用户（如 Tenant_Admin）使用。可建立新目录、列出 Business 底下所有目录并选择连结至目前公司 WABA；已连结的目录可于下方查看。删除／取消连结请至 Meta Commerce Manager 操作（API 未提供 unlink/delete）。",
    alertMetaPermission: "Meta 目录 API 所需权限",
    alertMetaPermissionDesc: "建立目录、列出 Business 底下目录需 Meta Access Token 具备：business_management、catalog_management。若出现「Missing Permission」或「Requires business_management permission」，请至 Meta 应用程式后台（App Dashboard）为此应用加入上述权限并重新取得／更新公司设定的 WA API Key（Access Token）。",
    cardCreate: "1. 建立新目录",
    metaBusinessId: "Meta Business ID",
    catalogName: "目录名称",
    catalogNamePlaceholder: "例如：我的商品目录",
    required: "必填",
    createCatalog: "建立目录",
    metaBusinessIdHint: "Meta Business ID 可于企业管理平台 > 企业设定 > 帐户 中查看。",
    cardOwned: "2. Business 底下所有目录（可选连结至 WABA）",
    inputMetaBusinessId: "输入 Meta Business ID",
    loadCatalogs: "载入目录",
    catalogId: "目录 ID",
    name: "名称",
    action: "操作",
    linkToWaba: "连结至 WABA",
    emptyOwned: "请输入 Business ID 并点「载入目录」，或先于上方建立新目录。",
    cardLinked: "3. 已连结至目前公司 WABA 的目录",
    reload: "重新载入",
    emptyLinked: "目前没有已连结的目录。若此 WABA 为测试帐号，Meta 可能尚未提供目录 API；或请先在 Meta 商家资产管理组合中建立并连结目录。",
    noPermission: "无目录管理权限",
    loadCatalogsFailed: "载入目录失败",
    catalogCreated: "目录已建立",
    createFailed: "建立失败",
    catalogIdEmpty: "目录 ID 为空",
    linkSuccess: "已连结目录至 WABA",
    linkFailed: "连结失败",
    wabaMaxOneCatalog: "此 WABA 已连结一个目录。Meta 规定每个 WhatsApp Business Account 最多只能连结一个商品目录。若要改连结其他目录，请先至 Meta Commerce Manager 取消连结现有目录。",
    unlinkHint: "取消连结目录须在 Meta 后台操作（公开 API 不提供 unlink）。",
    openMetaCommerceManager: "开启 Meta Commerce Manager",
    unlinkAction: "前往 Meta 取消连结",
    pleaseEnterMetaBusinessId: "请先输入 Meta Business ID",
    loadedCount: "已载入 {count} 个目录"
  },
  commerceCollections: {
    title: "Commerce / Collections",
    description: "管理商品集合，并可将商品关联到指定 collection。",
    refresh: "重新整理",
    addCollection: "新增集合",
    name: "名称",
    nameColUiLocale: "集合名称（界面语言）",
    company: "公司",
    phoneNumberId: "电话号码 ID",
    filterByCompany: "筛选公司",
    selectCompany: "请选择公司",
    externalKey: "External Key",
    metaProductSet: "Meta Product Set",
    itemCount: "商品数",
    actions: "操作",
    edit: "编辑",
    linkProducts: "关联商品",
    sync: "上传至 Meta",
    delete: "删除",
    confirmDelete: "确定删除此集合？",
    editCollection: "编辑集合",
    addCollectionModal: "新增集合",
    collectionName: "集合名称（英文／主栏）",
    nameLocaleZhTc: "集合名称（繁体）",
    nameLocaleZhSc: "集合名称（简体）",
    nameLocalesHint: "主栏位与 JSON 内 en 同步；繁／简可选填。",
    description: "描述",
    externalCollectionKey: "External Collection Key",
    metaProductSetId: "Meta Product Set ID",
    metaCatalogId: "Meta Catalog ID",
    selectCatalog: "请选择目录（由 Meta API 取得）",
    noCatalog: "无目录，请确认公司已设定 WABA 与 API Key",
    linkedCatalogDefault: "已连结目录（预设，WABA 仅能连结一个）",
    noCatalogLinkedHint: "目前公司 WABA 尚未连结目录，请至「目录管理」连结。",
    loading: "载入中...",
    linkProductsTitle: "关联商品：{name}",
    linkProductsHint: "上方为已关联商品，可移除；下方可搜索并勾选要新增关联的商品（不会显示已关联项目）。仅列出与此集合相同电话号码（WABA）的商品。",
    linkProductsLinkedSection: "已关联商品",
    linkProductsAvailableSection: "可新增关联",
    linkProductsLinkedEmpty: "尚未关联任何商品",
    linkProductsRemove: "移除",
    linkProductsSearchPlaceholder: "搜索名称、Content ID、描述、品牌、类别…",
    linkProductsSelectedCount: "已选 {n} 项商品",
    selectProducts: "选择要放入此集合的商品",
    loadFailed: "载入集合资料失败",
    saved: "集合已更新",
    created: "集合已新增",
    saveFailed: "保存失败",
    deleted: "集合已删除",
    deleteFailed: "删除失败",
    syncSuccess: "已加入上传伫列（scheduler_executions）",
    syncFailed: "上传至 Meta 失败",
    syncEmptyHint: "此集合尚无关联商品，请先「关联商品」加入至少一项后再上传至 Meta。",
    selectAtLeastOne: "请至少勾选一笔集合",
    batchUploadToMeta: "批量上传至 Meta",
    batchUploadQueued: "已将 {count}/{total} 笔加入上传伫列",
    batchUploadQueuedSkipped: "已将 {count}/{total} 笔加入上传伫列（跳过 {skipped} 笔无商品的集合）",
    loadLinkFailed: "载入关联商品失败",
    linkSaved: "商品关联已更新",
    linkSaveFailed: "保存关联失败"
  },
  commerceImport: {
    title: "Commerce 数据交换",
    description: "支持 Excel / Google Sheets / SQL 导入与销售订单导出。",
    uploadText: "点击或拖曳档案到这里",
    uploadHint: "首行请包含栏位标题；导入目标公司请在上方选择（Tenant_Admin）。",
    clear: "清空",
    startImport: "开始导入",
    loadedRows: "已载入 {count} 笔，缺少必填: {missing} 笔",
    parseSuccess: "已载入 {count} 笔数据",
    parseFailed: "载入失败",
    pleaseUpload: "请先上载档案",
    companyRequired: "请选择导入目标公司（Tenant_Admin 必选）。",
    rowMissing: "第 {row} 笔缺少必填栏位",
    rowMissingName: "第 {row} 笔缺少名称",
    rowFailed: "第 {row} 笔失败",
    importDone: "导入完成，共 {count} 笔",
    importDoneTitle: "导入完成",
    importFailed: "导入失败",
    importResult: "导入完成，成功 {success} / 失败 {failed}",
    importResultDetail: "导入结果：成功 {success}，失败 {failed}",
    allSuccess: "全部成功",
    importTarget: "导入对象",
    company: "公司",
    selectCompany: "选择公司",
    minutes: "分钟",
    total: "总计",
    created: "新增",
    updated: "更新",
    added: "新增",
    linked: "关联",
    skipped: "略过",
    errorsCount: "错误",
    errorDetails: "错误详情",
    exportDone: "导出完成",
    exportFailed: "导出失败",
    exportResult: "导出结果",
    tabImport: "数据导入",
    tabExport: "销售订单导出",
    domainCommerce: "商务主档",
    domainWpa: "PWA 权限",
    targetCustomers: "客户主档",
    targetPriceCards: "价格表",
    targetProducts: "商品列表",
    targetCollections: "商品集合（主档）",
    targetCollectionLinks: "集合—商品关联",
    targetWpaGroupMembers: "PWA 群组成员",
    targetWpaGroupCustomers: "PWA 群组客户",
    targetWpaContactOverrides: "PWA Contact 覆写",
    targetWpaIdentities: "PWA 登录帐号",
    stepSource: "选择来源",
    stepSourceDesc: "设定数据来源",
    stepMapping: "栏位对应",
    stepMappingDesc: "预览与对应",
    stepResult: "执行结果",
    stepResultDesc: "导入完成",
    sourceExcel: "Excel 文件",
    sourceGoogle: "Google Sheets",
    sourceSql: "SQL 数据库",
    exportTitle: "销售订单导出",
    exportModeSplit: "Header + Detail 分开",
    exportModeFlat: "扁平合并",
    exportQuery: "查询并导出",
    exportDownloadCsv: "下载 CSV",
    exportAllStatus: "全部",
    exportDateRange: "日期范围",
    exportMode: "对应模式",
    scheduleTitle: "Commerce 导入排程管理",
    scheduleName: "排程名称",
    scheduleTarget: "导入目标",
    scheduleFrequency: "执行频率",
    scheduleLastRun: "上次执行",
    scheduleNextRun: "下次执行",
    scheduleEdit: "编辑",
    scheduleEditTitle: "编辑 Commerce 导入排程",
    schedulePause: "暂停",
    scheduleResume: "启用",
    scheduleActive: "执行中",
    schedulePaused: "已暂停",
    scheduleResumed: "已启用",
    scheduleDeleted: "排程已删除",
    scheduleDeleteFailed: "删除失败",
    scheduleDeleteConfirm: "确定删除此排程？",
    scheduleDelete: "删除",
    scheduleUpdated: "排程已更新",
    scheduleUpdateFailed: "更新失败",
    scheduleSaved: "排程已保存！",
    scheduleSavedDesc: "您的导入已保存为定时任务，可在排程管理页面查看。",
    scheduleSaveFailed: "排程保存失败",
    scheduleGotoManage: "前往排程管理",
    scheduleLoadFailed: "载入排程列表失败",
    schedulePreviewFailed: "无法载入预览",
    schedulePreviewFailedManual: "预览载入失败，可手动编辑对应",
    scheduleToggleFailed: "操作失败",
    scheduleBasicSettings: "基本设定",
    scheduleIntervalLabel: "间隔（分钟）",
    scheduleEnable: "启用",
    scheduleSourceConfig: "来源设定",
    scheduleFile: "档案",
    scheduleSheet: "工作表",
    scheduleStatus: "状态",
    scheduleActions: "操作",
    scheduleCompany: "公司",
    scheduleExecuteNow: "执行",
    scheduleExecuteSuccess: "已执行导入",
    importProgress: "导入进度",
    importRunningBackground: "导入已在后台执行，请查看进度列",
    importAlreadyRunning: "该排程正在导入中，请稍候",
    scheduleExecuteFailed: "执行失败",
    scheduleTotalCount: "共 {count} 笔排程",
    reloadPreview: "重新载入预览",
    sqlPreviewTotalRows: "符合条件的总笔数：{count}",
    sqlPreviewTopNote: "为加快预览已自动加上 TOP {n}；正式导入会载入全部符合条件的数据。",
    sqlPreviewWithCteNote: "此查询含 WITH/CTE，无法自动加 TOP，预览可能较久。",
    sqlLoadingFullForImport: "正在从 SQL 载入完整数据以执行导入…",
    sqlConfigIncomplete: "请填写服务器、数据库，以及表名或自定义查询至少一项",
    googleSpreadsheetId: "试算表 ID（Spreadsheet ID）",
    googleSpreadsheetIdPlaceholder: "选填；已验证后可与 URL 并存",
    noPreviewData: "无预览数据",
    freqEveryNMin: "每 {n} 分钟",
    wpaAllowPasswordUpdate: "允许更新已存在帐号的密码",
    fieldCustomerNo: "客户编号",
    fieldBranchNo: "分店编号",
    fieldCustomerName1: "客户名称 1（英文／默认 en）",
    fieldCustomerName2: "客户名称 2（英文／默认 en）",
    fieldCustomerName3: "客户名称 3（英文／默认 en）",
    fieldCustomerNameLine1ZhTc: "客户名称 1 繁体（zh-TC）",
    fieldCustomerNameLine1ZhSc: "客户名称 1 简体（zh-SC）",
    fieldCustomerNameLine2ZhTc: "客户名称 2 繁体",
    fieldCustomerNameLine2ZhSc: "客户名称 2 简体",
    fieldCustomerNameLine3ZhTc: "客户名称 3 繁体",
    fieldCustomerNameLine3ZhSc: "客户名称 3 简体",
    fieldContactName: "联络人",
    fieldTel: "电话",
    fieldEmail: "电邮",
    fieldWhatsappNo: "WhatsApp",
    fieldSalesmanName: "销售员",
    fieldSalesmanCode: "销售员代码（核对用）",
    fieldSalesmanWhatsapp: "销售员电话 / WhatsApp",
    fieldCreditLimit: "信用额度",
    fieldPriceType: "价格类型（price_type）",
    fieldBillingAddressEn1: "账单地址（英文）行 1",
    fieldBillingAddressEn2: "账单地址（英文）行 2",
    fieldBillingAddressEn3: "账单地址（英文）行 3",
    fieldBillingAddressCn1: "账单地址（中文）行 1",
    fieldBillingAddressCn2: "账单地址（中文）行 2",
    fieldBillingAddressCn3: "账单地址（中文）行 3",
    fieldDeliveryAddressEn1: "送货地址（英文）行 1",
    fieldDeliveryAddressEn2: "送货地址（英文）行 2",
    fieldDeliveryAddressEn3: "送货地址（英文）行 3",
    fieldDeliveryAddressCn1: "送货地址（中文）行 1",
    fieldDeliveryAddressCn2: "送货地址（中文）行 2",
    fieldDeliveryAddressCn3: "送货地址（中文）行 3",
    fieldDeliveryDayMon: "车期：周一可送货",
    fieldDeliveryDayTue: "车期：周二可送货",
    fieldDeliveryDayWed: "车期：周三可送货",
    fieldDeliveryDayThu: "车期：周四可送货",
    fieldDeliveryDayFri: "车期：周五可送货",
    fieldDeliveryDaySat: "车期：周六可送货",
    fieldDeliveryDaySun: "车期：周日可送货",
    fieldDeliveryDayHoliday: "车期：公众假期可送货",
    fieldItemNo: "产品编号",
    fieldUnitPrice: "单价",
    fieldShowPrice: "显示价格",
    fieldValidFrom: "生效日期",
    fieldValidTo: "结束日期",
    fieldSource: "来源",
    fieldName: "名称",
    fieldNameLocaleEn: "名称（英文 JSON en，选填覆盖）",
    fieldNameLocaleZhTc: "名称（繁体 zh-TC）",
    fieldNameLocaleZhSc: "名称（简体 zh-SC）",
    fieldRetailerId: "Content ID (Product ID)",
    fieldDescription: "描述",
    fieldLinkUrl: "连结",
    fieldImageUrl: "图片 URL",
    fieldBrand: "品牌",
    fieldPrice: "价格",
    fieldProductPrice1: "区间一单价 (price_1)",
    fieldProductValidFrom1: "区间一起日 (valid_from_1)",
    fieldProductValidTo1: "区间一迄日 (valid_to_1)",
    fieldProductPrice2: "区间二单价 (price_2)",
    fieldProductValidFrom2: "区间二起日 (valid_from_2)",
    fieldProductValidTo2: "区间二迄日 (valid_to_2)",
    fieldCurrency: "币别",
    fieldStatus: "状态",
    fieldAvailability: "库存状态",
    fieldUnitOfMeasure: "数量单位",
    fieldUnitOfMeasureLocaleEn: "数量单位（JSON en 覆写，选填）",
    fieldUnitOfMeasureLocaleZhTc: "数量单位（繁体中文）",
    fieldUnitOfMeasureLocaleZhSc: "数量单位（简体中文）",
    fieldUnitOfBrokenPackLocaleEn: "散装单位（JSON en 覆写，选填）",
    fieldUnitOfBrokenPackLocaleZhTc: "散装单位（繁体中文）",
    fieldUnitOfBrokenPackLocaleZhSc: "散装单位（简体中文）",
    fieldQtyPerUnit: "每单位数量",
    fieldMinOrderQuantity: "最小订单数量（MOQ）",
    fieldOqm: "Original Quality Manufacturer（OQM）",
    fieldCondition: "状况",
    fieldColor: "颜色",
    fieldSize: "尺寸",
    fieldGender: "性别",
    fieldMaterial: "材质",
    fieldPattern: "样式",
    fieldCustomLabel0: "内容编号",
    fieldProductionCategory: "生产分类",
    fieldMetaCatalogId: "Meta Catalog ID",
    fieldExternalKey: "External Key",
    fieldCollectionKey: "集合 Key",
    fieldGroupName: "群组名称",
    fieldWhatsappNumber: "WhatsApp 号码",
    fieldRoleKey: "角色 Key",
    fieldDefaultCustomerNo: "预设客户编号",
    fieldDefaultBranchNo: "预设分店编号",
    fieldCustomerNos: "可下单客户（逗号分隔）",
    fieldPhoneNo: "电话号码",
    fieldDisplayName: "显示名称",
    fieldPassword: "密码",
    hintCustomers: "必填：customerNo。branchNo 预设为 0000。以 customerNo+branchNo 匹配，存在则更新。名称建议 name1～name3（英文 en）；繁／简请用 nameLocaleLine1ZhTc、nameLocaleLine1ZhSc 等。选填：salesmanName／salesmanCode（销售员与代码，对应 ERP 核对）。价格类型 priceType／price_type 为选填。账单／送货地址（英、中各三行）为选填，字段键 billingAddressEn1…deliveryAddressCn3（或 billing_address_en_1 等 snake_case）。车期（周一至日、公众假期）为选填，可对应 Y/N、1/0、是/否、TRUE/FALSE；更新时未对应列保留原值。",
    hintPriceCards: "必填：customerNo、itemNo、unitPrice。日期范围有重叠会略过。可选：priceType／price_type（价格类型）。",
    hintProducts: "红色字段为必填：name、Content ID (Product ID)（字段 productRetailerId；新增必须有值，已存在则更新）。可选：区间一／二单价与起迄日 price1、validFrom1、validTo1、price2…（或 price_1、valid_from_1 等 snake_case）；与主栏 price 并存。可选：最小订单量 minOrderQuantity（别名如 moq、min_order_quantity）。",
    fieldMappingColumnRequired: "请选择对应的来源字段",
    noColumnMapping: "（不对应来源列）",
    fieldMappingFormIncomplete: "请完成红色必填字段对应后再导入",
    mappingExport: "导出字段映射",
    mappingImport: "导入字段映射",
    mappingImportSuccess: "字段映射已成功导入",
    mappingImportFailed: "导入失败，请确认 JSON 格式是否正确",
    hintCollections: "必填：name。若有 externalCollectionKey 且已存在则更新。",
    hintCollectionLinks: "必填：collectionKey、Content ID (Product ID)（productRetailerId）。对应集合／商品须已存在于系统中。",
    fieldLoginId: "PWA 登录账号 (loginId)",
    downloadImportTemplate: "下载导入模版",
    downloadAllImportTemplatesZh: "下载全部模版（中文）",
    downloadAllImportTemplatesEn: "下载全部模版（英文）",
    templateDownloaded: "已下载当前 Master 导入模版",
    templateAllDownloaded: "已下载全部 Master 导入模版（含说明工作表）",
    selectImportSheet: "选择工作表（共 {count} 个分页）",
    multiSheetPickHint: "此 Excel 含 {count} 个工作表，已自动预选数据分页，请确认下方「选择工作表」",
    sqlTenantAdminOnly: "SQL 数据库导入仅限 Tenant_Admin 使用",
    templateGoogleSheetsHint: "可下载 Excel 模版，将字段结构复制到 Google Sheets，或上传模版后以 Google Sheets 打开同一文件。",
    hintWpaGroupMembers: "必填：groupName、loginId（PWA 登录账号）。群组与账号须已存在。",
    hintWpaGroupCustomers: "必填：groupName、customerNo。branchNo 预设 0000。",
    hintWpaContactOverrides: "必填：loginId、roleKey。customerNos 可用逗号分隔多笔（格式：编号/分店）。",
    hintWpaIdentities: "必填：loginId（PWA 登录账号，可沿用 email 列）。新建时 password 必填；更新密码需勾选「允许更新密码」。",
  },
  commerceProducts: {
    title: "Commerce / Products",
    description: "管理商品，并可关联至 Collection、同步至 Meta。",
    refresh: "重新整理",
    addProduct: "新增商品",
    image: "图片",
    titleLabel: "标题",
    nameColUiLocale: "商品名称（界面语言）",
    productName: "商品名称（英文／主栏）",
    nameLocaleZhTc: "商品名称（繁体）",
    nameLocaleZhSc: "商品名称（简体）",
    nameLocalesHint: "主栏位与 JSON 内 en 同步；繁／简可选填。",
    description: "描述",
    descriptionPrimary: "描述（英文／主栏）",
    descriptionLocalesHint: "主栏位与 description_locales 内 en 同步；繁／简可选填。",
    descriptionLocaleZhTc: "描述（繁体）",
    descriptionLocaleZhSc: "描述（简体）",
    link: "连结",
    company: "公司",
    filterByCompany: "筛选公司",
    filterByCollectionsPlaceholder: "按集合筛选（可多选）",
    phoneNumberId: "电话号码 ID",
    contentId: "Content ID (Product ID)",
    searchKeywordPlaceholder: "搜索名称／描述／Content ID (Product ID)",
    fbCategory: "Facebook 商品类别",
    brand: "品牌",
    contentNumber: "内容编号",
    color: "颜色",
    size: "尺寸",
    gender: "性别",
    price: "价格",
    tabBasic: "基本资料",
    tabSellingPrice: "出售单价",
    sellingPriceTabHint: "至少设置「价格1」或「价格2」一组（含生效起迄，UTC），或仅填账面价格。PWA／购物车以价格表为优先，无价格表时依此处区间生效价。",
    legacyPrice: "账面价格（选填，旧数据兼容）",
    price1: "价格1",
    validFrom1: "生效起（1）",
    validTo1: "生效迄（1）",
    price2: "价格2",
    validFrom2: "生效起（2）",
    validTo2: "生效迄（2）",
    effectivePriceCol: "生效价（当前）",
    previewEffectiveAtServer: "预览生效价（服务器 UTC）",
    status: "状态",
    availability: "库存状态",
    unitOfMeasure: "数量单位",
    unitOfMeasureLocaleZhTc: "数量单位（繁体中文）",
    unitOfMeasureLocaleZhSc: "数量单位（简体中文）",
    unitOfBrokenPack: "散装单位",
    unitOfBrokenPackLocaleZhTc: "散装单位（繁体中文）",
    unitOfBrokenPackLocaleZhSc: "散装单位（简体中文）",
    unitOfBrokenPackPlaceholder: "例如：件、包、袋",
    unitOfBrokenPackHint: "拆箱／散卖时使用的单位（非整箱／整包）",
    qtyPerUnit: "每单位数量",
    qtyPerUnitHint: "每一单位含多少件。例如 1 箱 = 12 件，填 12",
    moq: "MOQ（最小订单量）",
    oqm: "Original Quality Manufacturer（OQM）",
    oqmHint: "选填",
    oqmPlaceholder: "例如：制造商或品质来源",
    unitOfMeasurePlaceholder: "例如：件、箱、公斤",
    condition: "状况",
    currency: "币别",
    material: "材质",
    pattern: "样式",
    actions: "操作",
    edit: "编辑",
    sync: "同步",
    delete: "删除",
    confirmDelete: "确定删除此商品？",
    addProductModal: "新增商品",
    editProductModal: "编辑商品",
    loadFailed: "载入商品失败",
    loadCollectionsFailed: "载入集合列表失败",
    addToCollection: "加入集合",
    addToCollectionHint: "已选 {count} 项商品，请选择加入现有集合或建立新集合。",
    addToExistingCollection: "加入现有集合",
    createNewCollection: "建立新集合",
    selectCollection: "选择集合",
    selectCollectionPlaceholder: "请选择集合",
    selectCollectionFirst: "请先选择要加入的集合",
    selectCollectionsFirst: "请至少选择一个集合",
    addToCollectionSearchPlaceholder: "依名称、描述、外部键、公司搜索",
    addToCollectionsSelectedCount: "已选 {n} 个集合",
    addToCollectionMixedWaba: "已选商品对应不同的 WhatsApp 号码（WABA），请只勾选同一组电话号码 ID 的商品。",
    addToCollectionNoCompatibleCollections: "没有与已选商品相同 WABA 的集合。可建立新集合，或在集合端绑定相同电话号码。",
    formBasicSection: "基本资料",
    selectAtLeastOne: "请至少勾选一项商品",
    newCollectionNameRequired: "请输入新集合名称",
    newCollectionNamePlaceholder: "输入新集合名称",
    newCollectionDescriptionPlaceholder: "选填描述",
    confirmAddToCollection: "确定",
    cancel: "取消",
    drawerClose: "关闭",
    addToCollectionSuccess: "已加入集合",
    addToCollectionFailed: "加入集合失败",
    saveFailed: "保存失败",
    saved: "商品已更新",
    created: "商品已新增",
    deleted: "商品已删除",
    deleteFailed: "删除失败",
    syncSuccess: "已写入同步纪录（scheduler_executions）",
    syncFailed: "同步失败",
    uploadToMeta: "上传至 Meta",
    uploadQueued: "已加入上传伫列（仅上传至 Meta，不从 Meta 下载）",
    uploadFailed: "加入上传伫列失败",
    batchUploadToMeta: "批量上传至 Meta",
    batchUploadQueued: "已将 {count}/{total} 笔加入上传伫列",
    batchUploadFailed: "批量上传失败",
    copy: "复制",
    batchCopy: "批量复制",
    copySuccess: "已复制为新商品（名称已自动加 (1)、(2)...）",
    copyFailed: "复制失败",
    batchCopySuccess: "已复制 {count}/{total} 笔为新商品",
    batchCopyFailed: "批量复制失败",
    nameRequired: "名称不可为空",
    inlineSaveFailed: "行内储存失败",
    saveMediaFirst: "请先储存商品，再上载图片/影片",
    imageVideoOnly: "只支援图片或影片档案",
    imageSizeLimit: "图片不可超过 8MB",
    videoSizeLimit: "影片不可超过 100MB",
    mediaUploadSuccess: "媒体上载成功",
    uploadFailed: "上载失败",
    setPrimary: "已设为主图片",
    setPrimaryFailed: "设定主图片失败",
    altUpdated: "alt_text 已更新",
    altUpdateFailed: "更新 alt_text 失败",
    mediaDeleted: "媒体已删除",
    reorderFailed: "排序失败",
    loadMediaFailed: "载入媒体失败",
    loadCatalogFailed: "载入 Meta 目录列表失败",
    selectCategory: "选择分类",
    noCategory: "没有分类，请先同步",
    save: "保存",
    inlineEdit: "行内编辑",
    detail: "详细",
    media: "图片/影片",
    metaProductId: "Meta Product ID",
    customLabel0Label: "内容编号（custom_label_0）",
    linkUrlPlaceholder: "https://...",
    mediaFormHint: "改用附图管理 UI（主图会自动同步到列表显示）。",
    openMediaManager: "打开附图 / 影片管理",
    productImage: "产品图片",
    productImageUploadHint: "点击上载或管理",
    creatingProductForMedia: "正在建立商品...",
    mediaModalTitle: "图片 / 影片管理",
    mediaModalHint: "图片大小不可超过 8MB；影片不可超过 100MB。可设定主图片与排序。",
    mediaUploadDragText: "拖放档案或点击上载",
    mediaUploadHint: "支援 image/video，尽量重现 Meta 商品媒体管理流程",
    mediaTypeImage: "图片",
    mediaTypeVideo: "影片",
    mediaTagPrimary: "主图",
    batchUploadProgress: "批次上载进度",
    retry: "重试",
    copyImageUrl: "复制完整网址",
    copyImageUrlSuccess: "已复制完整网址（Base URL + 路径）",
    metaAttributes: "Meta 属性",
    productType: "product_type",
    loadingMedia: "载入媒体中...",
    noMediaUploaded: "尚未上载媒体",
    altTextPlaceholder: "alt_text",
    saveAlt: "保存 alt",
    primaryImage: "主图片",
    confirmDeleteMedia: "确定删除此媒体？",
    linkedCatalogDefault: "已连结目录（预设，WABA 仅能连结一个）",
    noCatalogLinkedHint: "目前公司 WABA 尚未连结目录，请至「目录管理」连结。",
    linkRequired: "必填（Meta/WhatsApp 显示商品需填写连结）",
    priceRequired: "必填（Meta/WhatsApp 显示商品需填写价格）",
    metaRequiredHint: "Meta / WhatsApp 显示商品需填写「连结」与「价格」，未填会出现「缺少商品连结」「缺少价格」等错误。",
    collectionsSection: "所属集合",
    productCollectionsLabel: "所属集合（一对多）",
    productCollectionsTooltip: "选择此商品所属的集合，可选多个；保存时将同步更新各集合的商品关联",
    productCollectionsPlaceholder: "选择集合...",
    noCollectionFound: "无集合",
    taxonomySyncSuccess: "{provider} 分类已同步：{count} 笔",
    taxonomySyncFailed: "同步 {provider} 分类失败",
    syncFacebookTaxonomy: "同步 Facebook 分类"
  },

  commerceWpaHomePromotions: {
    title: 'PWA 首页广告',
    selectCompany: '选择公司',
    refresh: '刷新',
    add: '新增',
    loadFailed: '载入失败',
    saveOk: '已保存',
    saveFailed: '保存失败',
    deleteConfirm: '确定删除此广告？',
    deleteOk: '已删除',
    deleteFailed: '删除失败',
    colSort: '排序',
    colBanner: '横幅',
    colFullscreen: '全屏',
    colProduct: '链接商品',
    colActive: '启用',
    colSchedule: '档期',
    colActions: '操作',
    yes: '是',
    no: '否',
    create: '新增广告',
    edit: '编辑广告',
    sortOrder: '排序（数字越小越前）',
    active: '启用',
    validFrom: '档期开始（选填）',
    validTo: '档期结束（选填）',
    bannerPath: '横幅图路径',
    fullscreenPath: '全屏图路径',
    uploadBanner: '建议 16:10（如 1920×1200），PWA 满宽显示',
    uploadFullscreen: '建议 9:16（如 1080×1920），注意底部安全区',
    uploadBannerBtn: '上传横幅',
    uploadFullscreenBtn: '上传全屏图',
    uploadOk: '上传成功',
    linkedProduct: '链接商品（选填）',
    searchProduct: '输入关键字搜索商品',
    noLinkedProduct: '未选择商品',
    pickProductBtn: '选择商品',
    pickProductTitle: '选择链接商品',
    clearLinkedProduct: '清除',
    productSearchPlaceholder: '搜索名称、编号或说明',
    filterBrand: '品牌（含文字）',
    pickerOk: '确定',
    pickerCancel: '取消',
    pickerNeedSelect: '请选择一笔商品',
    sizeHintTitle: '图档建议',
    sizeHintBody: '横幅：16:10（如 1920×1200）。全屏：9:16（如 1080×1920）；重要内容勿贴边，底部预留按钮区。',
  },
  
  // EForm 相关
  eform: {
    title: "电子表单管理",
    name: "名称",
    description: "描述",
    formType: "表单类型",
    status: "状态",
    createdAt: "建立时间",
    updatedAt: "更新时间",
    action: "操作",
    edit: "编辑",
    delete: "删除",
    add: "新增表单",
    search: "搜索",
    searchPlaceholder: "搜索表单名称、描述...",
    enabled: "启用",
    disabled: "停用",
    deleted: "删除",
    confirmDeleteTitle: "确定要删除这个表单吗？",
    confirmDeleteContent: "此操作无法撤销",
    confirmDeleteOk: "确定",
    confirmDeleteCancel: "取消",
    deleteSuccess: "删除成功",
    deleteFailed: "删除失败",
    saveSuccess: "保存成功",
    saveFailed: "保存失败",
    batchDeleteTitle: "批量删除",
    batchDeleteContent: "确定要删除选中的 {count} 个表单吗？",
    batchDeleteSuccess: "批量删除成功",
    batchDeleteFailed: "批量删除失败",
    batchEnableTitle: "批量启用",
    batchEnableContent: "确定要启用选中的 {count} 个表单吗？",
    batchEnableSuccess: "批量启用成功",
    batchDisableTitle: "批量停用",
    batchDisableContent: "确定要停用选中的 {count} 个表单吗？",
    batchDisableSuccess: "批量停用成功",
    noData: "暂无数据",
    loading: "加载中...",
    totalRecords: "总记录数",
    currentPageRecords: "当前页记录数",
    pleaseSelectForms: "请选择要操作的表单",
    cannotGetCompanyInfo: "无法获取用户的公司信息",
    updateFailed: "更新失败",
    createFailed: "创建失败",
    eformUpdateSuccess: "表单更新成功",
    eformCreateSuccess: "表单创建成功",
    batchEnable: "批量启用",
    batchDisable: "批量停用",
    batchDelete: "批量删除",
    refresh: "刷新",
    eformManagement: "表单管理",
    searchNameDescription: "搜索名称、描述...",
    clearFilter: "清除筛选",
    pageRange: "第 ",
    total: " 项，共 ",
    batchDeleteForms: "批量删除表单",
    cancel: "取消",
    confirmDelete: "确定删除",
    forms: " 个表单",
    batchDeleteWarning: "批量删除警告",
    batchDeleteWarningContent: "您即将删除 ",
    cannotBeUndone: " 个表单，此操作无法撤销。请确认要删除的表单。",
    pleaseConfirm: "请确认要删除的表单",
    batchEnableForms: "批量启用表单",
    batchDisableForms: "批量停用表单",
    confirm: "确定",
    enable: "启用",
    disable: "停用",
    confirmStatusChangeTitle: "确认更改状态",
    confirmStatusChangeContent: "确定要将表单「{name}」的状态更改为「{action}」吗？",
    statusChangeSuccess: "状态更改成功",
    statusChangeFailed: "状态更改失败",
    batchStatusContent: "您即将",
    enableAfter: " 个表单。启用后表单将可以正常使用。",
    disableAfter: " 个表单。停用后表单将无法使用，但可以重新启用。",
    unknownError: "未知错误",
    batchStatusSuccess: "成功",
    batchStatusFailed: "批量操作失败",
    copy: "复制",
    copyForm: "复制表单",
    copyFormInfo: "复制表单信息",
    copyFormContent: "您即将复制表单",
    copyFormContent2: "，复制后将创建一个新的表单副本。",
    newFormName: "新表单名称",
    newFormDescription: "新表单描述",
    pleaseEnterFormName: "请输入表单名称",
    formNameTooLong: "表单名称不能超过100个字符",
    enterNewFormName: "请输入新表单名称",
    enterNewFormDescription: "请输入新表单描述（可选）",
    copySuccess: "复制成功",
    copyFailed: "复制失败"
  },
  
  // EForm Designer
  eformDesigner: {
    title: '表单设计器',
    formInfo: '表单信息',
    formName: '表单名称',
    formDescription: '表单描述',
    formNamePlaceholder: '请输入表单名称',
    formDescriptionPlaceholder: '请输入表单描述',
    uploadFile: '文件上传',
    createFromWordFile: '从 Word 文件建立',
    createFromExcelFile: '从 Excel 文件建立',
    createFromPdfFile: '从 PDF 文件建立',
    uploadImage: '上传图片',
    aiGenerate: 'AI 生成',
    aiGenerateForm: 'AI 生成表单',
    tabBasicInfo: '基本資訊',
    tabFileUpload: '文件上傳',
    tabAIAssistant: 'AI 表單助理',
    aiSmartGeneration: 'AI 智能生成',
    describeTheFormTypeAndRequirements: '描述您需要的表单类型和要求，AI 将为您生成相应的 HTML 表单。适合用于审批流程、申请表单等。',
    requirementsDescription: '需求描述',
    uploadFormImage: '上传表单图片（可选）',
    uploadFormDocumentOptional: '上传 Word/Excel/PDF（可选）',
    clickOrDragDocHere: '点击或拖拽 Word/Excel/PDF 到此处',
    documentConvertedToHtmlForAi: '将依系统设置以 LibreOffice 转为 HTML 或 FODG（Flat ODF XML）供 AI 识别字段，与图片一并分析可获得更准确表单',
    uploadWordExcelPdfOnly: '仅支持 Word (.doc/.docx)、Excel (.xls/.xlsx)、PDF (.pdf)',
    documentSizeLimit: '文件大小不能超过 50MB',
    remove: '移除',
    placeholderExample: '例如：我需要一个请假申请表单，包含员工信息、请假类型、开始日期、结束日期、请假原因等字段...',
    welcomeMessage: '欢迎使用表单设计器',
    
    // Component Editor translations
    editComponent: '编辑组件',
    componentId: '组件 ID',
    editDropdownMenu: '编辑下拉菜单',
    editTextInput: '编辑文字输入框',
    editTextArea: '编辑文字区域',
    editButton: '编辑按钮',
    editRadioButton: '编辑单选按钮',
    editCheckbox: '编辑复选框',
    editLabel: '编辑标签',
    fieldName: '字段名称',
    fieldNamePlaceholder: '请输入字段名称',
    placeholderText: '占位符文字',
    placeholderTextPlaceholder: '请输入占位符文字',
    optionList: '选项列表',
    
    // Common field labels
    defaultValue: '默认值',
    inputType: '输入类型',
    dateFormat: '日期格式',
    rows: '行数',
    columns: '列数',
    buttonText: '按钮文字',
    buttonType: '按钮类型',
    buttonStyle: '按钮样式',
    buttonSize: '按钮大小',
    labelText: '标签文字',
    associatedField: '关联字段',
    labelStyle: '标签样式',
    fontSize: '字体大小',
    requiredField: '必填字段',
    disabled: '禁用',
    requiredLabel: '必填标示',
    
    // Placeholder texts
    pleaseEnterPlaceholderText: '请输入占位符文字',
    pleaseEnterFieldName: '请输入字段名称',
    pleaseEnterDefaultValue: '请输入默认值',
    pleaseEnterDefaultDate: '请输入默认日期',
    pleaseEnterButtonText: '请输入按钮文字',
    pleaseEnterLabelText: '请输入标签文字',
    pleaseEnterAssociatedFieldId: '请输入关联字段的 ID',
    
    // Input type options
    text: '文字',
    email: '电子邮件',
    password: '密码',
    number: '数字',
    currency: '金额',
    phone: '电话',
    url: '网址',
    date: '日期',
    time: '时间',
    file: '文件',
    
    // Button type options
    normalButton: '一般按钮',
    submitButton: '提交按钮',
    resetButton: '重置按钮',
    
    // Button style options
    primaryButton: '主要按钮',
    secondaryButton: '次要按钮',
    successButton: '成功按钮',
    dangerButton: '危险按钮',
    warningButton: '警告按钮',
    infoButton: '信息按钮',
    lightButton: '浅色按钮',
    darkButton: '深色按钮',
    
    // Button size options
    small: '小',
    medium: '中',
    large: '大',
    
    // Label style options
    normal: '一般',
    bold: '粗体',
    italic: '斜体',
    underline: '底线',
    
    // Font size options
    small12px: '小 (12px)',
    medium14px: '中 (14px)',
    large16px: '大 (16px)',
    extraLarge18px: '特大 (18px)',
    
    // Date format options and descriptions
    dateFormatDescription: '选择日期在表单中显示的格式，这将影响用户看到的日期样式',
    selectedFormat: '选择的格式: {format}',
    formatPreview: '格式预览: {preview}',
    tip: '提示: 格式设置会影响 WYSIWYG 编辑器中的显示效果',
    pleaseEnterDefaultValueAccordingToDateFormat: '请根据选择的日期格式输入默认值，例如: {example}',
    
    // GrapesJS component default content
    pleaseEnterYourMessage: '请输入您的消息',
    pleaseSelect: '请选择...',
    option1: '选项 1',
    option2: '选项 2',
    option3: '选项 3',
    pleaseEnterEmail: '请输入电子邮件',
    pleaseEnterPassword: '请输入密码',
    pleaseEnterNumber: '请输入数字',
    pleaseEnterCurrencyAmount: '请输入金额',
    pleaseEnterUrl: '请输入网址',
    pleaseEnterPhoneNumber: '请输入电话号码',
    
    // Table Cell Editor translations
    editTableCell: '编辑表格单元格',
    editTableHeader: '编辑表格标题',
    cellContent: '单元格内容',
    pleaseEnterCellContent: '请输入单元格内容...',

    // Text Block (文字元素) Editor
    editTextBlock: '编辑文字',
    textContent: '文字内容',
    pleaseEnterTextContent: '请输入文字内容',
    textAlign: '对齐方式',
    textAlignLeft: '靠左',
    textAlignCenter: '居中',
    textAlignRight: '靠右',
    textAlignJustify: '两端对齐',
    fontFamily: '字体',
    fontStyle: '字体样式',
    boldItalic: '粗体+斜体',
    fontSize20px: '20px',
    fontSize24px: '24px',
    
    // Image Editor translations
    editImage: '编辑图片',
    imageUrl: '图片 URL',
    pleaseEnterImageUrl: '请输入图片 URL',
    imageUploadHint: '点击上传按钮选择图片文件，或直接在 URL 字段输入图片地址',
    altText: '替代文字',
    pleaseEnterAltText: '请输入替代文字',
    imageWidth: '图片宽度',
    pleaseEnterWidth: '请输入宽度（如：100px 或 50%）',
    imageWidthHint: '可输入像素值（如：100px）或百分比（如：50%）',
    imageHeight: '图片高度',
    pleaseEnterHeight: '请输入高度（如：100px 或 50%）',
    imageHeightHint: '可输入像素值（如：100px）或百分比（如：50%）',
    imagePreview: '图片预览',
    uploadImage: '上传图片',
    labelText: '标签文字',
    groupTitle: '群组标题',
    groupInputField: '群组内输入框',
    unknown: '未知',
    optionValue: '选项值',
    optionText: '选项文字',
    delete: '删除',
    addOption: '+ 添加选项',
    requiredField: '必填字段',
    disabled: '禁用',
    readonly: '只读',
    buttonText: '按钮文字',
    buttonTextPlaceholder: '请输入按钮文字',
    buttonType: '按钮类型',
    buttonStyle: '按钮样式',
    buttonSize: '按钮大小',
    generalButton: '一般按钮',
    submitButton: '提交按钮',
    resetButton: '重置按钮',
    primaryButton: '主要按钮',
    secondaryButton: '次要按钮',
    successButton: '成功按钮',
    dangerButton: '危险按钮',
    warningButton: '警告按钮',
    infoButton: '信息按钮',
    lightButton: '浅色按钮',
    darkButton: '深色按钮',
    smallSize: '小尺寸',
    mediumSize: '中尺寸',
    largeSize: '大尺寸',
    labelText: '标签文字',
    labelTextPlaceholder: '请输入标签文字',
    defaultValue: '默认值',
    defaultValuePlaceholder: '请输入默认值',
    rows: '行数',
    cols: '列数',
    maxLength: '最大长度',
    minLength: '最小长度',
    inputType: '输入类型',
    text: '文字',
    email: '电子邮件',
    password: '密码',
    number: '数字',
    currency: '金额',
    tel: '电话',
    url: '网址',
    date: '日期',
    time: '时间',
    datetime: '日期时间',
    dateFormat: '日期格式',
    dateFormatPlaceholder: '选择日期格式',
    checkboxText: '复选框文字',
    checkboxTextPlaceholder: '请输入复选框文字',
    welcomeDescription: '请从左侧面板拖拽组件到此处开始设计您的表单。',
    pleaseDragComponents: '请拖拽组件到此处开始设计您的表单',
    exampleInput: '示例输入框',
    exampleInputLabel: '示例输入字段',
    exampleInputPlaceholder: '请输入...',
    pleaseEnter: '请输入内容',
    newForm: '新表单',
    saveForm: '保存表单',
    formSaved: '表单已保存',
    saveFailed: '保存失败',
    grapesJsInitializationFailed: 'GrapesJS 初始化失败',
    uploadWord: '上传 Word 文件',
    uploadExcel: '上传 Excel 文件',
    uploadPdf: '上传 PDF 文件',
    uploadImage: '上传图片',
    aiGenerate: 'AI 生成表单',
    aiPrompt: '请描述您想要的表单',
    generating: '生成中...',
    generationFailed: '生成失败',
    wordUploadSuccess: 'Word 文件转换成功',
    excelUploadSuccess: 'Excel 文件转换成功',
    pdfUploadSuccess: 'PDF 文件转换成功',
    imageUploadSuccess: '图片上传成功',
    uploadFailed: '上传失败',
    fileTooLarge: '文件太大',
    unsupportedFormat: '不支持的格式',
    includeCurrentHtml: '包含当前 HTML 内容',
    aiProvider: 'AI 提供商',
    aiProviderPlaceholder: '选择要使用的 AI 提供商',
    aiProviderRequired: '请选择一个 AI 提供商',
    loadAiProvidersFailed: '无法加载 AI 提供商，请稍后再试',
    aiProvider: 'AI 提供商',
    aiProviderPlaceholder: '选择要使用的 AI 提供商',
    aiProviderRequired: '请选择一个 AI 提供商',
    loadAiProvidersFailed: '无法加载 AI 提供商，请稍后再试',
    sendDefaultSystemPrompt: '传送系统预设 prompt',
    modifySystemPrompt: '修改系统预设 prompt',
    loadDefaultPromptFailed: '无法载入预设系统 prompt',
    loadingDefaultPrompt: '载入预设中...',
    systemPromptPlaceholder: '系统预设 prompt（可编辑）',
    aiFormAssistant: 'AI 表单助理',
    chatEmptyHint: '输入需求或上传图片/文件，AI 将协助生成或修改表单',
    chatSaveFailed: '对话纪录储存失败',
    chatSaveHintNewForm: '储存表单后，对话纪录将写入',
    restoreToThisVersion: '还原到此版本',
    restoredToThisVersion: '已还原到此版本',
    uploadedImage: '已上传图片',
    uploadImage: '图片',
    uploadDoc: 'Word/PDF',
    aiFormUpdatedSuccess: '已根据您的要求更新表单',
    advancedOptions: '进阶选项',
    formStyle: '表单风格',
    formStyleUi: '操作式 UI',
    formStylePrint: '可打印文件',
    formStylePrintHint: '适合上传图片/PDF/Word，尽量 1:1 还原原始文件版面',
    pleaseUploadImage: '请上传图片文件',
    imageSizeLimit: '图片大小不能超过 10MB',
    toolbarCollapse: '收合工具栏',
    toolbarExpand: '展开工具栏',
    viewCode: '查看代码',
    viewPreview: '预览',
    backToList: '返回列表',
    wordFileConvertedSuccess: 'Word 文件转换成功',
    excelFileConvertedSuccess: 'Excel 文件转换成功',
    pdfFileConvertedSuccess: 'PDF 文件转换成功',
    conversionFailed: '转换失败',
    unknownError: '未知错误',
    requestTimeoutWordFileConversion: 'Word 文件转换请求超时',
    requestTimeoutExcelFileConversion: 'Excel 文件转换请求超时',
    requestTimeoutPdfFileConversion: 'PDF 文件转换请求超时',
    requestTimeoutImageUpload: '图片上传请求超时',
    requestTimeoutAiGeneration: 'AI 生成请求超时',
    requestTimeoutPleaseTryAgain: '请求超时，请重试',
    pleaseTryAgainLaterOrCheckNetworkConnection: '，请稍后重试或检查网络连接',
    pleaseEnterYourRequirements: '请输入您的需求',
    aiFormGeneratedSuccess: 'AI 表单生成成功',
    aiGeneratedForm: 'AI 生成表单',
    pleaseWriteFormContent: '请编写表单内容',
    pleaseEnterFormName: '请输入表单名称',
    formSavedSuccessfully: '表单保存成功',
    formSavedToLocalStorage: '表单已保存到本地存储',
    saveFailed: '保存失败',
    expandToolbar: '展开工具栏',
    back: '返回',
    saving: '保存中...',
    saveDesign: '保存设计',
    aiGenerateForm: 'AI 生成表单',
    createFromWordFile: '从 Word 文件建立',
    createFromExcelFile: '从 Excel 文件建立',
    createFromPdfFile: '从 PDF 文件建立',
    createFromImageFile: '从图片建立',
    viewDesign: '查看设计',
    viewCode: '查看代码',
    formName: '表单名称',
    formDescription: '表单描述',
    formNamePlaceholder: '请输入表单名称',
    formDescriptionPlaceholder: '请输入表单描述（可选）',
    uploadFile: '上传文件',
    exportImport: '导出 / 导入',
    exportHtml: '导出 HTML',
    importHtml: '导入 HTML',
    exportSuccess: '已导出 HTML 文件',
    importSuccess: '已导入 HTML',
    importFailed: '导入失败',
    dragAndDropOrClick: '拖拽文件到此处或点击上传',
    selectFile: '选择文件',
    upload: '上传',
    cancel: '取消',
    close: '关闭',
    generate: '生成',
    promptPlaceholder: '请描述您想要的表单，例如：一个包含姓名、电话、地址的联系表单',
    includeCurrentContent: '包含当前内容',
    yes: '是',
    no: '否',
    loading: '加载中...',
    error: '错误',
    success: '成功',
    warning: '警告',
    info: '信息',
    
    // GrapesJS 编辑器界面元素翻译
    grapesJs: {
      // 左侧 Blocks 面板
      blocks: '组件',
      layout: '布局',
      basic: '基本',
      forms: '表单',
      section: '区块',
      div: '分区',
      container: '容器',
      text: '文字',
      heading: '标题',
      paragraph: '段落',
      form: '表单',
      input: '输入框',
      button: '按钮',
      textarea: '文字区域',
      select: '下拉菜单',
      radio: '单选框',
      checkbox: '复选框',
      fileUpload: '文件上传',
      email: '电子邮件',
      password: '密码',
      number: '数字',
      date: '日期',
      time: '时间',
      url: '网址',
      tel: '电话',
      label: '标签',
      fieldset: '字段组',
      
      // 右侧面板
      layers: '图层',
      styles: '样式',
      traits: '属性',
      settings: '设置',
      tableConfig: '表格设置',
      selectParentTable: '选中整个表格',
      tableColWidths: '列宽设置:',
      tableColWidthValue: '宽度（留空为自动）',
      tableColWidthUnit: '单位',
      tableColLabel: '列',
      tableColWidthAuto: '自动',
      
      // 工具栏
      viewCode: '查看代码',
      preview: '预览',
      fullscreen: '全屏',
      undo: '撤销',
      redo: '重做',
      clear: '清除',
      export: '导出',
      import: '导入',
      
      // 属性面板
      id: 'ID',
      class: 'CSS 类',
      style: '样式',
      attributes: '属性',
      content: '内容',
      placeholder: '默认文字',
      required: '必填',
      disabled: '禁用',
      readonly: '只读',
      maxlength: '最大长度',
      minlength: '最小长度',
      pattern: '格式',
      title: '标题',
      alt: '替代文字',
      src: '来源',
      href: '链接',
      target: '目标',
      rel: '关联',
      
      // 样式面板
      dimensions: '尺寸',
      positioning: '定位',
      typography: '字体',
      background: '背景',
      border: '边框',
      effects: '效果',
      extra: '其他',
      
      // 通用
      width: '宽度',
      height: '高度',
      margin: '外边距',
      padding: '内边距',
      borderWidth: '边框宽度',
      borderStyle: '边框样式',
      borderColor: '边框颜色',
      borderRadius: '圆角',
      borderCollapse: '边框合并',
      backgroundColor: '背景颜色',
      color: '文字颜色',
      fontSize: '字体大小',
      fontWeight: '字体粗细',
      fontFamily: '字体',
      textAlign: '文字对齐',
      lineHeight: '行高',
      letterSpacing: '字距',
      textDecoration: '文字装饰',
      opacity: '透明度',
      boxShadow: '阴影',
      transform: '变形',
      
      // 提示消息
      dragToAdd: '拖拽到此处添加',
      clickToEdit: '点击编辑',
      doubleClickToEdit: '双击编辑',
      selectComponent: '选择组件',
      deleteComponent: '删除组件',
      copyComponent: '复制组件',
      pasteComponent: '粘贴组件',
      moveUp: '上移',
      moveDown: '下移',
      moveLeft: '左移',
      moveRight: '右移',
      
      // 编辑提示
      editTip: '请点击组件上方的编辑按钮来修改此输入框的属性。',
      deselectTip: '按 ESC 键或点击空白区域取消选中',
      
      // 设备视图
      device: '设备',
      desktop: '桌面',
      tablet: '平板',
      mobileLandscape: '手机横向',
      mobilePortrait: '手机直向',
      
      // 工具栏提示
      viewComponents: '查看组件',
      preview: '预览',
      fullscreen: '全屏',
      viewCode: '查看代码',
      
      // 样式面板详细
      classes: '类别',
      general: '通用',
      display: '显示',
      float: '浮动',
      position: '定位',
      top: '上',
      right: '右',
      left: '左',
      bottom: '下',
      none: '无',
      block: '区块',
      inline: '行内',
      inlineBlock: '行内区块',
      flex: '弹性',
      grid: '网格',
      static: '静态',
      relative: '相对',
      absolute: '绝对',
      fixed: '固定',
      auto: '自动',
      
      // 状态和选择
      state: '状态',
      selected: '已选中',
      componentSet: '组件集合',
      
      // 其他界面元素
      add: '添加',
      remove: '移除',
      close: '关闭',
      open: '打开',
      expand: '展开',
      collapse: '收合',
      refresh: '刷新',
      loading: '加载中...',
      error: '错误',
      success: '成功',
      warning: '警告',
      info: '信息'
    },
    
    // 上传相关翻译
    upload: {
      authTokenNotFound: '未找到认证 token，请重新登入'
    },
    
    // 字段显示设定相关翻译
    fieldDisplaySetting: {
      modalTitle: '表单字段显示设定',
      tableColumns: {
        fieldType: '字段类型',
        originalLabel: '原始标签',
        displayLabel: '显示标签',
        showInList: '在列表中显示',
        fieldId: '字段ID',
        actions: '操作'
      },
      placeholders: {
        displayLabel: '输入显示标签',
        jsonKey: '输入 JSON Key'
      },
      actions: {
        moveUp: '上移',
        moveDown: '下移',
        addJsonRow: '新增 JSON 子列',
        convertToJson: '转为 JSON 模式',
        removeJsonRow: '移除 JSON 子列'
      },
      buttons: {
        cancel: '取消',
        confirm: '确定'
      },
      helperText: '系统已自动扫描表单中的所有输入字段，您可以自定义显示标签、调整顺序，并选择是否在列表中显示。对 JSON 类型字段可加入多个 JSON Key 子列。',
      helperTextNoJson: '系统已自动扫描表单中的所有输入字段，您可以自定义显示标签、调整顺序，并选择是否在列表中显示。',
      messages: {
        saveSuccess: '字段显示设定已保存',
        saveFailed: '保存失败: ',
        unnamedField: '未命名字段',
        noFieldsFound: '未找到表单字段'
      }
    }
  },
  
  // EForm Instance 相关
  eformInstance: {
    title: "表单实例",
    status: "状态",
    submittedAt: "提交时间",
    approvedAt: "核准时间",
    rejectedAt: "拒绝时间",
    approvedBy: "核准人",
    rejectedBy: "拒绝人",
    approvalNote: "核准备注",
    rejectNote: "拒绝备注",
    approve: "核准",
    reject: "拒绝",
    back: "返回",
    loading: "加载中...",
    error: "错误",
    noData: "暂无数据",
    pending: "待处理",
    approved: "已核准",
    rejected: "已拒绝",
    confirmApprove: "确定要核准这个表单吗？",
    confirmReject: "确定要拒绝这个表单吗？",
    approveSuccess: "核准成功",
    rejectSuccess: "拒绝成功",
    approveFailed: "核准失败",
    rejectFailed: "拒绝失败",
    noteRequired: "请输入备注",
    loginRequired: "请先登录",
    loginExpired: "登录已过期，请重新登录",
    fetchFailed: "获取表单实例失败",
    formApproved: "表单已批准",
    formRejected: "表单已拒绝",
    pendingApproval: "待审批",
    formInstanceNotFound: "找不到表单实例",
    formInfo: "表单信息",
    instanceName: "实例名称",
    createdAt: "创建时间",
    userInput: "用户输入",
    approver: "审批人",
    approvalTime: "审批时间",
    formContent: "表单内容",
    approveForm: "批准表单",
    cancel: "取消",
    confirmApprove: "确定批准",
    confirmApproveForm: "您确定要批准这个表单吗？",
    approvalNotePlaceholder: "审批备注（可选）",
    rejectForm: "拒绝表单",
    confirmReject: "确定拒绝",
    confirmRejectForm: "您确定要拒绝这个表单吗？",
    rejectReasonPlaceholder: "拒绝原因（可选）",
    rejectionReasonRequired: "请输入拒绝原因",
    receivedMedia: "已接收的媒体"
  },

  eformValidation: {
    pleaseFillRequiredFields: "请填写所有必填字段",
    pleaseFillField: "请填写「{field}」",
    pleaseUploadField: "请上传「{field}」",
    pleaseCheckField: "请勾选「{field}」",
    pleaseSelectField: "请选择「{field}」"
  },
  
  // WhatsApp Template 相关
  whatsappTemplate: {
    title: "消息模板管理",
    name: "名称",
    description: "描述",
    category: "分类",
    status: "状态",
    type: "类型",
    createdAt: "建立时间",
    updatedAt: "更新时间",
    action: "操作",
    add: "新增模板",
    edit: "编辑",
    delete: "删除",
    copy: "复制",
    preview: "预览",
    import: "导入",
    search: "搜索",
    searchPlaceholder: "搜索模板名称、描述...",
    enabled: "启用",
    disabled: "停用",
    draft: "草稿",
    text: "文字",
    image: "图片",
    video: "视频",
    audio: "音频",
    document: "文档",
    location: "位置",
    contact: "联系人",
    interactive: "交互式",
    button: "按钮",
    list: "列表",
    confirmDeleteTitle: "确定要删除这个模板吗？",
    confirmDeleteContent: "此操作无法撤销",
    confirmDeleteOk: "确定",
    confirmDeleteCancel: "取消",
    deleteSuccess: "删除成功",
    deleteFailed: "删除失败",
    copySuccess: "复制成功",
    copyFailed: "复制失败",
    saveSuccess: "保存成功",
    saveFailed: "保存失败",
    importSuccess: "导入成功",
    importFailed: "导入失败",
    batchDeleteTitle: "批量删除",
    batchDeleteContent: "确定要删除选中的 {count} 个模板吗？",
    batchDeleteSuccess: "批量删除成功",
    batchDeleteFailed: "批量删除失败",
    noData: "暂无数据",
    loading: "加载中...",
    totalRecords: "总记录数",
    currentPageRecords: "当前页记录数",
    messageContent: "消息内容",
    mediaUrl: "媒体网址",
    caption: "标题",
    latitude: "纬度",
    longitude: "经度",
    address: "地址",
    phoneNumber: "电话号码",
    displayName: "显示名称",
    buttonText: "按钮文字",
    buttonType: "按钮类型",
    listTitle: "列表标题",
    listDescription: "列表描述",
    listItems: "列表项目",
    variables: "变量",
    addVariable: "新增变量",
    variableName: "变量名称",
    variableValue: "变量值",
    removeVariable: "移除变量",
    metaTemplates: "Meta 模板",
    importFromMeta: "从 Meta 导入",
    createMetaTemplate: "建立 Meta 模板",
    deleteMetaTemplate: "删除 Meta 模板",
    metaTemplateName: "Meta 模板名称",
    metaTemplateCategory: "Meta 模板分类",
    customName: "自定义名称",
    filterAll: "全部",
    filterEnabled: "启用",
    filterDisabled: "停用",
    templateName: "模板名称",
    templateDescription: "模板描述",
    templateType: "模板类型",
    templateStatus: "模板状态",
    templateLanguage: "模板语言",
    templateVersion: "模板版本",
    templateUpdateTime: "模板更新时间",
    templateOperation: "模板操作",
    templatePreview: "模板预览",
    templateEdit: "模板编辑",
    templateCopy: "模板复制",
    templateDelete: "模板删除",
    templateDeleteMeta: "删除 Meta 模板",
    templateDeleteConfirm: "确定要从 Meta 删除这个模板吗？",
    templateDeleteConfirmLocal: "确定要删除这个模板吗？",
    templateConfirm: "确定",
    templateCancel: "取消",
    templateBatchDelete: "批量删除",
    templateBatchDeleteConfirm: "确定要删除选中的 {count} 个模板吗？此操作无法撤销。",
    templateBatchDeleteConfirmCount: "确定要删除选中的",
    templateBatchDeleteConfirmSuffix: "个模板吗？此操作无法撤销。",
    templateBatchDeleteOk: "确定删除",
    templateBatchDeleteCancel: "取消",
    templateAdd: "新增模板",
    templateEditTitle: "编辑模板",
    templateAddTitle: "新增模板",
    templateSave: "保存",
    templateCancel: "取消",
    templateNameRequired: "请输入模板名称",
    templateNamePlaceholder: "请输入模板名称",
    templateDescriptionPlaceholder: "请输入模板描述",
    templateCategoryRequired: "请选择分类",
    templateCategoryPlaceholder: "请选择分类",
    templateTypeRequired: "请选择模板类型",
    templateTypePlaceholder: "请选择模板类型",
    templateStatusRequired: "请选择状态",
    templateStatusPlaceholder: "请选择状态",
    templateLanguageRequired: "请选择语言",
    templateLanguagePlaceholder: "请选择语言",
    templateMessageContent: "消息内容",
    templateMessageContentRequired: "请输入消息内容",
    templateMessageContentPlaceholder: "请输入消息内容，可使用 {{变量名}} 格式插入变量",
    templateMediaType: "媒体类型",
    templateMediaTypeRequired: "请选择媒体类型",
    templateMediaUrl: "媒体文件 URL",
    templateMediaUrlRequired: "请输入媒体文件 URL",
    templateMediaUrlPlaceholder: "请输入媒体文件 URL",
    templateMediaCaption: "媒体说明",
    templateMediaCaptionPlaceholder: "请输入媒体说明（可选）",
    templateInteractiveType: "交互类型",
    templateInteractiveTypeRequired: "请选择交互类型",
    templateHeader: "标题",
    templateHeaderPlaceholder: "请输入标题（可选）",
    templateBody: "主要内容",
    templateBodyRequired: "请输入主要内容",
    templateBodyPlaceholder: "请输入主要内容",
    templateFooter: "底部文字",
    templateFooterPlaceholder: "请输入底部文字（可选）",
    templateLatitude: "纬度",
    templateLatitudeRequired: "请输入纬度",
    templateLatitudePlaceholder: "请输入纬度",
    templateLongitude: "经度",
    templateLongitudeRequired: "请输入经度",
    templateLongitudePlaceholder: "请输入经度",
    templateLocationName: "位置名称",
    templateLocationNameRequired: "请输入位置名称",
    templateLocationNamePlaceholder: "请输入位置名称",
    templateLocationAddress: "地址",
    templateLocationAddressRequired: "请输入地址",
    templateLocationAddressPlaceholder: "请输入完整地址",
    templateContactName: "联系人姓名",
    templateContactNameRequired: "请输入联系人姓名",
    templateContactNamePlaceholder: "请输入联系人姓名",
    templateContactPhone: "联系人电话",
    templateContactPhoneRequired: "请输入联系人电话",
    templateContactPhonePlaceholder: "请输入联系人电话",
    templateContactEmail: "联系人 Email",
    templateContactEmailPlaceholder: "请输入联系人 Email（可选）",
    templateVariables: "变量设置",
    templateVariableName: "变量名称",
    templateVariableNamePlaceholder: "变量名称",
    templateVariableType: "类型",
    templateVariableTypePlaceholder: "类型",
    templateVariableDescription: "描述",
    templateVariableDescriptionPlaceholder: "描述",
    templateVariableRequired: "必填",
    templateAddVariable: "添加变量",
    templateFromMetaImport: "从 Meta 导入",
    templateBatchDelete: "批量删除",
    templateWhatsAppMessageTemplateManagement: "WhatsApp 消息模板管理",
    templateSearchPlaceholder: "搜索模板名称、描述或分类",
    templateCategorySelect: "选择分类",
    templateStatusSelect: "选择状态",
    templateClearFilter: "清除筛选",
    templatePageRange: "第",
    templatePageTotal: "项，共",
    templatePageItems: "项",
    templateBasicInfo: "基本信息",
    templateContent: "模板内容",
    templateVariableDefinition: "变量定义",
    templateWelcome: "欢迎",
    templateOrder: "订单",
    templateMarketing: "营销",
    templateSupport: "客服",
    templateGeneral: "一般",
    templateMedia: "媒体",
    templateInteractive: "交互",
    templateLocation: "位置",
    templateContact: "联系人",
    templateActive: "启用",
    templateInactive: "停用",
    templateDraft: "草稿",
    templateTraditionalChinese: "繁体中文",
    templateSimplifiedChinese: "简体中文",
    templateEnglish: "English",
    templateString: "文字",
    templateNumber: "数字",
    templateDate: "日期",
    templateID: "ID",
    templateRefreshMetaTemplates: "刷新 Meta 模板",
    templateImportFromMeta: "从 Meta 导入模板",
    templateImport: "导入",
    templateGetMetaTemplatesFailed: "获取 Meta 模板失败",
    templateImportSuccess: "模板导入成功",
    templateImportFailed: "导入失败",
    templateCreateMetaTemplateSuccess: "Meta 模板创建成功",
    templateCreateFailed: "创建失败",
    templateDeleteMetaTemplateSuccess: "Meta 模板删除成功",
    templateDeleteFailed: "删除失败",
    templateGetTemplateListFailed: "获取模板列表失败",
    templatePleaseSelectTemplates: "请选择要删除的模板",
    templateSuccessDelete: "成功删除",
    templateTemplates: "个模板",
    templateDeleteSuccess: "模板删除成功",
    templateUpdateSuccess: "模板更新成功",
    templateUpdateFailed: "更新失败",
    templateCreateSuccess: "模板创建成功",
    templateCreateFailed: "创建失败",
    templateSaveFailed: "保存模板失败",
    templateParseContentFailed: "解析模板内容失败",
    templateConfirmDeleteSelected: "确定要删除选中的",
    templateConfirmDeleteSelectedSuffix: "个模板吗？此操作无法撤销。"
  },
  
  // WhatsApp Workflow Designer
  workflowDesigner: {
    title: '工作流程设计器',
    workflowInfo: '工作流程信息',
    workflowName: '工作流程名称',
    workflowDescription: '工作流程描述',
    workflowNamePlaceholder: '请输入工作流程名称',
    workflowDescriptionPlaceholder: '请输入工作流程描述',
    nodeTypes: '节点类型',
    loadingNodeTypes: '加载节点类型中...',
    nodeConfiguration: '节点配置',
    connection: '连线',
    node: '节点',
    flow: '流程',
    startNode: '开始节点',
    endNode: '结束节点',
    waitReplyNode: '等待回复节点',
    waitForEmailReplyNode: '等待 Email 回复节点',
    waitForEmailReplyAutoCompleteTitle: '超时自动完成（仅 Wait for Email Reply）',
    waitForEmailReplyAutoCompleteEnable: '启用超时自动完成',
    waitForEmailReplyAutoCompleteTimeout: '自动完成超时时间',
    sendMessageNode: '发送 Message 节点',
    sendTemplateNode: '发送模板节点',
    shoppingCartNode: 'WhatsApp 购物车',
    sendInstitutionOrderingCartNode: '机构订购购物车',
    institutionOrderingCartNode: '机构订购购物车',
    chatOrderingCartNode: '聊天购物车',
    chatBotNode: '聊天机器人',
    chatBotInitialGreeting: '开场白',
    chatBotInitialGreetingPlaceholder: '例如：您好！有什么可以帮到您？',
    chatBotGreetingEnabled: '发送开场白',
    chatBotGreetingEnabledHelp: '关闭后，进入等待状态时不会发送开场白消息。适合用户一开始就会直接发送照片或消息的流程。',
    chatBotEndKeywords: '以相似关键字结束对话',
    chatBotEndKeywordsPlaceholder: '按 Enter 加入参考短语。系统会用 AI 比对语义（例：再见、谢谢、不用了、stop）',
    chatBotEndMessageEnabled: '发送结束语',
    chatBotEndMessageEnabledHelp: '关闭后，对话结束时不会发送任何结束消息（包括系统默认及超时消息）。',
    chatBotEndMessage: '对话结束语',
    chatBotEndMessageHelp: '当用户触发结束关键字或对话闲置超时自动完成时，发送此消息给用户。留空则使用系统默认结束语。',
    chatBotEndMessagePlaceholder: '例如：感谢您的查询，如有需要欢迎再联系我们。',
    chatBotRagAdditionalQuery: 'RAG 附加查询',
    chatBotRagAdditionalQueryHelp: '每次查询知识库时，将此文字附加到用户消息后一起送给 RAG 引擎，可提升特定知识库 chunk（如身份对照表）的命中率。留空则只用用户消息查询。',
    chatBotRagAdditionalQueryPlaceholder: '例如：身份识别 用户资料 租户',
    chatBotAdditionalPrompt: 'Additional Prompt',
    chatBotAdditionalPromptHelp: '追加到 Chat Bot 默认 system prompt，不会取代 appsettings 的 system prompt。',
    chatBotAdditionalPromptPlaceholder: '输入额外行为或回答风格指示，例如：请用简短条列回答。',
    chatBotSystemPromptOverride: 'System Prompt 覆写',
    chatBotSystemPromptOverridePlaceholder: '留空使用 appsettings 默认',
    chatOrderingCartTargetCompany: '目标公司',
    chatOrderingCartProductLanguage: '商品语言',
    chatOrderingCartInitialGreeting: '开场白',
    chatOrderingCartInitialGreetingPlaceholder: '例如：您好！请告诉我您要订什么～',
    chatOrderingCartReconfirmQuestion: '追问语句',
    chatOrderingCartReconfirmQuestionPlaceholder: '例如：还有什么需要的吗？',
    chatOrderingCartMissingInfoExtra: '缺漏信息时追加提示',
    chatOrderingCartAdditionalPrompt: 'Additional Prompt',
    chatOrderingCartAdditionalPromptHelp: '追加到聊天购物车默认 system prompt，不会取代 appsettings 的 system prompt。',
    chatOrderingCartAdditionalPromptPlaceholder: '输入额外下单规则或回答风格指示，例如：地址、电话、金额必须逐字复制。',
    chatOrderingCartEndKeywords: '以相似关键字结束对话',
    chatOrderingCartEndKeywordsPlaceholder: '按 Enter 加入参考短语（中英皆可）。系统会用 AI 比对语义，与下列相近即视为放弃下单／结束对话（例：取消、不订了、cancel、stop ordering）',
    chatOrderingCartBtnConfirmLabel: '确认按钮文字',
    chatOrderingCartBtnModifyLabel: '修改按钮文字',
    chatOrderingCartBtnCancelLabel: '取消按钮文字',
    chatOrderingCartSystemPromptOverride: 'System Prompt 覆写',
    chatOrderingCartSystemPromptOverridePlaceholder: '留空使用 appsettings 默认',
    chatOrderingCartContactAndAnonymous: '联络人与匿名',
    chatOrderingCartAllowAnonymousOrder: '允许匿名下单',
    chatOrderingCartAllowAnonymousOrderHelp: '开启时，即使 WhatsApp 号码未连结到联络人，也可下单（CustomerId 留空并标记为匿名）。关闭时，必须在 PWA 联络人设定中将 WhatsApp 号码授权至少 1 个客户。',
    conditionNode: '条件节点',
    formNode: '表单节点',
    webhookNode: 'Webhook 节点',
    callApiNode: '触发外部 API 节点',
    dataSetQueryNode: 'DataSet 查询节点',
    eFormResultNode: '表单结果节点',
    taskName: '任务名称',
    taskNamePlaceholder: '请输入任务名称',
    description: '描述',
    descriptionPlaceholder: '请输入描述（可选）',
    assignTo: '指定给',
    assignToPlaceholder: '请选择指定人员',
    messageContent: '消息内容',
    messageContentPlaceholder: '请输入消息内容',
    condition: '条件',
    conditionPlaceholder: '请输入条件',
    formSelection: '表单选择',
    formSelectionPlaceholder: '请选择表单',
    webhookUrl: 'Webhook URL',
    webhookUrlPlaceholder: '请输入 Webhook URL',
    save: '保存',
    saveSuccess: '工作流程已保存！',
    saveFailed: '保存失败',
    validationErrors: '验证错误',
    validationWarnings: '验证警告',
    mustHaveStartEnd: '工作流程必须包含开始和结束节点',
    mustHaveConnection: '请建立节点连线',
    hasCycle: '发现循环连接',
    isolatedNode: '发现孤立节点',
    startNodeNoOutput: '开始节点没有输出连接',
    endNodeNoInput: '结束节点没有输入连接',
    cannotConnectToSelf: '不能连接节点到自己',
    connectionAlreadyExists: '节点之间已经存在连接',
    workflowValidationFailed: '工作流程验证失败',
    workflowValidationWarning: '工作流程警告',
    continueSave: '是否继续保存？',
    back: '返回',
    design: '设计',
    copy: '复制',
    delete: '删除',
    confirmDelete: '确定要删除此工作流程吗？',
    copySuccess: '已复制工作流程',
    deleteSuccess: '已删除工作流程',
    deleteFailed: '删除失败',
    copyFailed: '复制失败',
    nameRequired: '请输入工作流程名称',
    descriptionRequired: '请输入工作流程描述',
    
    // 按钮和操作
    delete: '删除',
    clear: '清除',
    selectUser: '选择用户',
    selectPerson: '选择人员',
    selectForm: '选择表单',
    selectTemplate: '选择模板',
    
    // 表单标签和提示
    taskNameLabel: '任务名称',
    taskNamePlaceholder: '输入任务名称',
    phoneNumberPlaceholder: '输入电话号码 (例如: 85296366318) 或点击选择用户',
    selectSpecifiedPerson: '选择指定人员',
    waitReplyMessagePlaceholder: '输入等待用户回复时的提示消息',
    selectEFormPlaceholder: '选择要发送的 e-Form',
    
    // 节点配置
    replyType: '回复类型',
    initiator: '流程启动人',
    specifiedPerson: '指定人员',
    promptMessage: '提示消息',
    promptMessageHelp: '在用户输入前，系统会发送以下消息提醒用户需要输入',
    validationConfig: '验证配置',
    validationSettings: '验证设置',
    validatorActiveLabel: '验证状态',
    active: '启用',
    inactive: '停用',
    enableValidation: '启用验证',
    yes: '是',
    no: '否',
    validatorType: '验证器类型',
    defaultValidator: '预设验证器',
    customValidator: '自定义验证器',
    aiValidator: 'AI 验证',
    timeValidatorLabel: '时间验证器（无回应提醒）',
    timeoutCompleteValidatorLabel: 'Auto Complete 验证器',
    promptText: '提示文字',
    promptTextPlaceholder: '描述有效回复需要满足的条件，例如"用户必须提供 6 位数字验证码"。',
    retryMessage: '提醒消息',
    retryMessagePlaceholder: '输入当用户回复不符合要求时要发送的提示内容。',
    maxRetries: '最大提醒次数',
    minutes: '分钟',
    days: '天',
    hours: '小时',
    validationAiProvider: 'AI 提供商',
    validationAiProviderPlaceholder: '选择用于验证用户回复的 AI 提供商',
    validationAiProviderRequired: '请选择用于验证的 AI 提供商',
    voiceProviderKey: '语音转文字 Provider',
    voiceProviderKeyPlaceholder: '留空则使用公司预设语音 AI',
    aiStaffLabel: 'AI 员工',
    aiStaffPlaceholder: '选择 AI 员工（可选）',
    aiStaffHelp: '选定后，AI 调用将以该员工的角色、技能和个性执行任务',
    aiStaffUseMemory: '使用 AI 员工全局记忆',
    aiStaffUseMemoryHelp: '开启时，AI 员工的历史工作记忆（MemoryMd）会注入 system prompt；关闭则只使用角色设定，不带入过去记忆。',
    validationAiResultVariable: 'AI 结果流程变量',
    validationAiResultVariablePlaceholder: '选择要保存 AI 结果的流程变量',
    validationAiResultVariableHelp: 'AI 解析完成后会将结果写入该流程变量，供后续节点使用。',
    validationAiSuggestionVariable: 'AI 建议流程变量',
    validationAiSuggestionVariablePlaceholder: '选择要保存 AI 建议文字的流程变量',
    validationAiSuggestionVariableHelp: '验证成功且 AI 返回 suggestion 时，会写入此流程变量。仅可选择 text 或 string 类型（非 json）。',
    validationAiFailReasonVariable: 'AI 失败原因流程变量',
    validationAiFailReasonVariablePlaceholder: '选择要保存 AI 失败原因的流程变量',
    validationAiFailReasonVariableHelp: '验证失败时，会将 AI 响应中解析出的 reason（若无则为错误信息）写入此流程变量。仅可选择 text 或 string 类型（非 json）。',
    aiProviderInactive: '未启用',
    aiProviderNotConfigured: '尚未配置 AI 提供商，请到 API 管理页面新增。',
    aiProviderLoadFailed: '无法载入 AI 提供商列表',
    
    // Time Validator 相关翻译
    timeValidator: {
      retryInterval: '提醒间隔',
      retryIntervalHelp: '用户在此时间内没有回应，系统将自动重新发送提醒消息',
      retryLimit: '提醒次数上限',
      retryMessage: '提醒消息设置',
      escalation: '升级通知设置',
      configureRetryMessage: '设置提醒消息',
      configureEscalation: '设置升级通知',
      directMessage: '直接消息',
      useTemplate: '使用模板',
      retryMessageDescription: '设置当用户在指定时间内没有回应时，重新发送的提醒消息内容：',
      retryMessagePlaceholder: '请输入提醒消息内容，提醒用户尽快回复...',
      retryMessageTip: '提示：此消息会在每次提醒时发送给用户',
      retryMessageRecipients: '提醒消息收件人',
      retryMessageRecipientsDescription: '选择需要接收提醒消息的人员（可选择用户、联系人、流程变量或流程启动人）：',
      templateDescription: '选择一个已建立的模板作为提醒消息：',
      noTemplateSelected: '尚未选择模板',
      escalationMessageDescription: '设置当达到提醒上限后，发送给升级对象的通知消息：',
      escalationMessagePlaceholder: '请输入升级通知消息内容，告知管理者需要处理...',
      escalationMessageTip: '提示：此消息只会在达到提醒上限后发送一次',
      escalationRecipients: '升级通知收件人',
      escalationRecipientsDescription: '选择在达到提醒上限后，需要接收升级通知的人员：',
      escalationMessage: '升级通知消息',
      retryMessageSaved: '提醒消息配置已保存',
      escalationSaved: '升级通知配置已保存',
      retryMessageCleared: '提醒消息配置已清除',
      escalationCleared: '升级通知配置已清除',
      overdueEscalationCleared: '逾期升级通知配置已清除',
      overdueEscalationRecipients: '逾期升级通知收件人',
      overdueEscalationRecipientsDescription: '选择在流程逾期后，需要接收升级通知的人员：',
      overdueEscalationMessage: '逾期升级通知消息',
      overdueEscalationMessageDescription: '设置当流程逾期后，发送给升级对象的通知消息：',
      overdueEscalationMessagePlaceholder: '请输入逾期升级通知消息内容...',
      overdueEscalationMessageTip: '提示：此消息会在流程超过逾期时间后发送',
    },

    // Auto Complete 验证器相关翻译
    timeoutComplete: {
      timeoutInterval: '超时间隔',
      description: '设定超时后自动完成节点的时间间隔。超过此时间用户无操作，系统将自动完成节点并前往下一个节点。',
      hint: '提示：将天、时、分全部设为 0 或留空，则不启用自动完成功能。',
    },
    autoComplete: {
      aiBatchCount: {
        enable: '图片／影片 AI 批次分析次数达标后自动完成',
        count: 'AI 批次分析完成次数',
        description: '仅计算图片或影片触发的 AI 批次分析（纯文字消息不计入）。设定完成几批后自动结束 Chatbot；停用则不限制批次次数。',
        hint: '提示：适合「用户发完一批相片即结束」的场景。若用户在第 1 批 AI 分析期间抢先发出第 2 批，第 2 批将排入队列；若已达设定次数，队列中剩余图片将被丢弃而不会送至 AI。',
      },
    },
    
    // Send E-Form 相关翻译
    sendEForm: {
      integrateWaitReply: '整合等待回复',
      integrateWaitReplyDesc: '表单发送后，系统会等待用户填写并回复表单',
      integrateDataSetQuery: '整合 DataSet 查询',
      integrateDataSetQueryDesc: '从 DataSet Query 节点获取数据并自动填充表单',
      integrateEmailStart: '整合 Email 监看 (AI 填表)',
      integrateEmailStartDesc: '承接开始节点由 Email 监控触发时收到的邮件内容与附件，使用 AI 智能填充表单；无需 waitReply 节点。',
      integrateManualStart: '整合已发布应用手动触发 (AI 填表)',
      integrateManualStartDesc: '承接「已发布应用」手动触发时输入的消息与附件（与 Email 监看相同数据结构），使用 AI 填表；请搭配手动触发流程使用。',
      integrateEForm: '整合上游 eForm 节点 (使用已填好的表单数据)',
      integrateEFormDesc: '承接画布上指定的 sendEForm 节点产生的表单实例；同一节点若使用多笔模式（multiFormMode=multi）会把所有实例的字段一并汇总后送给 AI。',
      selectUpstreamEFormNode: '上游 sendEForm 节点',
      selectUpstreamEFormNodePlaceholder: '选择要整合的 sendEForm 节点…',
      selectUpstreamEFormNodeHelp: '指向同一流程中已执行完成的 sendEForm 节点；其表单实例（FilledHtmlCode）解析出的字段会作为 AI 的输入资料。多笔模式时会逐张汇总所有实例。',
      noUpstreamEFormNode: '画布上没有 sendEForm 节点；请先新增 sendEForm 节点。',
      integrateChatBot: '整合 Chatbot 节点 (AI 填表)',
      integrateChatBotDesc: '使用上游 Chatbot 节点的对话记录（含图片／附件）作为 AI 填表的输入数据',
      integrateChatOrderingCart: '整合 Chatbot 购物车节点 (AI 填表)',
      integrateChatOrderingCartDesc: '使用上游 Chatbot 购物车节点的下单对话记录（含图片／附件）作为 AI 填表的输入数据',
      selectUpstreamWaitReplyNode: '指定上游 waitReply 节点',
      selectUpstreamWaitReplyNodePlaceholder: '选择 waitReply 节点（留空=最后一笔）…',
      selectUpstreamWaitReplyNodeHelp: '选择特定 waitReply 节点的回复（含图片／文件）作为 AI 输入数据。留空则自动取本次执行中最后一笔有效回复。',
      noUpstreamWaitReplyNode: '画布上没有 waitReply 节点',
      selectUpstreamChatBotNode: '指定上游 Chatbot 节点',
      selectUpstreamChatBotNodePlaceholder: '选择 Chatbot 节点（留空=最新 session）…',
      selectUpstreamChatBotNodeHelp: '选择特定 Chatbot 节点的对话记录作为 AI 输入数据。留空则自动取本次执行中最近更新的 Chatbot session。',
      noUpstreamChatBotNode: '画布上没有 Chatbot 节点',
      selectUpstreamChatOrderingCartNode: '指定上游 Chatbot 购物车节点',
      selectUpstreamChatOrderingCartNodePlaceholder: '选择 Chatbot 购物车节点（留空=最新 session）…',
      selectUpstreamChatOrderingCartNodeHelp: '选择特定 Chatbot 购物车节点的下单对话记录作为 AI 输入数据。留空则自动取本次执行中最近更新的购物车 session。',
      noUpstreamChatOrderingCartNode: '画布上没有 Chatbot 购物车节点',
      integrateEmailStartSendToAi: '传给 AI 的内容',
      integrateEmailStartSendToAiHelp: '选择传给 AI 填表的数据来源：仅附件、仅 email 内文、或两者都传。',
      integrateEmailStartSendToAiAttachment: '仅附件',
      integrateEmailStartSendToAiBody: '仅 email 内文',
      integrateEmailStartSendToAiBoth: '两者都传',
      integrateManualStartSendToAiHelp: '选择传给 AI 的数据来源：仅附件、仅手动触发时输入的消息（用户启动信息）、或两者都传。',
      integrateManualStartSendToAiBody: '仅 用户启动信息',
      manualFill: '手动填写',
      exclusiveModeLabel: '独立模式（互斥）',
      aiSourceLabel: 'AI 数据来源（可多选）',
      emailAndManualBothWarning: 'Email 监看与手动触发同属启动触发器，同一流程只有一种，建议只选其中一个。',
      multiSourceDesc: '多个 AI 来源将合并后一并送给 AI，各来源资料以区块标示。',
      manualFillDesc: '發送空白表單給用戶自行填寫，無需依賴其他節點。系統會自動將表單字段值（字段名稱需與流程資料名稱匹配）複製到流程資料中',
      
      // eForm 结果模式
      resultMode: 'eForm 结果模式',
      singleResult: '单个 eForm 结果',
      multiResult: '允许多于一个 eForm 结果（两层分析）',
      singleResultDesc: '单个结果：AI 直接填充一份表单。',
      multiResultDesc: '多个结果：AI 先分析出多份表单，再逐一填充。',
      multiResultNotice: '此模式会增加 AI 调用次数，请留意成本与时间。',
      sendNotificationToRecipients: '发送通知给收件人',
      sendNotificationToRecipientsHelp: '关闭时仅填表不发送通知（收件人与通知消息无需设置）。手动填表模式必须为开启。',
      sendNotificationOn: 'On',
      sendNotificationOff: 'Off',
      notificationMessage: '通知消息',
      selectDataSetQueryNode: '选择 DataSet Query 节点',
      selectDataSetQueryNodePlaceholder: '请选择要整合的 DataSet Query 节点',
      noDataSetQueryNodes: '暂无可用的 DataSet Query 节点',
      dataSetQueryNodeHelp: '选择要整合的 DataSet Query 节点（操作类型为 SELECT）',
      useDefaultMessage: '使用预设消息',
      customMessage: '自定义消息',
      notificationMessagePlaceholder: '请输入通知消息内容，告知用户需要填写表单...',
      notificationMessageHelp: '当表单发送后，此消息会自动发送给用户',
      defaultNotificationMessage: '请填写并回复此表单',
      promptMessagePlaceholder: '输入提示消息，提醒用户填写表单前需要了解的信息',
      
      // MetaFlows 專用配置
      flowHeader: '標題',
      flowHeaderPlaceholder: '請輸入 Flow 消息的標題（例如：請填寫表單）',
      flowBody: '內容',
      flowBodyPlaceholder: '請輸入 Flow 消息的主體內容（例如：請點擊下方按鈕開始填寫表單）',
      flowCta: '按鈕文字',
      flowCtaPlaceholder: '請輸入按鈕文字（例如：填寫表單）',
      flowTemplateModeTitle: 'Meta Flow Template 变量配置',
      flowTemplateModeHint: 'Template 的标题、内文、按钮文字已于建立时固定，无法在此 override。下方逐项对应 {{1}} {{2}} ... placeholder 到流程变量；如需修改文字内容请至 MetaFlows 表单页重建 Flow Template。',
      flowTemplateNotBuiltHint: '此表单尚未建立 Flow Template（或建立失败）。请至 MetaFlows 表单页触发建立后再回此节点配置变量；以下变量映射会在 Template 建好后生效。',
      flowTemplateLegacyHint: '此表单目前的 Flow Template 为旧格式（无 {{N}} placeholder），下方变量映射不会生效。请至 MetaFlows 表单页重建 Flow Template，并在 BODY 中加入 {{1}} {{2}} ... 才能注入流程变量。',
      metaFlowsManualFillOnly: 'Meta Flows 表單僅支持手動填表模式',
      
      // Additional Prompt 和 JSON Result Variable 配置
      fillFormAdditionalPrompt: '额外 Prompt（填表指示）',
      fillFormAdditionalPromptHelp: '用于指示 AI 如何理解数据来源并填充表单，特别是在多笔模式中，此指示会用于规划多个表单',
      fillFormAdditionalPromptPlaceholder: '例如：数据来源的明细表，会是有不同公司名、不同地址，原因他是在明细内看送货要到那处，所以请你正确理解，每一个明细其实就是一张单独的送货单 delivery note',
      additionalPrompt: '额外 Prompt（JSON 生成指示）',
      additionalPromptHelp: '用于指示 AI 如何用同一组数据源（用户输入的文字/图片/文件）来生成 JSON，方便之后的 dataset 节点用 insert / update 时可以选用 json 来插记录',
      additionalPromptPlaceholder: '例如：请将提取的数据生成以下格式的 JSON：\n{\n  "date": "2017-04-25",\n  "time": "18:27",\n  "amount": 1500.00,\n  "currency": "HKD",\n  "fromAccount": "661-050***-292",\n  "toAccount": "619-034457-888",\n  "toAccountName": "HUNG C** W**",\n  "reference": "5BCO"\n}',
      jsonResultVariable: 'JSON 结果流程变量',
      jsonResultVariableHelp: '选择一个 JSON 类型的流程变量来存储 AI 生成的 JSON 数据',
      jsonResultVariablePlaceholder: '选择 JSON 类型的流程变量',
      jsonResultAiSuggestionVariable: 'AI 建议流程变量',
      jsonResultAiSuggestionVariablePlaceholder: '选择 text 或 string 类型流程变量',
      jsonResultAiSuggestionVariableHelp: '当 AI 在 JSON 对象中返回 suggestion 字段（与验证节点语义相同）时，在 JSON 提取写入后一并写入此变量。仅 text/string。',
      jsonResultAiFailReasonVariable: 'AI 失败原因流程变量',
      jsonResultAiFailReasonVariablePlaceholder: '选择 text 或 string 类型流程变量',
      jsonResultAiFailReasonVariableHelp: '当 AI 在 JSON 对象中返回 reason 字段时写入此变量。仅 text/string（非 json）。',
      knowledgeBaseEnabled: 'Dataset 作为知识库',
      knowledgeBaseEnabledHelp: '启用后，运行时先按条件查询指定 Dataset，将结果 JSON 一并传给 AI，便于将 Email／WhatsApp 内容与主数据（如产品代码、名称）对照再填表。',
      knowledgeBaseHint: '运行时会把查询结果以 JSON 传给 AI（条件编辑与 DataSet Query 节点相同）。数据量大时请用查询条件缩小范围。',
      knowledgeBaseDataSet: '知识库 Dataset',
      knowledgeBaseQueryConditions: '查询条件',
      
      aiProvider: 'AI 提供商',
      aiProviderPlaceholder: '选择用于解析用户自然语言输入的 AI 提供商',
      aiProviderRequired: '请为 AI 自动填写模式选择 AI 提供商',
      
      // 审批设置
      approvalSettingDescription: 'eForm 可以设置为是否需要审批。如果选择「是」，流程将等待用户回复；如果选择「否」，表单提交后将立即自动设为已审批。',
      requireApproval: '需要审批',
      approveButtonLabel: 'Approve 显示名称',
      approveButtonLabelPlaceholder: '例如：通过、WON（留空使用预设名称）',
      rejectButtonLabel: 'Reject 显示名称',
      rejectButtonLabelPlaceholder: '例如：不通过、LOST（留空使用预设名称）'
    },
    artifact: {
      generationMode: '生成数据来源',
      documentFormat: '输出格式',
      storageKind: '存储位置',
      storageLocal: 'WhatoFlow 本机',
      comingSoon: '即将推出',
      sendNotification: '发送通知给收件人',
      reportNameVariable: '报表名称（对应任务名称）',
      reportUrlVariable: '报表链接（登录后可打开的完整 URL）',
      docNameVariable: '文件名称',
      docUrlVariable: '文件页面链接（登录后可下载，完整 URL）',
      defaultHtmlReportNotification: '您的报表「{reportName}」已生成，请登录后打开：\n\n{reportUrl}',
      defaultDocumentNotification: '您的文件「{docName}」已生成，请登录后下载：\n\n{docUrl}',
      knowledgeBaseEnabled: 'Dataset 作为知识库',
      knowledgeBaseEnabledHelp: '启用后，在生成 HTML 报表或 Office 文件前会先按条件查询指定 Dataset，将行数据以 JSON 附加到 AI 系统提示，便于对照主数据（如产品、客户代码）生成内容。',
      knowledgeBaseHint: '查询结果会以 JSON 传给 AI（条件编辑与 DataSet Query 节点相同）。数据量大时请用查询条件缩小范围。',
      attachmentBatchMode: '附件送 AI 范围',
      attachmentBatchModeHelp: '多个附件时：「全部」会依次转档并合并送 AI；「仅第一个」只处理列表中第一个路径（省 token）。与 eForm「多笔结果／多张表单」不同。',
      attachmentBatchModeAll: '全部附件',
      attachmentBatchModeFirst: '仅第一个附件',
      attachmentAiInputFormat: '输入格式',
      attachmentAiInputFormatHelp: '限定送 AI 的附件扩展名：先按此筛选，再应用「附件送 AI 范围」。筛后为空则节点失败。',
      attachmentAiInputFormatAny: '不筛选',
      documentFormatPdfHelp: '以输入的 PDF（或 Office 档）为范本：经 LibreOffice 转为 FODG 交 AI 填写后再导出 PDF；多个输入会一对一产出多份，并各自发送通知。',
      embeddedImages: '嵌入图片',
      embeddedImageDesc: '常用于公司盖章、授权人签名等需印在文件上的图片。上传后在「额外填表指示」中写明使用哪张图及放置位置，AI 会自动将图片嵌入对应栏位。',
      embeddedImageUpload: '上传图片',
      embeddedImageHint: '支持 jpg/png/gif/bmp/webp/svg；在「额外填表指示」中用图片名称指定插入位置',
      embeddedImageName: '图片名称（在 prompt 中引用）',
      embeddedImageEmpty: '尚未上传任何图片',
      embeddedImageNoWorkflowId: '请先保存流程定义后再上传图片',
      embeddedImageInvalidType: '只支持 jpg/png/gif/bmp/webp/svg 格式',
      embeddedImageUploaded: '图片上传成功',
      embeddedImageUploadFailed: '图片上传失败'
    },
    
    // Drawer 全屏相关
    enterFullscreen: '全屏显示',
    exitFullscreen: '退出全屏',
    
    // Overdue Settings（流程逾期设置 - Start 节点）
    overdueConfig: '流程逾期设置',
    overdueSettings: '逾期监控设定',
    overdue: {
      enabled: '启用逾期监控',
      duration: '逾期时限',
      escalation: '逾期通知设置',
      configureEscalation: '设置逾期通知',
      durationHelp: '流程从启动后超过此时限仍未完成，将发送逾期通知',
      escalationRecipients: '逾期通知收件人',
      escalationRecipientsDescription: '选择在流程逾期时需要接收通知的管理人员：',
      escalationMessage: '逾期通知消息',
      escalationMessageDescription: '设置当流程逾期时，发送给管理者的通知消息：',
      escalationMessagePlaceholder: '请输入逾期通知消息内容，告知管理者流程已逾期需要处理...',
      escalationMessageTip: '提示：此消息会在流程逾期时发送一次',
      escalationSaved: '逾期通知配置已保存',
      howItWorks: '运作方式',
      description1: '系统定时检查所有运行中的流程，计算从启动至今的时间',
      description2: '当超过设定的时限（天数 + 小时），且流程仍在运行（未 Complete 或 Failed），则发送逾期通知',
      description3: '逾期通知只发送一次，避免重复打扰',
    },
    
    // 功能说明
    waitReplyDescription1: '1. 流程执行到此节点时会暂停等待用户回复',
    waitReplyDescription2: '2. 只有指定的用户回复才会继续执行流程',
    waitReplyDescription3: '3. 如果启用验证，会检查用户输入是否符合要求',
    waitReplyDescription4: '4. 验证失败时会要求用户重新输入',
    waitReplyKnowledgeBaseEnabled: 'Dataset 作为知识库',
    waitReplyKnowledgeBaseEnabledHelp: '启用 AI 验证时，执行前先按条件查询指定 Dataset，将结果 JSON 一并传给 AI，便于对照主数据判断用户输入。AI Result 流程变量写入逻辑不变。',
    waitReplyKnowledgeBaseHint: '查询结果会以 JSON 传给 AI（条件编辑与 DataSet Query 节点相同）。数据量大时请用查询条件缩小范围。',
    waitReplyKnowledgeBaseDataSet: '知识库 Dataset',
    waitReplyKnowledgeBaseQueryConditions: '查询条件',
    knowledgeSourcesHint: '可同时或择一使用：「Dataset 作为知识库」会按查询条件将行数据以 JSON 传给 AI；「使用知识库」可多选 Studio 知识库文件，传入已发布版本之抽取文字。Dataset 仅能选一个；文件可选多份。',
    knowledgeSourceDataset: 'Dataset 作为知识库',
    knowledgeSourceDatasetHelp: '开启后可指定一个 Dataset 与查询条件，结果以 JSON 并入 AI 提示（与 DataSet Query 节点条件编辑相同）。',
    knowledgeSourceStudio: '使用知识库',
    knowledgeSourceStudioHelp: '多选与 Studio「知识库」页相同的文件；执行时仅纳入已发布版本内容。未发布者仍可选取以便设计，但执行时会跳过。',
    knowledgeSourceStudioPlaceholder: '选择知识库文件（可多选）',
    knowledgeSourceStudioDraft: '未发布',
    knowledgeBaseSettingsDrawerLabel: '使用知识库',
    knowledgeBaseSettingsDrawerHelp: '点「开启设置」于弹窗内一并设置「知识库 Dataset」（单一）与 Studio 知识库文件（可多选）；确定后写入节点。',
    knowledgeBaseSettingsModalTitle: '使用知识库设置',
    knowledgeBaseSettingsConfigure: '开启设置',
    knowledgeBaseSettingsOk: '确定',
    knowledgeBaseSettingsCancel: '取消',
    knowledgeBaseSettingsSectionDataset: '知识库 Dataset',
    knowledgeBaseSettingsSectionStudio: '知识库文件（可多选）',
    knowledgeStudioRagEnabled: '向量检索 (RAG)',
    knowledgeStudioRagHint: '开启后仅将 Top-K 相关 FAQ 片段传给 AI（需文件已完成向量索引）；默认关闭为全文模式。',
    knowledgeStudioTopK: 'Top-K 片段数',
    knowledgeStudioMaxContextChars: '最大上下文字符数',
    knowledgeStudioEmbeddingProvider: 'Embedding 供应商',
    knowledgeStudioEmbeddingProviderPlaceholder: '留空则使用公司默认 Embedding 供应商',
    knowledgeStudioRagProvider: 'RAG 引擎',
    knowledgeStudioRagProviderLocal: '自建管线（本地 Embedding）',
    knowledgeStudioRagProviderXai: 'xAI Collections（托管）',
    knowledgeStudioRagXaiHint: 'xAI Collections 由 xAI 云端托管。系统将自动搜索知识库中所有已建立 Collection 的分类，无需手动填入 ID。请确保：① 在知识库页面为各分类建立 Collection；② 将文件归入分类后发布。',
    knowledgeStudioRagXaiAutoSelected: '已检测到默认 AI 供应商为 xAI，自动使用 xAI Collections（托管）模式。',

    knowledgeBaseSettingsSummaryEmpty: '尚未设置',
    knowledgeBaseSettingsSummaryDataset: 'Dataset：{name}',
    knowledgeBaseSettingsSummaryAndStudio: '；文件 {count} 份',
    knowledgeBaseSettingsSummaryStudioOnly: '文件 {count} 份',
    knowledgeBaseSettingsSummaryMasterOn: '已开启（尚未选择文件或 Dataset）',
    knowledgeBaseSettingsMasterSwitch: '使用知识库',
    knowledgeBaseSettingsMasterHelp: '关闭时不向 AI 传递知识库内容；开启后可设置下方知识库文件与 Dataset。',
    knowledgeBaseSettingsQueryDivider: '查询条件',
    knowledgeBaseSettingsSectionCalendar: '日历事件',
    knowledgeBaseCalendarEnabledSwitch: '启用日历事件作为知识库',
    knowledgeBaseCalendarEnabledHelp: '开启后，执行时会依筛选模式查询日历事件，将事件清单以 JSON 传给 AI，供聊天机器人回答工作安排等问题。',
    knowledgeBaseCalendarFilterModeLabel: '人员筛选模式',
    knowledgeBaseCalendarFilterModeSelf: '查询本人（自动以触发流程的 WhatsApp 用户筛选）',
    knowledgeBaseCalendarFilterModeGroupTag: '指定群组／标签（可建不同流程给不同权限的人）',
    knowledgeBaseCalendarGroupIds: 'Broadcast Group',
    knowledgeBaseCalendarGroupIdsPlaceholder: '选择广播群组（可多选）',
    knowledgeBaseCalendarHashtags: 'Hashtag 标签',
    knowledgeBaseCalendarHashtagsPlaceholder: '输入标签后按 Enter，可多个',
    knowledgeBaseCalendarRelativeDays: '查询未来几天',
    knowledgeBaseCalendarRelativeDaysPlaceholder: '留空 = 不限日期',
    knowledgeBaseSettingsSummaryCalendarSelf: '日历：查本人',
    knowledgeBaseSettingsSummaryCalendarGroup: '日历：{n} 群组{tags}',
    eFormDescription1: '1. 选择要发送的 e-Form 表单',
    eFormDescription2: '2. 选择接收表单的用户（电话号码）',
    eFormDescription3: '3. 系统会将表单链接发送给指定用户',
    eFormDescription4: '4. 用户可以点击链接填写表单',
    eFormDescription5: '5. 表单提交后会触发后续流程',
    
    // 启动方式配置
    activationConfig: '启动方式配置',
    activationType: '启动方式',
    manualActivation: '手动启动',
    metaWebhookCall: '从 WhatsApp 启动',
    scheduledTableWatch: '定时监看数据表',
    emailMonitor: 'Email 监控',
    emailProvider: '邮件服务提供商',
    emailProviderPlaceholder: '请选择邮件服务提供商',
    emailNoProviderConfigured: '未配置邮件服务提供商，请在 API 管理中添加',
    emailMonitorMailbox: '监听的 Email Box (email address)',
    emailMonitorMailboxPlaceholder: '要监听的信箱地址，例如 user@company.com；留空则依提供商设定',
    emailFilterSender: '筛选发件人',
    emailFilterSenderPlaceholder: '留空则不筛选；可输入部分比对',
    emailFilterSubject: '筛选关键词（任一命中）',
    emailFilterSubjectPlaceholder: '留空则不筛选；任一关键词出现在主旨或内文即可',
    emailFilterKeywordsRequired: '必要关键词（全部必须）',
    emailFilterKeywordsRequiredPlaceholder: '留空则不强制；每个关键词都须出现在主旨或内文',
    emailFilterKeywordsMatchHint: '两栏之间为 AND：先通过「任一命中」，再检查「全部必须」；关键词会在主旨与内文搜索',
    emailFilterSenderNot: '发件人不包含',
    emailFilterSenderNotPlaceholder: '留空则不筛选；任一出现则排除',
    emailFilterSubjectNot: '主旨不包含',
    emailFilterSubjectNotPlaceholder: '留空则不筛选；任一出现则排除',
    emailFilterBodyKeywordsNot: '内文不包含',
    emailFilterBodyKeywordsNotPlaceholder: '留空则不筛选；任一出现则排除',
    emailFilterHasAttachment: '仅有附件的邮件',
    emailFilterAttachmentExtensions: '附件副档名筛选',
    emailFilterAttachmentExtensionsPlaceholder: '留空则不筛选；多个为 OR（任一副档名符合即可）',
    emailFilterAttachmentFileName: '附件档名包含',
    emailFilterAttachmentFileNamePlaceholder: '留空则不筛选；多个为 OR（档名包含任一关键词即可）',
    emailFilterAttachmentFileNameNot: '附件档名不包含',
    emailFilterAttachmentFileNameNotPlaceholder: '留空则不筛选；档名包含任一则排除',
    emailMonitorInfo: 'Email 监控说明',
    emailMonitorDescription1: '1. 系统会定期检查所选信箱，符合筛选条件的邮件将触发此流程',
    emailMonitorDescription2: '2. 触发后邮件内容与附件会写入流程，可搭配「整合 Email 监看 (AI 填表)」节点使用',
    watchTable: '监看数据表',
    queryCondition: '查询条件',
    checkInterval: '检查间隔 (秒)',
    
    // Webhook 相关
    webhookToken: 'Webhook Token',
    webhookTokenPlaceholder: '请输入 Webhook Token',
    whatsAppMenuName: 'WhatsApp 选单名称',
    whatsAppMenuNamePlaceholder: '选填，显示在 WhatsApp 选单的选项名称（留空则使用流程名称）',
    webhookInfo: 'Webhook 信息',
    webhookDescription1: '1. 请在公司设置页面配置 Meta Webhook URL',
    webhookDescription2: '2. 当收到 WhatsApp 消息时，系统会回复菜单让用户选择功能',
    webhookDescription3: 'Webhook Token 已在公司层级配置，流程将自动使用公司的 Webhook 设定',

    // Webhook 流程使用权限
    webhookAccess: {
      modalTitle: '选择允许启动本流程的联络人',
      modalIntro: '只有电话号码属于以下任一条件的联络人，才会在 WhatsApp 菜单中看到并可以启动此流程。',
      modeLabel: '流程使用权限',
      modePublic: '公众可用',
      modeRestricted: '限定指定联络人',
      allowedRecipientsLabel: '允许启动的联络人 / 群组 / 标签',
      allowedRecipientsHelp: '可勾选个别联络人、广播群组或联络人标签；只要符合任一条件即视为有权使用。',
      restrictedInfo: '此流程已限定使用对象，不在名单内的 WhatsApp 用户将看不到此选项。',
      fieldPlaceholder: '尚未选择任何联络人 / 群组 / 标签',
      fieldButton: '选择',
      selectedSummary: '已选择的允许名单',
      summaryGroups: '{count} 个群组',
      summaryHashtags: '{count} 个标签',
      summaryContacts: '{count} 个联络人',
    },

    scheduledTable: '监看数据表（旧）',
    scheduledTablePlaceholder: '例如: dbo.SoOrderManage',
    scheduledQuery: '查询条件（旧）',
    scheduledQueryPlaceholder: '例如: WHERE status = \'PENDING\'',
    scheduledInterval: '检查间隔',
    seconds: '秒',
    scheduledInfo: 'Dataset 定时触发（条件 + 写回）',
    scheduledDataSet: '要监看的 Dataset',
    scheduledTriggerConditions: '触发条件（哪些行会启动流程）',
    scheduledFieldMapping: '将列字段映射到流程变量',
    scheduledPostSuccessWriteBack: '流程创建成功后 — 写回该行',
    scheduledPostSuccessSetWriteBack: '设置写回字段',
    scheduledPostSuccessWriteBackSummary: '流程执行创建后将更新该行共 {count} 个字段。',
    scheduledPostSuccessOperationSaved: '已保存写回字段。',
    scheduledLegacySqlDeprecated: '此流程仍包含旧版自由填写的表名/SQL 字段。请改选 Dataset 并在下方配置条件组；服务器将忽略旧字段。',
    scheduledDescription1: '1. 选择一个 Dataset（类似从 Excel 上传的表格）。系统会按您设定的间隔扫描其中的行。',
    scheduledDescription2: '2. 触发条件：与 DataSet 节点相同的查询条件组。例如：状态 等于 待处理 且 部门 等于 销售 —— 只有符合条件的行才会新建一条流程执行。',
    scheduledDescription3: '3. 字段映射：把命中行上的列写入流程变量（如订单号、客户名），后续节点才能使用。',
    scheduledDescription4: '4. 写回：执行实例成功创建后，系统会更新同一行（例如把状态改为处理中），下一轮扫描便不会再次触发。请至少配置一个写回字段，避免重复开跑。',
    scheduledDescription5: '示例：Dataset「订单」有列状态、金额。触发条件为状态=新建；写回把状态改为处理中。某行首次符合条件时会开跑，写回后不再等于新建，便不会重复触发。',
    
    // 配置说明
    metaWebhookConfigTitle: 'Meta Webhook 配置说明',
    metaWebhookConfig1: '1. 请在公司设置页面配置 Meta Webhook URL',
    metaWebhookConfig2: '2. 当收到 WhatsApp 消息时，系统会回复菜单让用户选择功能',
    metaWebhookConfig3: '3. 根据用户选择启动对应的流程',
    metaWebhookConfig4: '4. 此流程将在用户选择后执行',
    scheduledWatchTitle: '定时监看说明',
    scheduledWatchDescription: '此功能正在开发中，将在后续版本中实现',
    
    // 模态框
    selectWhatsAppTemplate: '选择 WhatsApp 模板',
    selectUser: '选择用户',
    selectEForm: '选择 e-Form 表单',
    noTemplatesAvailable: '暂无可用的模板，请先创建模板',
    noUsersAvailable: '暂无可用的用户，请先添加用户',
    noEFormsAvailable: '暂无可用的 e-Form 表单，请先创建表单',
    
    // 其他界面元素
    inDevelopment: '开发中',
    loadingWorkflow: '载入流程中…',
    clickToSelectConnection: '点击选择连接线',
    template: '模板',
    templateInfo: '模板信息',
    templatePreview: '模板预览',
    templateContent: '模板内容',
    templatePreviewNoData: '无模板资料可预览',
    templateId: '模板ID：',
    templateName: '模板名称：',
    // 模板 Image/Document URL 配置
    templateImageUrl: '图片 URL',
    templateDocumentUrl: '文件 URL',
    templateImageUrlPlaceholder: '例如：https://example.com/images/${InvoiceNo}.jpg',
    templateDocumentUrlPlaceholder: '例如：https://example.com/pdf/${InvoiceNo}.pdf',
    templateHeaderUrlHelp: '支持使用流程变量，例如：${InvoiceNo}。若为 JSON 类型可使用 ${JsonName.JsonFieldName}。运行时会自动替换为实际值。',
    templateImageSource: '图片来源',
    templateImageSourceUrl: '使用 URL',
    templateImageSourceInstance: '使用流程实例图片',
    templateImageSourceHelp: '选择使用 URL 或当前流程实例文件夹中的图片（自动排除 qr_scan_success_* 文件，如有多张图片则使用最早的一张）。',
    templateDocumentFilename: '文件名称',
    templateDocumentFilenamePlaceholder: '例如：${InvoiceNo}.pdf',
    templateDocumentFilenameHelp: '支持使用流程变量，例如：${InvoiceNo}。若为 JSON 类型可使用 ${JsonName.JsonFieldName}。运行时会自动替换为实际值。',
    formInfo: '表单信息',
    formId: '表单ID：',
    formName: '表单名称：',
    formDescription: '描述：',
    
    // 默认值和提示
    enterValidContent: '请输入有效内容',
    inputIncorrectRetry: '输入不正确，请重新输入',
    dateFormatExample: '例如：请输入请假日期，格式：YYYY-MM-DD',
    formatExample: '例如：格式不正确，请重新输入，例如：2024-01-15',
    tableExample: '例如: dbo.SoOrderManage',
    queryExample: '例如: WHERE status = \'PENDING\' AND created_at > @lastCheckTime',
    
    // 默认节点数据
    defaultStartNode: '开始',
    defaultEndNode: '结束',
    defaultSendWhatsAppNode: '发送消息',
    defaultSendTemplateNode: '发送 WhatsApp 模板',
    defaultWaitReplyNode: '等待用户回复',
    defaultWaitForEmailReplyNode: '等待 Email 回复',
    defaultDataSetQueryNode: 'DataSet 查询/更新',
    defaultCallApiNode: '触发外部 API',
    defaultSendEFormNode: '发送 e-Form',
    defaultEFormResultNode: 'e-Form 核准/拒绝',
    
    // 验证消息
    defaultReplyMessage: '请输入您的回复',
    defaultValidationPrompt: '请输入有效内容',
    defaultRetryMessage: '输入不正确，请重新输入',
    
    // 注释说明
    specifiedUsersComment: '指定人员的电话号码，用逗号分隔',
    scheduledIntervalComment: '5分钟',
    
    // 状态和其他标签
    statusEnabled: '启用',
    statusDisabled: '停用',
    designer: '设计者',
    functionDescription: '功能说明',
    
    // 错误消息
    saveFailed: '保存失败',
    updateFailed: '更新失败',
    createFailed: '创建失败',
    getTemplatesFailed: '获取模板列表失败',
    unknownError: '未知错误',
    
    // 验证错误消息
    missingStartNode: '缺少开始节点 (Start)',
    missingEndNode: '缺少结束节点 (End)',
    noConnections: '没有连接线',
    circularConnection: '发现循环连接：节点 "{nodeName}" 参与循环',
    isolatedNodes: '发现孤立节点：{nodeNames}',
    startNodeNoOutput: '开始节点 "{nodeName}" 没有输出连接',
    endNodeNoInput: '结束节点 "{nodeName}" 没有输入连接',
    
    // 节点类型说明
    nodeDescriptions: {
      start: '流程的开始点，只能有一个',
      end: '流程的结束点，可以有多个',
      waitReply: '等待用户回复的节点',
      sendMessage: '发送消息给用户的节点',
      condition: '根据条件决定流程方向的节点',
      form: '显示表单给用户填写的节点',
      webhook: '调用外部 API 的节点'
    },
    // 节点配置说明
    nodeConfigDescriptions: {
      waitReply: '1. 流程执行到此节点时会暂停等待用户回复\n2. 只有指定的用户回复才会继续执行流程',
      sendMessage: '1. 发送消息给用户\n2. 可以包含文字、图片、文件等\n3. 支持变量替换',
      condition: '1. 根据条件决定下一步流程\n2. 支持多个分支\n3. 可以根据用户输入、时间等条件判断',
      form: '1. 显示表单给用户填写\n2. 支持多种表单类型\n3. 表单提交后会触发后续流程',
      webhook: '1. 调用外部 API\n2. 可以发送数据到其他系统\n3. 根据 API 响应决定流程方向'
    },
    // 流程启动人选项
    initiatorOptions: {
      initiator: '流程启动人',
      anyUser: '任何用户',
      specificUser: '指定用户'
    },
    
    // 缺少的翻译键
    conditionLabel: '条件标签',
    conditionLabelPlaceholder: '请输入条件标签（可选）',
    cancel: '取消',
    add: '添加',
    selectDefaultPath: '选择默认路径',
    defaultPath: '默认路径',
    defaultPathDescription: '当所有条件群组都不满足时，将执行此默认路径',
    conditionValuePlaceholder: '请输入条件值',
    
    // 高级功能翻译键
    copyNodes: '复制节点',
    pasteNodes: '粘贴节点',
    align: '对齐',
    alignNodes: '对齐节点',
    alignLeft: '左对齐',
    alignCenter: '居中对齐',
    alignRight: '右对齐',
    alignTop: '顶部对齐',
    alignMiddle: '垂直居中',
    alignBottom: '底部对齐',

    multiSelectHintTitle: '小提示',
    multiSelectHint: '按住 {key} 键 + 点击节点即可多选，再用上方对齐按钮即可批量对齐',
    gotIt: '知道了',

    unsavedChangesTitle: '有未保存的变更',
    unsavedChangesContent: '流程内容已变更尚未保存，是否要保存？',
    saveAndLeave: '保存并离开',
    leaveWithoutSaving: '不保存并离开',
    cancel: '取消',
    
    // 节点类型标签
    sendEFormNode: '发送 e-Form',
    generateHtmlReportNode: '生成 HTML 报表',
    generateDocumentNode: '生成文件',
    calendarNode: '日历',
    defaultCalendarNode: '日历排程',
    calendar: {
      generationMode: '数据来源整合模式',
      additionalPrompt: '附加 Prompt（指示 AI 如何排期）',
      additionalPromptPlaceholder: '例如：每月第 2 周周三上午 9:00 安排例行检查工程',
      fillCalendarAdditionalPrompt: '填充日历附加 Prompt',
      fillCalendarAdditionalPromptPlaceholder: '例如：请依据合约期间，逐月展开为具体事件',
      calendarCommandVariable: '保存指令 JSON 至流程变量',
      defaultWorkflowDefinitionLinkage: '事件默认关联到当前流程定义',
      dryRun: '仅验证不写入（Dry Run）',
      failOnValidationError: '指令验证失败时整体失败',
      manualStartInputMode: '手动触发数据来源',
      manualStartInputModeBody: '使用触发 InputJson',
      manualStartInputModeAttachment: '使用触发附件',
      manualStartInputModeBoth: '两者皆使用',
      // 两段式 AI：分析视窗与现况快照
      snapshotSection: '分析视窗与现况快照',
      snapshotHelp: '两段式 AI：第一轮解析分析视窗 from/to/timezone，后端依视窗 + 同流程定义范围捞出既有事件快照，第二轮 AI 才依快照避免冲突地产生 commands。',
      disableTwoStage: '停用两段式 AI（直接用预设视窗）',
      windowDefaults: '预设分析视窗（AI 没给时 fallback）',
      windowMaxes: '分析视窗最大允许范围',
      analysisLookBackDaysDefault: '预设向前回看天数（from = 现在 - N 天）',
      analysisLookAheadDaysDefault: '预设向后展望天数（to = 现在 + N 天）',
      analysisLookBackDaysMax: '最大向前回看天数',
      analysisLookAheadDaysMax: '最大向后展望天数',
      snapshotLimits: '快照大小限制',
      snapshotMaxEvents: '快照事件上限',
      snapshotMaxEventsHelp: '超过上限时只送 perDayCount 统计（不送 events 数组），避免 token 爆量。',
      snapshotIncludeEvents: '包含事件详情（events 数组）',
      snapshotIncludeEventsHelp: '关闭时只送每日数量统计（perDayCount），最省 token。',
      resourceContactRefs: '资源人员标识符',
      resourceContactRefsHelp: '每行（或逗号分隔）一个标识符，系统尝试匹配系统 Contact。\n• 电话号码（如 85296366318）\n• Email（如 user@example.com）\n• {{initiator}} — 自动使用流程启动人\n\n匹配成功 → 加入事件「资源」字段；找不到 → 在事件「说明」末尾补充提示，不影响事件创建。',
      resourceContactRefsPlaceholder: '每行一个，例如：\n85296366318\nuser@example.com\n{{initiator}}',
      defaultEventTypeRef: '默认日历类型名称',
      defaultEventTypeRefsHelp: '填写系统已建立的日历类型名称（完整匹配）。\n• AI 指令未指定 eventTypeId 时，后端自动以此名称查找并注入。\n• AI 已在 additional prompt 中明确指定类型时，优先采用 AI 的选择。\n• 找不到对应类型 → 不报错，eventTypeId 留空或由 AI 决定。\n• 所有可用类型名称会自动注入 AI context，方便在 additional prompt 中按名称指定。',
      defaultEventTypeRefPlaceholder: '例如：假期申请',
    },
    odooNode: 'Odoo',
    defaultOdooNode: 'Odoo ERP',
    odoo: {
      tabData: '操作',
      tabMode: '生成模式',
      tabMapping: '字段映射',
      tabResult: '结果与行为',
      intro: 'Odoo 19 ERP 集成：请先在 API Provider Management → ERP 系统 加入 odoo provider 并启用后再使用。',
      apiProviderKey: 'Odoo Provider',
      apiProviderKeyTip: '对应 API Provider Management → ERP 系统 → odoo；多 Odoo 环境可改成其他 provider key。',
      operationType: '操作类型',
      generationMode: '生成模式',
      modeFormBased: 'Form 模式（手动字段映射）',
      defaultCompanyId: '默认公司 ID',
      defaultCompanyIdTip: '多公司情境下强制 Odoo context.allowed_company_ids；单公司可留空。',
      autoConfirm: '建立后自动 button_confirm',
      autoPost: '建立后自动 action_post',
      autoValidate: '建立后自动 button_validate',
      autoValidateTip: '需要库存可用，否则建议保持关闭，由人手在 Odoo 确认。',
      mappingHelp: 'Form 模式：把 Process Data / 静态值 / Expression 映射到 OdooOperation 字段（例 partner.name、lines[0].product.code、lines[0].qty）。',
      mappingHelpForm: 'Form 模式：上游 sendEForm 字段 / Process Data / 静态值映射到 Odoo 字段（partner.id、partner.name、lines[0].product.code、lines[0].qty…）；mappedFields 为空则 fallback AI。',
      mappingHelpDataSet: 'DataSet 模式：scope=master 取第一笔 row，scope=line 每笔 row 产生一笔 lines[]；mappedFields 为空则 fallback AI。',
      mappingEmptyHint: '尚未设定任何映射，将以 AI 解析整批内容（不确定字段请优先用映射而非 prompt）。',
      mappingOdooField: 'Odoo 字段路径',
      mappingSourceType: '来源',
      mappingSourceValue: '值',
      mappingAdd: '新增字段映射',
      scope: 'Scope',
      scopeMaster: 'master',
      scopeLine: 'line',
      sourceEFormField: 'eForm 字段',
      sourceDatasetColumn: 'DataSet 列',
      sourceVariable: '流程变量',
      sourceStatic: '静态值',
      sourceExpressionLegacy: 'Expression（已弃用）',
      sourceEFormFieldPlaceholder: '选 eForm 字段…',
      sourceDatasetColumnPlaceholder: '选 DataSet 列…',
      sourceVariablePlaceholder: '选流程变量…',
      sourceStaticPlaceholder: '输入静态值',
      expressionDeprecatedTag: '已弃用',
      selectUpstreamEForm: '上游 sendEForm 节点',
      selectUpstreamEFormTip: '指向已填好的 eForm instance；其字段用作 mapping value 来源。',
      selectUpstreamEFormPlaceholder: '选择上游 sendEForm…',
      noUpstreamEForm: '画布上没有 sendEForm 节点；请先新增并指定 formId。',
      schemaPanelMissing: '此 operation 尚无 cheat-sheet',
      schemaPath: '路径 / 标签',
      schemaTip: '说明',
      schemaMaster: 'Master 字段',
      schemaLines: 'Line 字段（每笔 row 重复）',
      schemaFk: 'FK 参照',
      schemaExample: '示例 JSON',
      schemaTips: '注意事项',
      requiredTag: '必填',
      fkTag: 'FK',
      promptFieldPickerButton: '插入 Odoo 字段',
      promptFieldPickerInsert: '插入到光标位置',
      promptFieldPickerInsertBtn: '加入',
      promptFieldPickerSearch: '搜寻路径 / 标签…',
      promptFieldPickerMaster: 'Master',
      promptFieldPickerLines: 'Lines',
      promptFieldPickerFk: 'FK 参照',
      promptFieldPickerSchema: '完整 Schema',
      promptFieldPickerEmpty: '无字段',
      promptFieldPickerNoProvider: '需设定 Odoo Provider Key 才能载入完整 schema',
      promptFieldPickerSchemaEmpty: 'fields_get 为空',
      commandVariable: '保存指令 JSON 至流程变量',
      commandVariableTip: '可选；存放最终丢给 Odoo 的 commands JSON 字符串。',
      resultVariable: '保存 Odoo 执行结果至流程变量',
      resultVariableTip: '存放 OdooCommandExecutionReport（含每笔 doc id / state）。',
      fillOdooAdditionalPrompt: '填充 Odoo 附加 Prompt',
      fillOdooAdditionalPromptPlaceholder: '例：请从 PDF 解析供应商名称、SKU 与 5 笔 line items',
      op: {
        createPO: '建立采购订单（PO）',
        createQuotation: '建立报价单（draft SO）',
        createSO: '建立并确认销售单（SO）',
        confirmSO: '确认销售单',
        createInvoice: '建立发票（INV）',
        postInvoice: '过账发票',
        createDeliveryNote: '建立出货单（DN）',
        createGoodsReceive: '建立收货单（GR）',
        createReturn: '建立退货',
        createCreditNote: '建立信用备忘录',
        registerPayment: '登记付款',
        lookupPartner: '查询客户/供应商',
        lookupProduct: '查询产品',
        lookupStock: '查询库存'
      }
    },
    defaultGenerateHtmlReportNode: '生成 HTML 报表',
    defaultGenerateDocumentNode: '生成文件',

    // Switch 节点条件群组
    editConditionGroup: '编辑条件组',
    groupRelation: '组关系',
    groupRelationRequired: '请选择组关系',
    outputPathRequired: '请选择输出路径',
    noConditions: '暂无条件'
  },

  // 工作流列表页面
  workflowList: {
    add: '新增',
    batchDelete: '批量删除',
    batchEnable: '批量启用',
    batchDisable: '批量停用',
    clearFilter: '清除筛选',
    manualStart: '手动启动',
    select: '选择',
    clear: '清除',
    confirmBatchDelete: '确认批量删除',
    confirmBatchEnable: '确认批量启用',
    confirmBatchDisable: '确认批量停用',
    confirmDelete: '确认删除',
    cancel: '取消',
    confirmDeleteSelected: '确定要删除选中的',
    confirmEnableSelected: '确定要启用选中的',
    confirmDisableSelected: '确定要停用选中的',
    workflows: '个流程',
    cannotBeUndone: '此操作无法撤销！',
    successfullyDeleted: '已成功删除',
    successfullyEnabled: '已成功启用',
    successfullyDisabled: '已成功停用',
    batchDeleteFailed: '批量删除失败',
    batchOperationFailed: '批量操作失败',
    pleaseSelectWorkflows: '请选择要删除的流程',
    pleaseSelectWorkflowsToOperate: '请选择要操作的流程',
    workflowStarted: '已成功启动',
    manualStartMessage: '手动启动的流程',
    deleteWithRelatedRecords: '删除流程及其相关记录',
    confirmDeleteWithRelatedRecords: '确定要删除流程「{name}」吗？',
    relatedRecordsWillBeDeleted: '删除此流程将同时删除以下相关记录：',
    executionInstances: '流程实例',
    stepExecutions: '步骤执行记录',
    messageSends: '消息发送记录',
    messageRecipients: '消息收件人记录',
    queryResults: '数据集查询结果',
    queryRecords: '数据集查询记录',
    eformInstances: '表单实例',
    messageValidations: '消息验证记录',
    chatMessages: '聊天消息',
    processVariableValues: '流程变量值',
    processVariableDefinitions: '流程变量定义',
    noRelatedRecords: '此流程没有相关记录，可以直接删除。',
    loadingRelatedRecords: '正在查询相关记录...',
    warningDeleteTitle: '⚠️ 严重警告：删除操作不可回复！',
    warningDeleteDescription: '删除此流程定义将永久删除所有相关数据，包括：流程定义本身、所有流程运行实例、表单实例、表单审批记录、消息发送记录、步骤执行记录、数据集查询记录、流程变量、消息验证记录等。所有数据将被永久删除且无法恢复！',
    criticalWarning: '⚠️ 此操作无法撤销！请确认您真的要删除这些数据。',
    confirmStatusChange: '确认更改状态',
    confirmStatusChangeContent: '确定要将流程「{name}」的状态更改为「{action}」吗？',
    successfullyChangedStatus: '状态已成功更改为',
    statusChangeFailed: '状态更改失败'
  },

  // 日历页面（应用 → 日历）
  calendar: {
    title: '日历',
    viewDay: '日',
    viewWeek: '周',
    viewMonth: '月',
    viewYear: '年',
    today: '今天',
    jumpToDate: '跳至日期',
    jumpToMonth: '跳至月份',
    jumpToYear: '跳至年份',
    refresh: '刷新',
    newEvent: '新增事件',
    editEvent: '编辑事件',
    filterAll: '全部流程',
    fromWorkflow: '所属流程',
    fieldTitle: '标题',
    fieldAllDay: '整天',
    fieldTime: '开始 / 结束',
    fieldWorkflow: '流程定义',
    fieldWorkflowPlaceholder: '可选，将事件归入指定流程定义',
    fieldResources: '资源',
    fieldResourcesPlaceholder: '选择 contact 作为事件资源 / 工程人员',
    selectResources: '选择资源',
    resourcePickerTitle: '选择资源',
    resourcePickerSearchPlaceholder: '搜索名称 / 电话 / Email / 部门 / 群组 / 标签',
    resourceName: '名称',
    resourcePosition: '职位 / 部门',
    resourceCompany: '公司',
    resourcePhone: '电话',
    resourceEmail: 'Email',
    resourceGroup: '群组',
    resourceTags: '标签',
    filterGroup: '群组',
    filterTag: '标签',
    clearFilters: '清除筛选',
    apply: '套用',
    fieldLocation: '地点',
    fieldColor: '颜色',
    fieldStatus: '状态',
    fieldEventType: '日历类型',
    fieldEventTypePlaceholder: '选择或输入日历类型',
    eventTypeDeleted: '已删除日历类型',
    eventTypeDeleteFail: '删除日历类型失败',
    eventTypeDeleteInUse: '此日历类型仍有事件使用中，无法删除',
    eventTypeDeleteInUseCount: '此日历类型仍有 {count} 个事件使用中，无法删除',
    sidebarEventTypes: '日历类型',
    untypedEvents: '未分类',
    noEventTypesYet: '尚无日历类型，新增事件时可输入建立',
    fieldTypeColor: '类型色彩',
    editTypeColor: '设定类型色彩',
    typeColorSidebarHint: '可在左侧选单调整类型色彩',
    eventTypeColorUpdateFail: '更新日历类型色彩失败',
    collapseSidebar: '收合侧边栏',
    expandSidebar: '展开侧边栏',
    fieldDescription: '说明',
    statusConfirmed: '已确认',
    statusTentative: '待定',
    statusCancelled: '已取消',
    save: '保存',
    cancel: '取消',
    delete: '删除',
    saved: '已保存',
    saveFail: '保存失败',
    deleted: '已删除',
    deleteFail: '删除失败',
    confirmDelete: '确认删除此事件？',
    requireTitle: '请输入标题',
    requireTime: '请选择开始与结束时间',
    loadFail: '加载事件失败',
  },

  // 已发布应用页面
  publishedApps: {
    title: '已发布应用',
    description: '显示所有启用状态且支持手动启动的工作流程应用',
    totalApps: '总应用数',
    manualTriggerWorkflows: '手动触发工作流程',
    autoTriggerWorkflows: '自动触发工作流程',
    noManualWorkflows: '暂无手动触发的工作流程',
    noAutoWorkflows: '暂无自动触发的工作流程',
    loading: '加载已发布应用中...',
    executionCount: '执行次数',
    creator: '创建者',
    clickToStart: '点击启动',
    manualMessagePlaceholder: '输入消息…',
    manualSend: '发送',
    manualSendHint: '输入消息后点绿色发送；附件请点回形针，或将文件拖入虚线框内',
    manualComposerDropHint: '将文件拖到此虚线框内，或点左侧回形针加入多个文件',
    manualAttachTooltip: '从电脑选择文件（可多选）',
    manualDropOnIconHint: '拖放多个文件至此，或点击选择文件；亦可拖至下方虚线输入区',
    manualSendNeedContent: '请输入至少一条消息或上传一个文件',
    starting: '启动中...',
    autoOnly: '仅自动触发',
    unknown: '未知',
    manual: '手动',
    auto: '自动',
    startWorkflowSuccess: '工作流程 "{name}" 已成功启动',
    startWorkflowQueued: '工作流程 "{name}" 已提交并于后台执行；状态与错误请到流程监控查看',
    startWorkflowFailed: '启动工作流程失败',
    loadAppsFailed: '加载已发布应用失败',
    noDescription: '无描述',
    mockCustomerService: '客户服务流程',
    mockCustomerServiceDesc: '处理客户咨询和投诉的标准化流程',
    mockOrderProcess: '订单处理流程',
    mockOrderProcessDesc: '从订单接收到发货的完整流程',
    mockPaymentConfirm: '付款确认流程',
    mockPaymentConfirmDesc: '处理付款确认和发票生成的流程',
    mockAutoNotification: '自动通知流程',
    mockAutoNotificationDesc: '系统自动发送通知的流程'
  },

  // Data Set 管理页面
  dataSetManagement: {
    title: '数据集管理',
    add: '新增',
    createDataSet: '创建 Data Set',
    editDataSet: '编辑 Data Set',
    createDataSetTitle: '创建 Data Set',
    editDataSetTitle: '编辑 Data Set',
    save: '保存',
    cancel: '取消',
    
    // 表格列标题
    name: '名称',
    dataSourceType: '数据源类型',
    status: '状态',
    recordCount: '记录数',
    lastUpdate: '最后更新',
    actions: '操作',
    
    // 状态标签
    active: '启用',
    inactive: '停用',
    error: '错误',
    
    // 同步状态标签
    idle: '闲置',
    running: '同步中',
    completed: '已完成',
    failed: '失败',
    paused: '已暂停',
    
    // 同步进度
    syncStatus: '同步状态',
    syncProgress: '同步进度',
    syncInProgress: '数据集正在同步中，请稍后再试',
    syncStarted: '同步已开始',
    syncCompleted: '同步完成 - 新增: {inserted}, 更新: {updated}, 删除: {deleted}',
    syncFailed: '同步失败',
    inserted: '新增',
    updated: '更新',
    deleted: '删除',
    skipped: '跳过',
    processed: '已处理',
    total: '总计',
    syncPaused: '同步已暂停',
    readyToSync: '准备同步',
    
    // 数据源类型
    sql: 'SQL',
    excel: 'EXCEL',
    googleDocs: 'GOOGLE_DOCS',
    
    // 操作按钮
    viewRecords: '查看记录',
    syncData: '同步数据',
    edit: '编辑',
    delete: '删除',
    deleteRecord: '删除记录',
    editRecord: '编辑记录',
    editRecordTitle: '编辑记录',
    recordUpdated: '记录已更新',
    recordUpdateFailed: '更新记录失败',
    
    // 确认对话框
    confirmDelete: '确定要删除这个 DataSet 吗？',
    confirmDeleteOk: '确定',
    confirmDeleteCancel: '取消',
    confirmDeleteRecord: '确定要删除这条记录吗？',
    confirmDeleteRecordDescription: '删除此记录将无法复原，请确认是否继续？',
    recordDeleted: '记录已成功删除',
    recordDeleteFailed: '删除记录失败',
    
    // 分页
    totalRecords: '共 {total} 条记录',
    pageRange: '第 ',
    total: ' 条记录',
    pageSizeOptions: ['10', '20', '50', '100'],
    
    // 标签页
    basicInfo: '基本信息',
    dataSourceConfig: '数据源配置',
    columnDefinition: '字段定义',
    
    // 基本信息表单
    nameLabel: '名称',
    namePlaceholder: '输入 Data Set 名称',
    nameRequired: '请输入名称',
    description: '描述',
    descriptionPlaceholder: '输入描述',
    isScheduled: '定时更新',
    updateInterval: '更新间隔（分钟）',
    updateIntervalPlaceholder: '例如：60（1小时）',
    updateIntervalRequired: '请设定更新间隔',
    syncDirection: '同步方向',
    syncDirectionTooltip: '选择数据同步的方向：入站（从外部读取）、出站（写入外部）、双向（先写入再读取）',
    syncDirectionPlaceholder: '请选择同步方向',
    syncDirectionInbound: '入站（从外部数据源读取到内部）',
    syncDirectionOutbound: '出站（从内部写入到外部数据源）',
    syncDirectionBidirectional: '双向（先写入外部，再从外部读取）',
    
    // 数据源配置
    dataSourceTypeLabel: '数据源类型',
    dataSourceTypePlaceholder: '选择数据源类型',
    dataSourceTypeRequired: '请选择数据源类型',
    dataSourceTypeInfo: '数据源类型设定',
    dataSourceTypeDescription: '请在「数据源配置」标签中选择数据源类型并进行相应配置。',
    
    // SQL 配置
    connectionType: '连接方式',
    usePresetConnection: '使用预设连接',
    customConnection: '自定义连接',
    presetDatabaseConnection: '预设数据库连接',
    presetConnectionPlaceholder: '选择数据库连接',
    erpDatabase: 'ERP 数据库',
    purpleRiceDatabase: 'Purple Rice 数据库',
    serverName: '服务器名称/IP',
    serverNamePlaceholder: '例如：192.168.1.100',
    serverNameRequired: '请输入服务器名称或IP',
    port: '端口号',
    portPlaceholder: '例如：1433',
    databaseName: '数据库名称',
    databaseNamePlaceholder: '例如：MyDatabase',
    databaseNameRequired: '请输入数据库名称',
    authenticationType: '认证方式',
    sqlServerAuth: 'SQL Server 认证',
    windowsAuth: 'Windows 认证',
    username: '用户名',
    usernamePlaceholder: '例如：sa',
    usernameRequired: '请输入用户名',
    password: '密码',
    passwordPlaceholder: '输入密码',
    passwordRequired: '请输入密码',
    additionalOptions: '额外连接选项',
    additionalOptionsPlaceholder: '例如：TrustServerCertificate=true;MultipleActiveResultSets=true',
    connectionTest: '连接测试',
    connectionTestDescription: '配置完成后，可以点击下方按钮测试连接是否成功。',
    testConnection: '测试连接',
    sqlQuery: 'SQL 查询语句',
    sqlQueryPlaceholder: 'SELECT * FROM table_name WHERE condition',
    sqlQueryRequired: '请输入 SQL 查询语句',
    sqlParameters: 'SQL 参数（JSON 格式）',
    sqlParametersPlaceholder: '{"param1": "value1", "param2": "value2"}',
    targetTableName: '目标表名',
    targetTableNamePlaceholder: '例如：customers',
    targetTableNameRequired: '出站或双向同步时，目标表名为必填项',
    targetTableNameTooltip: '指定出站同步时要写入的 SQL 表名（仅在出站或双向同步时需要）',
    
    // Excel 配置
    excelFilePath: 'Excel 文件路径',
    excelFilePathPlaceholder: '例如：C:/local/data.xlsx、/uploads/excel/data.xlsx，或 \\\\\\\\server\\\\share\\\\folder\\\\file.xlsx（网络磁盘请用 UNC）',
    excelSheetName: '工作表名称',
    excelSheetNamePlaceholder: '选择工作表',
    uploadExcelFile: '上传 Excel 文件',
    excelUploadDescription: 'Excel 上传说明',
    excelUploadInfo: '上传成功后，文件路径会自动填充。保存 DataSet 后，点击「同步数据」按钮来将 Excel 数据导入到数据库中。系统会自动根据 Excel 标题行生成字段定义。',
    selectSheetThenLoadColumns: '已载入工作表列表，请选择工作表后再点击「载入字段定义」。',
    
    // Google Docs 配置
    googleDocsUrl: 'Google Docs URL',
    googleDocsUrlPlaceholder: 'https://docs.google.com/spreadsheets/d/...',
    googleDocsUrlRequired: '请输入 Google Docs URL',
    googleDocsSheetName: '工作表名称',
    googleDocsSheetNamePlaceholder: '例如：Sheet1',
    googleDocsIntegration: 'Google Docs 整合说明',
    googleDocsIntegrationDescription: '请确保 Google Docs 文件已设定为可公开读取，或已配置适当的认证信息。',
    loadColumnDefinition: '载入字段定义',
    tenantAdminOnly: '仅 Tenant_Admin 可用',
    sqlReadOnlyNotice: 'SQL 查询由 Tenant_Admin 管理，您只能查看，无法修改。',
    
    // 自动更新
    autoUpdate: '自动更新',
    autoUpdateInterval: '更新间隔（分钟）',
    autoUpdateIntervalPlaceholder: '例如：60（1小时）',
    autoUpdateIntervalRequired: '请设定更新间隔',
    
    // 字段定义
    columnDefinitionDescription: '字段定义说明',
    columnDefinitionInfo: '对于 Excel 数据源，系统会自动根据 Excel 标题行生成字段定义。您可以在同步数据后手动调整字段属性。',
    columnName: '字段名称',
    columnNamePlaceholder: '例如：customer_id',
    columnNameRequired: '请输入字段名称',
    displayName: '显示名称',
    displayNamePlaceholder: '例如：客户编号',
    dataType: '数据类型',
    dataTypePlaceholder: '选择数据类型',
    dataTypeRequired: '请选择数据类型',
    string: '字符串',
    text: '长文本',
    int: '整数',
    decimal: '小数',
    datetime: '日期时间',
    boolean: '布尔值',
    isPrimaryKey: '主键',
    isPrimaryKeyNormal: '普通',
    isSearchable: '可搜索',
    isSearchableNot: '不可搜索',
    isSortable: '可排序',
    isSortableNot: '不可排序',
    isIndexed: '建索引',
    isIndexedNot: '不建索引',
    defaultValue: '默认值',
    defaultValuePlaceholder: '默认值',
    sortOrder: '排序顺序',
    addColumn: '添加字段',
    removeColumn: '删除',
    
    // 记录查看
    dataRecords: '数据记录',
    advancedSearch: '高级搜索',
    refresh: '重新整理',
    recordId: 'ID',
    primaryKeyValue: '主键值',
    recordStatus: '状态',
    createdAt: '创建时间',
    nA: 'N/A',
    
    // 高级搜索
    advancedSearchTitle: '高级搜索',
    searchConditions: '搜索条件',
    columnNameLabel: '字段名称',
    columnNamePlaceholder: '选择字段',
    columnNameRequired: '请选择字段',
    operator: '操作符',
    operatorPlaceholder: '选择操作符',
    operatorRequired: '请选择操作符',
    equals: '等于',
    contains: '包含',
    greaterThan: '大于',
    lessThan: '小于',
    dateRange: '日期范围',
    value: '值',
    valuePlaceholder: '输入搜索值',
    valueRequired: '请输入值',
    addSearchCondition: '添加搜索条件',
    removeSearchCondition: '删除',
    sortBy: '排序字段',
    sortByPlaceholder: '选择排序字段',
    sortOrder: '排序方向',
    ascending: '升序',
    descending: '降序',
    executeSearch: '执行搜索',
    
    // 操作结果消息
    deleteSuccess: '删除成功',
    deleteFailed: '删除失败',
    syncSuccess: '同步成功！共处理 {count} 条记录',
    syncFailed: '同步失败',
    createSuccess: '创建成功',
    updateSuccess: '更新成功',
    operationFailed: '操作失败',
    fetchFailed: '获取 DataSet 列表失败',
    fetchRecordsFailed: '获取记录失败',
    processFailed: '处理失败',
    searchFailed: '搜索失败',
    foundRecords: '找到 {count} 条记录',
    
    // 错误消息
    pleaseSelectDataSourceType: '请选择数据源类型',
    pleaseEnterName: '请输入名称',
    pleaseEnterServerName: '请输入服务器名称或IP',
    pleaseEnterDatabaseName: '请输入数据库名称',
    pleaseEnterUsername: '请输入用户名',
    pleaseEnterPassword: '请输入密码',
    pleaseEnterSqlQuery: '请先输入 SQL 查询语句',
    pleaseSelectPresetConnection: '请选择预设连接',
    pleaseEnterGoogleDocsUrl: '请输入 Google Docs URL',
    pleaseEnterColumnName: '请输入字段名称',
    pleaseSelectDataType: '请选择数据类型',
    pleaseSelectColumn: '请选择字段',
    pleaseSelectOperator: '请选择操作符',
    pleaseEnterValue: '请输入值',
    
    // 文件上传
    onlyExcelFiles: '只能上传 Excel 文件！',
    fileSizeLimit: '文件大小不能超过 10MB！',
    uploadSuccess: '上传成功',
    uploadFailed: '上传失败',
    processingFile: '正在处理文件，请稍候...',
    getSheetNamesFailed: '获取工作表名称失败',
    getColumnPreviewFailed: '获取字段预览失败',
    autoGeneratedColumns: '已自动生成 {count} 个字段定义',
    cannotAutoGenerateColumns: '无法自动生成字段定义',
    pleaseManuallyConfigure: '请手动配置',
    
    // 连接测试
    testingConnection: '正在测试连接...',
    connectionTestSuccess: '连接测试成功！正在获取字段定义...',
    connectionTestFailed: '连接测试失败',
    presetConnectionConfigured: '预设连接配置完成',
    
    // 分页
    pageRange: '第 {start}-{end} 条，共 {total} 条记录',
    recordPageSizeOptions: ['20', '50', '100', '200']
  },

  // 流程变量管理
  processVariables: {
    title: '流程变量管理',
    variableList: '流程变量列表',
    addVariable: '添加变量',
    editVariable: '编辑变量',
    deleteVariable: '删除变量',
    createVariable: '创建变量',
    updateVariable: '更新变量',
    cancel: '取消',
    save: '保存',
    
    // 变量属性
    variableName: '变量名称',
    displayName: '显示名称',
    dataType: '数据类型',
    description: '描述',
    isRequired: '是否必填',
    defaultValue: '默认值',
    validationRules: '验证规则',
    jsonSchema: 'JSON Schema',
    
    // 数据类型选项
    dataTypeString: '字符串 (string)',
    dataTypeInt: '整数 (int)',
    dataTypeDecimal: '小数 (decimal)',
    dataTypeDatetime: '日期时间 (datetime)',
    dataTypeBoolean: '布尔值 (boolean)',
    dataTypeText: '长文本 (text)',
    dataTypeJson: 'JSON 对象 (json)',
    
    // 表单提示
    variableNamePlaceholder: '例如：customer_name',
    displayNamePlaceholder: '例如：客户名称',
    descriptionPlaceholder: '描述这个变量的用途',
    defaultValuePlaceholder: '变量的默认值',
    validationRulesPlaceholder: 'JSON 格式的验证规则',
    jsonSchemaPlaceholder: 'JSON Schema 定义（仅 JSON 类型需要）',
    
    // 验证消息
    variableNameRequired: '请输入变量名称',
    variableNamePattern: '变量名称只能包含字母、数字和下划线，且不能以数字开头',
    dataTypeRequired: '请选择数据类型',
    
    // 状态标签
    required: '必填',
    optional: '可选',
    
    // 操作结果
    createSuccess: '流程变量创建成功',
    updateSuccess: '流程变量更新成功',
    deleteSuccess: '流程变量删除成功',
    createFailed: '流程变量创建失败',
    updateFailed: '流程变量更新失败',
    deleteFailed: '流程变量删除失败',
    saveFailed: '保存流程变量失败',
    fetchFailed: '获取流程变量失败',
    
    // 确认对话框
    confirmDelete: '确定要删除这个流程变量吗？',
    confirmDeleteOk: '确定',
    confirmDeleteCancel: '取消',
    
    // 空状态
    noVariables: '暂无流程变量，点击「添加变量」开始创建',
    noDisplayName: '无显示名称',
    selectVariableToEdit: '请选择一个流程变量进行编辑，或点击「添加变量」创建新的流程变量',
    
    // 管理按钮
    manageProcessVariables: '管理流程变量',

    // PV 显示设定（PendingTasks 展开行用）
    displaySection: '列表显示设定',
    showInList: '在表单列表中显示',
    showInFormList: '在表单列表中显示',
    showInFormListHelp: '勾选后，此 PV 会出现在 PendingTasks 等表单列表的「流程变量」区块。',
    showInListHelp: '勾选后，此 PV 会出现在 PendingTasks 等表单列表的「流程变量」区块。',
    shownInList: '已显示于表单列表',
    shownInFormList: '已显示于表单列表',
    showInInstanceList: '在实例列表中显示',
    showInInstanceListHelp: '勾选后，此 PV 的值会显示在流程活动看板的实例标题行，并可作为筛选条件。',
    shownInInstanceList: '已显示于实例列表',
    displayLabel: '显示标签',
    displayLabelHelp: '若为空，会 fallback 用 DisplayName / VariableName。',
    displayLabelPlaceholder: '例如：客户总价钱',
    displayOrder: '显示顺序',
    displayOrderHelp: '数值越小越靠前；通常用左侧列表的 ↑/↓ 即可，不必手动输入。',
    jsonKeyDisplay: 'JSON Key 显示设定',
    jsonKeyDisplayHelp: '为此 JSON 变量定义要显示的 key。每一行会在列表中显示为一列。',
    noJsonKeys: '尚未新增 JSON Key',
    addJsonKey: '新增 JSON Key',
    jsonKeyPlaceholder: '例如：customerName',
    jsonKeyDisplayLabelPlaceholder: '例如：客户名称',
    listColumnLabel: '列表显示名称:',
    moveUp: '上移',
    moveDown: '下移'
  },

  // WhatsApp Workflow Designer
  workflowDesigner: {
    title: '工作流程设计器',
    workflowInfo: '工作流程信息',
    workflowName: '工作流程名称',
    workflowDescription: '工作流程描述',
    workflowNamePlaceholder: '请输入工作流程名称',
    workflowDescriptionPlaceholder: '请输入工作流程描述',
    nodeTypes: '节点类型',
    loadingNodeTypes: '加载节点类型中...',
    nodeConfiguration: '节点配置',
    connection: '连线',
    node: '节点',
    flow: '流程',
    startNode: '开始节点',
    endNode: '结束节点',
    waitReplyNode: '等待回复节点',
    waitForQRCodeNode: '等待 QR Code 节点',
    waitForEmailReplyNode: '等待 Email 回复节点',
    waitForEmailReplyAutoCompleteTitle: '超时自动完成（仅 Wait for Email Reply）',
    waitForEmailReplyAutoCompleteEnable: '启用超时自动完成',
    waitForEmailReplyAutoCompleteTimeout: '自动完成超时时间',
    switchNode: '切换节点',
    sendMessageNode: '发送 Message 节点',
    sendWhatsAppNode: '发送 Message 节点',
    sendTemplateNode: '发送模板节点',
    shoppingCartNode: 'WhatsApp 购物车',
    sendInstitutionOrderingCartNode: '机构订购购物车',
    institutionOrderingCartNode: '机构订购购物车',
    chatOrderingCartNode: '聊天购物车',
    chatBotNode: '聊天机器人',
    chatBotInitialGreeting: '开场白',
    chatBotInitialGreetingPlaceholder: '例如：您好！有什么可以帮到您？',
    chatBotGreetingEnabled: '发送开场白',
    chatBotGreetingEnabledHelp: '关闭后，进入等待状态时不会发送开场白消息。适合用户一开始就会直接发送照片或消息的流程。',
    chatBotEndKeywords: '以相似关键字结束对话',
    chatBotEndKeywordsPlaceholder: '按 Enter 加入参考短语。系统会用 AI 比对语义（例：再见、谢谢、不用了、stop）',
    chatBotEndMessageEnabled: '发送结束语',
    chatBotEndMessageEnabledHelp: '关闭后，对话结束时不会发送任何结束消息（包括系统默认及超时消息）。',
    chatBotEndMessage: '对话结束语',
    chatBotEndMessageHelp: '当用户触发结束关键字或对话闲置超时自动完成时，发送此消息给用户。留空则使用系统默认结束语。',
    chatBotEndMessagePlaceholder: '例如：感谢您的查询，如有需要欢迎再联系我们。',
    chatBotRagAdditionalQuery: 'RAG 附加查询',
    chatBotRagAdditionalQueryHelp: '每次查询知识库时，将此文字附加到用户消息后一起送给 RAG 引擎，可提升特定知识库 chunk（如身份对照表）的命中率。留空则只用用户消息查询。',
    chatBotRagAdditionalQueryPlaceholder: '例如：身份识别 用户资料 租户',
    chatBotAdditionalPrompt: 'Additional Prompt',
    chatBotAdditionalPromptHelp: '追加到 Chat Bot 默认 system prompt，不会取代 appsettings 的 system prompt。',
    chatBotAdditionalPromptPlaceholder: '输入额外行为或回答风格指示，例如：请用简短条列回答。',
    chatBotSystemPromptOverride: 'System Prompt 覆写',
    chatBotSystemPromptOverridePlaceholder: '留空使用 appsettings 默认',
    chatOrderingCartTargetCompany: '目标公司',
    chatOrderingCartProductLanguage: '商品语言',
    chatOrderingCartInitialGreeting: '开场白',
    chatOrderingCartInitialGreetingPlaceholder: '例如：您好！请告诉我您要订什么～',
    chatOrderingCartReconfirmQuestion: '追问语句',
    chatOrderingCartReconfirmQuestionPlaceholder: '例如：还有什么需要的吗？',
    chatOrderingCartMissingInfoExtra: '缺漏信息时追加提示',
    chatOrderingCartAdditionalPrompt: 'Additional Prompt',
    chatOrderingCartAdditionalPromptHelp: '追加到聊天购物车默认 system prompt，不会取代 appsettings 的 system prompt。',
    chatOrderingCartAdditionalPromptPlaceholder: '输入额外下单规则或回答风格指示，例如：地址、电话、金额必须逐字复制。',
    chatOrderingCartEndKeywords: '以相似关键字结束对话',
    chatOrderingCartEndKeywordsPlaceholder: '按 Enter 加入参考短语（中英皆可）。系统会用 AI 比对语义，与下列相近即视为放弃下单／结束对话（例：取消、不订了、cancel、stop ordering）',
    chatOrderingCartBtnConfirmLabel: '确认按钮文字',
    chatOrderingCartBtnModifyLabel: '修改按钮文字',
    chatOrderingCartBtnCancelLabel: '取消按钮文字',
    chatOrderingCartSystemPromptOverride: 'System Prompt 覆写',
    chatOrderingCartSystemPromptOverridePlaceholder: '留空使用 appsettings 默认',
    chatOrderingCartContactAndAnonymous: '联络人与匿名',
    chatOrderingCartAllowAnonymousOrder: '允许匿名下单',
    chatOrderingCartAllowAnonymousOrderHelp: '开启时，即使 WhatsApp 号码未连结到联络人，也可下单（CustomerId 留空并标记为匿名）。关闭时，必须在 PWA 联络人设定中将 WhatsApp 号码授权至少 1 个客户。',
    conditionNode: '条件节点',
    formNode: '表单节点',
    webhookNode: 'Webhook 节点',
    callApiNode: '触发外部 API 节点',
    dataSetQueryNode: 'DataSet 查询节点',

    tabDesign: '流程设计',
    exportFlowJson: '导出流程 JSON',
    importFlowJson: '导入流程 JSON',
    exportFlowJsonSuccess: '已导出 JSON 文件',
    exportFlowJsonFailed: '导出失败',
    importFlowJsonSuccess: '已导入流程',
    importFlowJsonFailed: '导入失败',
    importFlowJsonInvalidFile: '请选择 .json 文件',
    importFlowJsonConfirmTitle: '覆盖当前流程？',
    importFlowJsonConfirmContent: '当前有未保存的更改，导入文件将替换画布上的流程。是否继续？',
    importFlowJsonConfirmOk: '继续导入',
    importFlowJsonConfirmCancel: '取消',
    tabAIAssistant: 'AI 流程助理',
    aiChat: {
      placeholder: '例如：开始后发送 WhatsApp 再等回复，然后结束',
      includeCurrentFlow: '包含当前流程',
      pleaseEnterPrompt: '请输入流程描述',
      generationFailed: '生成失败',
      schemaValidationFailed: '流程格式验证失败：',
      logicValidationFailed: '流程逻辑验证失败：',
      applied: '已套用流程',
      updated: '已根据您的要求更新流程',
      restored: '已还原到此版本',
      restoreFailed: '还原失败',
      restoreToThisVersion: '还原到此版本',
      emptyHint: '输入流程描述，AI 将协助生成或修改流程',
      saveHint: '保存流程后，对话记录将写入',
      chatSaveFailed: '未能保存对话记录',
      timeout: 'AI 生成超时，请重试或缩短流程描述',
      generatingHint: '这可能需要 15–60 秒，请耐心等候'
    },
    
    // DataSet 节点相关翻译
    dataSet: {
      selectDataSet: '选择 DataSet',
      selectDataSetPlaceholder: '选择要操作的 DataSet',
      operationType: '操作类型',
      operationTypePlaceholder: '请选择操作类型',
      select: '查询',
      insert: '新增',
      update: '更新',
      delete: '删除',
      queryConditions: '查询条件',
      addQueryConditionGroup: '添加查询条件组',
      editQueryConditionGroup: '编辑查询条件组',
      queryConditionGroup: '查询条件组',
      conditionRelation: '条件关系',
      conditionRelationPlaceholder: '请选择条件关系',
      and: 'AND',
      or: 'OR',
      andDescription: '所有条件都必须满足',
      orDescription: '任一条件满足即可',
      cancel: '取消',
      add: '添加',
      update: '更新',
      selectDataSetField: '选择 DataSet 字段',
      selectDataSetFieldPlaceholder: '请选择 DataSet 字段',
      operator: '操作符',
      operatorPlaceholder: '请选择操作符',
      conditionValue: '条件值',
      conditionValueSource: '条件值来源',
      fixedValue: '固定值',
      selectVariable: '选择变量',
      conditionValuePlaceholder: '请输入条件值',
      conditionValueInputPlaceholder: '输入条件值，可使用流程变量 ${variableName}',
      conditionLabel: '条件标签',
      conditionLabelPlaceholder: '可选的条件描述标签',
      availableProcessVariables: '可用流程变量',
      clickVariableToInsert: '点击变量名称可插入到条件值中',
      editQueryCondition: '编辑查询条件',
      noDataSetFields: '暂无 DataSet 字段',
      conditionCount: '条件数量',
      qrCodeSuccessMessage: 'QR Code 扫描成功！流程将继续执行。',
      qrCodeErrorMessage: '无法处理您上传的图片，请重新上传。',
      template: '模板',
      close: '关闭',
      testQuery: '测试查询',
      queryResultDescription: '基于输入的模拟数据查询结果（前10条）：',
      noQueryResultData: '暂无查询结果数据',
      totalRecords: '共 {count} 条记录',
      pvSimulationDataHelp: '输入测试值后点击「测试查询」查看结果',
      addCondition: '添加条件',
      operationData: '操作数据',
      setOperationData: '设置操作数据',
      fieldMapping: '字段映射',
      setFieldMapping: '设置字段映射',
      selectDataSetField: '选择 DataSet 字段',
      selectProcessVariable: '选择流程变量',
      selectValueSource: '选择流程变量或 eForm 字段',
      processVariables: '流程变量',
      eFormFields: 'eForm 字段',
      noProcessVariables: '暂无流程变量',
      addFieldMapping: '添加字段映射',
      noFieldMapping: '暂无字段映射',
      noOperationData: '暂无操作数据设置',
      fieldMappingSaved: '字段映射保存成功',
      fieldMappingSaveFailed: '保存字段映射失败',
      operationDataSaved: '操作数据设置保存成功',
      operationDataSaveFailed: '保存操作数据设置失败',
      queryConditionGroupSaved: '查询条件组保存成功',
      queryConditionGroupSaveFailed: '保存查询条件组失败',
      queryConditionSaved: '查询条件保存成功',
      queryConditionSaveFailed: '保存查询条件失败',
      loadDataSetListFailed: '加载 DataSet 列表失败',
      loadDataSetColumnsFailed: '加载 DataSet 字段失败',
      loadProcessVariablesFailed: '加载流程变量失败',
      testOperation: '测试操作',
      testQuery: '测试查询',
      testOperationFailed: '测试操作失败',
      testConfigSuccess: '测试配置成功！请在弹窗中输入模拟数据进行查询测试。',
      pleaseSelectDataSet: '请先选择 DataSet',
      pleaseSelectDataSetAndOperation: '请先选择 DataSet 和操作类型',
      queryResultPreview: 'DataSet 查询结果预览',
      pvSimulationData: 'PV 模拟数据',
      pvSimulationDataDescription: '为查询条件中的流程变量输入测试值：',
      pvSimulationDataHelp: '输入测试值后点击「测试查询」查看结果',
      queryResultDescription: '基于输入的模拟数据查询结果（前10条）：',
      noQueryConditions: '无查询条件',
      fieldMappingDescription: '选择 DataSet 字段并从现有流程变量中选择对应的变量，查询结果会自动映射到流程变量中',
      operationDataDescription: '选择 DataSet 字段并从流程变量或 eForm 字段中选择对应的值，INSERT/UPDATE 操作会将选定的值写入到 DataSet 字段中',
      fieldMappingSummary: '已设置 {count} 个字段映射',
      operationDataSummary: '已设置 {count} 个字段映射',
      clickToSetFieldMapping: '点击上方按钮设置 DataSet 字段到流程变量的映射关系',
      generatedWhereClause: '生成的 WHERE 条件',
      operationPreview: '操作预览',
      pleaseSelectDataSetAndOperationType: '请先选择 DataSet 和操作类型',
      pleaseSelectOperationType: '请先选择操作类型',
      pleaseSelectDataSet: '请先选择 DataSet',
      operationData: '操作数据',
      fieldMapping: '字段映射',
      noOperationData: '无操作数据',
      noFieldMapping: '无字段映射',
      queryTopRows: '查询条数上限 (TOP)',
      queryTopRowsPlaceholder: '例如：1、10、100',
      queryTopRowsHelp: '留空表示不限制条数',
      orderByFields: '排序字段 (ORDER BY)',
      noOrderByFields: '尚未设置排序字段',
      addOrderByField: '添加排序字段',
      selectOrderByField: '选择排序字段',
      orderAsc: '升序 ASC',
      orderDesc: '降序 DESC'
    },
    
    eFormResultNode: '表单结果节点',
    defaultStartNode: '开始',
    statusEnabled: '启用',
    taskName: '任务名称',
    taskNameLabel: '任务名称',
    taskNamePlaceholder: '请输入任务名称',
    phoneNumberPlaceholder: '请输入手机号码',
    clear: '清除',
    sectionBasic: '基本',
    sectionTrigger: '触发',
    sectionRecipient: '对象',
    sectionMessage: '讯息',
    sectionRecipientAndMessage: '对象及讯息',
    sectionTemplate: '模板与媒体',
    sectionAi: 'AI',
    sectionValidation: '验证',
    sectionKnowledgeBase: '知识库',
    sectionData: '数据整合',
    sectionForm: '表单与文件',
    sectionCommerce: '商务购物车',
    sectionApproval: '审批',
    sectionBranch: '分支',
    sectionOverdue: '逾期与升级',
    sectionDescription: '功能说明',
    sectionLocation: '地理位置',
    sectionEmailFilter: 'Email 筛选',
    loading: '加载中...',
    noCollections: '暂无集合',
    selectUser: '选择用户',
    selectRecipients: '选择收件人',
    shoppingCartSelectCollection: '选择商品集合',
    shoppingCartSelectCollectionPlaceholder: '请选择要显示的商品集合',
    shoppingCartBody: '消息内容（必填）',
    shoppingCartBodyPlaceholder: '输入商品列表上方的说明文字',
    shoppingCartHeader: '标题（选填）',
    shoppingCartHeaderPlaceholder: '选填',
    shoppingCartFooter: '页脚（选填）',
    shoppingCartFooterPlaceholder: '选填',
    shoppingCart24hHint: '此消息需在用户 24 小时内有回复的对话中发送；超过 24 小时需使用 MPM 模板（后续支持）。',
    institutionOrderingCartFlowMessageTitle: 'Flow 讯息内容（依语系）',
    institutionOrderingCartFlowMessageHeader: '标题 (Header)',
    institutionOrderingCartFlowMessageHeaderPlaceholder: '留空则使用流程名称',
    institutionOrderingCartFlowMessageBody: '内文 (Body)',
    institutionOrderingCartFlowMessageBodyDefault: '请按下面按钮开始输入订单',
    institutionOrderingCartFlowMessageBodyDefaultZhCN: '请按下面按钮开始输入订单',
    institutionOrderingCartFlowMessageBodyDefaultEn: 'Tap the button below to start ordering',
    institutionOrderingCartFlowMessageButton: '按钮 (Footer)',
    institutionOrderingCartFlowMessageButtonDefault: '开始创建订单',
    institutionOrderingCartFlowMessageButtonDefaultZhCN: '开始创建订单',
    institutionOrderingCartFlowMessageButtonDefaultEn: 'Start creating order',
    institutionOrderingCartFlowTemplate: 'Flow 模板名称',
    institutionOrderingCartHint: '请先在 Meta Flows 建立并发布名为上述模板名称的 Flow，Data Exchange 端点会依 flow_token 前缀 cart_ 辨识并回传商品组合／商品列表／购物车。',
    institutionOrderingCart24hTemplateNote: 'Flows 一律透过「Flow 模板」发送，24 小时内外皆使用同一模板（与普通 Shopping Cart 的 product_list 不同，无 24h 内免模板选项）。',
    institutionOrderingCartSettingsSummary: '本节点设定：收件者、Flow 模板名称。流程为选 collection → 商品列表（含图）→ 产品明细（±qty、±10）→ 购物车 → 提交。',
    institutionOrderingCartFlowLanguage: 'Flow 语言',
    institutionOrderingCartLangZhTW: '繁体中文',
    institutionOrderingCartLangZhCN: '简体中文',
    institutionOrderingCartLangEn: 'English',
    institutionOrderingCartCompanyForTemplate: '公司（用于建立 Template）',
    institutionOrderingCartSelectCompany: '请选择公司',
    institutionOrderingCartSelectCompanyFirst: '请先选择公司再建立 Template',
    institutionOrderingCartCreateTemplateButton: '创建到 Meta Template 并连结',
    institutionOrderingCartCreateSuccess: 'Flow Template 已建立，可于 Meta 模板管理查看',
    institutionOrderingCartCreateFailed: '建立 Flow Template 失败',
    institutionOrderingCartPreviewTitle: 'Flow Template 预览',
    institutionOrderingCartOpenMetaPanel: '在 Meta 模板管理查看',
    institutionOrderingCartTemplateInfo: '模板资讯',
    institutionOrderingCartStatus: '状态',
    institutionOrderingCartCategory: '类别',
    institutionOrderingCartLanguage: '语言',
    institutionOrderingCartMessagePreview: '讯息预览',
    institutionOrderingCartFlowButton: '开启订购购物车',
    close: '关闭',
    shoppingCartMode: '模式',
    shoppingCartModeSelectCollection: '选定一个 collection 来显示',
    shoppingCartModeSendCollectionOptions: '发送 collection 选项（先发列表，用户选择后再发 product_list）',
    messageWithVariablesPlaceholder: '请输入消息内容，可使用变量如 {变量名}；流程变量为 JSON 时可用 ${JsonName.JsonFieldName}',
    availableVariables: '可用变量',
    variableSyntaxHelp: '使用 {变量名} 语法来插入变量；JSON 流程变量可使用 ${JsonName.JsonFieldName}',
    description: '描述',
    descriptionPlaceholder: '请输入描述（可选）',
    assignTo: '指定给',
    assignToPlaceholder: '请选择指定人员',
    messageContent: '消息内容',
    messageContentPlaceholder: '请输入消息内容',
    condition: '条件',
    conditionPlaceholder: '请输入条件',
    formSelection: '表单选择',
    formSelectionPlaceholder: '请选择表单',
    webhookUrl: 'Webhook URL',
    webhookUrlPlaceholder: '请输入 Webhook URL',
    save: '保存',
    saveSuccess: '工作流程已保存！',
    saveFailed: '保存失败',
    validationErrors: '验证错误',
    validationWarnings: '验证警告',
    mustHaveStartEnd: '工作流程必须包含开始和结束节点',
    mustHaveConnection: '请建立节点连线',
    hasCycle: '发现循环连接',
    isolatedNode: '发现孤立节点',
    startNodeNoOutput: '开始节点没有输出连接',
    endNodeNoInput: '结束节点没有输入连接',
    cannotConnectToSelf: '不能连接节点到自己',
    connectionAlreadyExists: '节点之间已经存在连接',
    workflowValidationFailed: '工作流程验证失败',
    workflowValidationWarning: '工作流程警告',
    continueSave: '是否继续保存？',
    back: '返回',
    design: '设计',
    copy: '复制',
    delete: '删除',
    confirmDelete: '确定要删除此工作流程吗？',
    copySuccess: '已复制工作流程',
    deleteSuccess: '已删除工作流程',
    deleteFailed: '删除失败',
    copyFailed: '复制失败',
    nameRequired: '请输入工作流程名称',
    descriptionRequired: '请输入工作流程描述',
    
    // 按钮和操作
    clear: '清除',
    selectUser: '选择用户',
    selectPerson: '选择人员',
    selectForm: '选择表单',
    selectTemplate: '选择模板',
    
    // 表单标签和提示
    taskNameLabel: '任务名称',
    phoneNumberPlaceholder: '输入电话号码 (例如: 85296366318) 或点击选择用户',
    selectSpecifiedPerson: '选择指定人员',
    waitReplyMessagePlaceholder: '输入等待用户回复时的提示消息',
    selectEFormPlaceholder: '选择要发送的 e-Form',
    
    // 节点配置
    replyType: '回复类型',
    initiator: '流程启动人',
    specifiedPerson: '指定人员',
    promptMessage: '提示消息',
    promptMessageHelp: '在用户输入前，系统会发送以下消息提醒用户需要输入',
    validationConfig: '验证配置',
    validationSettings: '验证设置',
    validatorActiveLabel: '验证状态',
    active: '启用',
    inactive: '停用',
    enableValidation: '启用验证',
    yes: '是',
    no: '否',
    validatorType: '验证器类型',
    defaultValidator: '预设验证器',
    customValidator: '自定义验证器',
    aiValidator: 'AI 验证',
    timeValidatorLabel: '时间验证器（无回应提醒）',
    timeoutCompleteValidatorLabel: 'Auto Complete 验证器',
    promptText: '提示文字',
    promptTextPlaceholder: '描述有效回复需要满足的条件，例如"用户必须提供 6 位数字验证码"。',
    retryMessage: '提醒消息',
    retryMessagePlaceholder: '输入当用户回复不符合要求时要发送的提示内容。',
    maxRetries: '最大提醒次数',
    minutes: '分钟',
    days: '天',
    hours: '小时',
    validationAiProvider: 'AI 提供商',
    validationAiProviderPlaceholder: '选择用于验证用户回复的 AI 提供商',
    validationAiProviderRequired: '请选择用于验证的 AI 提供商',
    voiceProviderKey: '语音转文字 Provider',
    voiceProviderKeyPlaceholder: '留空则使用公司预设语音 AI',
    aiStaffLabel: 'AI 员工',
    aiStaffPlaceholder: '选择 AI 员工（可选）',
    aiStaffHelp: '选定后，AI 调用将以该员工的角色、技能和个性执行任务',
    aiStaffUseMemory: '使用 AI 员工全局记忆',
    aiStaffUseMemoryHelp: '开启时，AI 员工的历史工作记忆（MemoryMd）会注入 system prompt；关闭则只使用角色设定，不带入过去记忆。',
    aiProviderInactive: '未启用',
    aiProviderNotConfigured: '尚未配置 AI 提供商，请到 API 管理页面新增。',
    aiProviderLoadFailed: '无法载入 AI 提供商列表',
    
    // Time Validator 相关翻译
    timeValidator: {
      retryInterval: '提醒间隔',
      retryIntervalHelp: '用户在此时间内没有回应，系统将自动重新发送提醒消息',
      retryLimit: '提醒次数上限',
      retryMessage: '提醒消息设置',
      escalation: '升级通知设置',
      configureRetryMessage: '设置提醒消息',
      configureEscalation: '设置升级通知',
      directMessage: '直接消息',
      useTemplate: '使用模板',
      retryMessageDescription: '设置当用户在指定时间内没有回应时，重新发送的提醒消息内容：',
      retryMessagePlaceholder: '请输入提醒消息内容，提醒用户尽快回复...',
      retryMessageTip: '提示：此消息会在每次提醒时发送给用户',
      retryMessageRecipients: '提醒消息收件人',
      retryMessageRecipientsDescription: '选择需要接收提醒消息的人员（可选择用户、联系人、流程变量或流程启动人）：',
      templateDescription: '选择一个已建立的模板作为提醒消息：',
      noTemplateSelected: '尚未选择模板',
      escalationMessageDescription: '设置当达到提醒上限后，发送给升级对象的通知消息：',
      escalationMessagePlaceholder: '请输入升级通知消息内容，告知管理者需要处理...',
      escalationMessageTip: '提示：此消息只会在达到提醒上限后发送一次',
      escalationRecipients: '升级通知收件人',
      escalationRecipientsDescription: '选择在达到提醒上限后，需要接收升级通知的人员：',
      escalationMessage: '升级通知消息',
      retryMessageSaved: '提醒消息配置已保存',
      escalationSaved: '升级通知配置已保存',
      retryMessageCleared: '提醒消息配置已清除',
      escalationCleared: '升级通知配置已清除',
      overdueEscalationCleared: '逾期升级通知配置已清除',
      retryMessageConfig: '提醒消息设置',
      escalationConfig: '升级通知设置',
      overdueEscalation: '逾期升级通知',
      configureOverdueEscalation: '设置逾期升级通知',
    },

    // Auto Complete 验证器相关翻译
    timeoutComplete: {
      timeoutInterval: '超时间隔',
      description: '设定超时后自动完成节点的时间间隔。超过此时间用户无操作，系统将自动完成节点并前往下一个节点。',
      hint: '提示：将天、时、分全部设为 0 或留空，则不启用自动完成功能。',
    },
    autoComplete: {
      aiBatchCount: {
        enable: '图片／影片 AI 批次分析次数达标后自动完成',
        count: 'AI 批次分析完成次数',
        description: '仅计算图片或影片触发的 AI 批次分析（纯文字消息不计入）。设定完成几批后自动结束 Chatbot；停用则不限制批次次数。',
        hint: '提示：适合「用户发完一批相片即结束」的场景。若用户在第 1 批 AI 分析期间抢先发出第 2 批，第 2 批将排入队列；若已达设定次数，队列中剩余图片将被丢弃而不会送至 AI。',
      },
    },
    chatBot: {
      jsonExtraction: {
        sectionTitle: 'JSON 提取（每轮 AI 回复后同步执行）',
        additionalPrompt: '额外 Prompt（JSON 生成指示）',
        additionalPromptHelp: '用于指示 AI 从对话历史中提取数据并生成 JSON。有填写才执行，结果写入下方指定流程数据。',
        additionalPromptPlaceholder: '例如：请将对话中提到的订单资料生成以下格式的 JSON：\n{\n  "customerName": "...",\n  "product": "...",\n  "quantity": 1,\n  "deliveryAddress": "..."\n}',
        jsonResultVariable: 'JSON 结果流程数据',
        jsonResultVariableHelp: '选择一个 JSON 类型的流程数据来存储 AI 每轮提取的 JSON 数据',
        jsonResultVariablePlaceholder: '选择 JSON 类型的流程数据',
      },
      batchRequireText: {
        enable: '图片批次必须附带文字说明',
        waitSeconds: '等待文字秒数',
        seconds: '秒',
        prompt: '未收到文字时的提示语',
        promptPlaceholder: '请附上文字说明，如楼盘/地址/工程描述，多谢！',
      },
    },
    
    enterFullscreen: '全屏显示',
    exitFullscreen: '退出全屏',
    
    // Overdue Settings（流程逾期设置 - Start 节点）
    overdueConfig: '流程逾期设置',
    overdueSettings: '逾期监控设定',
    overdue: {
      enabled: '启用逾期监控',
      duration: '逾期时限',
      escalation: '逾期通知设置',
      configureEscalation: '设置逾期通知',
      durationHelp: '流程从启动后超过此时限仍未完成，将发送逾期通知',
      escalationRecipients: '逾期通知收件人',
      escalationRecipientsDescription: '选择在流程逾期时需要接收通知的管理人员：',
      escalationMessage: '逾期通知消息',
      escalationMessageDescription: '设置当流程逾期时，发送给管理者的通知消息：',
      escalationMessagePlaceholder: '请输入逾期通知消息内容，告知管理者流程已逾期需要处理...',
      escalationMessageTip: '提示：此消息会在流程逾期时发送一次',
      escalationSaved: '逾期通知配置已保存',
      howItWorks: '运作方式',
      description1: '系统定时检查所有运行中的流程，计算从启动至今的时间',
      description2: '当超过设定的时限（天数 + 小时），且流程仍在运行（未 Complete 或 Failed），则发送逾期通知',
      description3: '逾期通知只发送一次，避免重复打扰',
    },
    
    // 功能说明
    waitReplyDescription1: '1. 流程执行到此节点时会暂停等待用户回复',
    waitReplyDescription2: '2. 只有指定的用户回复才会继续执行流程',
    waitReplyDescription3: '3. 如果启用验证，会检查用户输入是否符合要求',
    waitReplyDescription4: '4. 验证失败时会要求用户重新输入',
    waitReplyKnowledgeBaseEnabled: 'Dataset 作为知识库',
    waitReplyKnowledgeBaseEnabledHelp: '启用 AI 验证时，执行前先按条件查询指定 Dataset，将结果 JSON 一并传给 AI，便于对照主数据判断用户输入。AI Result 流程变量写入逻辑不变。',
    waitReplyKnowledgeBaseHint: '查询结果会以 JSON 传给 AI（条件编辑与 DataSet Query 节点相同）。数据量大时请用查询条件缩小范围。',
    waitReplyKnowledgeBaseDataSet: '知识库 Dataset',
    waitReplyKnowledgeBaseQueryConditions: '查询条件',
    knowledgeSourcesHint: '可同时或择一使用：「Dataset 作为知识库」会按查询条件将行数据以 JSON 传给 AI；「使用知识库」可多选 Studio 知识库文件，传入已发布版本之抽取文字。Dataset 仅能选一个；文件可选多份。',
    knowledgeSourceDataset: 'Dataset 作为知识库',
    knowledgeSourceDatasetHelp: '开启后可指定一个 Dataset 与查询条件，结果以 JSON 并入 AI 提示（与 DataSet Query 节点条件编辑相同）。',
    knowledgeSourceStudio: '使用知识库',
    knowledgeSourceStudioHelp: '多选与 Studio「知识库」页相同的文件；执行时仅纳入已发布版本内容。未发布者仍可选取以便设计，但执行时会跳过。',
    knowledgeSourceStudioPlaceholder: '选择知识库文件（可多选）',
    knowledgeSourceStudioDraft: '未发布',
    knowledgeBaseSettingsDrawerLabel: '使用知识库',
    knowledgeBaseSettingsDrawerHelp: '点「开启设置」于弹窗内一并设置「知识库 Dataset」（单一）与 Studio 知识库文件（可多选）；确定后写入节点。',
    knowledgeBaseSettingsModalTitle: '使用知识库设置',
    knowledgeBaseSettingsConfigure: '开启设置',
    knowledgeBaseSettingsOk: '确定',
    knowledgeBaseSettingsCancel: '取消',
    knowledgeBaseSettingsSectionDataset: '知识库 Dataset',
    knowledgeBaseSettingsSectionStudio: '知识库文件（可多选）',
    knowledgeStudioRagEnabled: '向量检索 (RAG)',
    knowledgeStudioRagHint: '开启后仅将 Top-K 相关 FAQ 片段传给 AI（需文件已完成向量索引）；默认关闭为全文模式。',
    knowledgeStudioTopK: 'Top-K 片段数',
    knowledgeStudioMaxContextChars: '最大上下文字符数',
    knowledgeStudioEmbeddingProvider: 'Embedding 供应商',
    knowledgeStudioEmbeddingProviderPlaceholder: '留空则使用公司默认 Embedding 供应商',
    knowledgeStudioRagProvider: 'RAG 引擎',
    knowledgeStudioRagProviderLocal: '自建管线（本地 Embedding）',
    knowledgeStudioRagProviderXai: 'xAI Collections（托管）',
    knowledgeStudioRagXaiHint: 'xAI Collections 由 xAI 云端托管。系统将自动搜索知识库中所有已建立 Collection 的分类，无需手动填入 ID。请确保：① 在知识库页面为各分类建立 Collection；② 将文件归入分类后发布。',
    knowledgeStudioRagXaiAutoSelected: '已检测到默认 AI 供应商为 xAI，自动使用 xAI Collections（托管）模式。',

    knowledgeBaseSettingsSummaryEmpty: '尚未设置',
    knowledgeBaseSettingsSummaryDataset: 'Dataset：{name}',
    knowledgeBaseSettingsSummaryAndStudio: '；文件 {count} 份',
    knowledgeBaseSettingsSummaryStudioOnly: '文件 {count} 份',
    knowledgeBaseSettingsSummaryMasterOn: '已开启（尚未选择文件或 Dataset）',
    knowledgeBaseSettingsMasterSwitch: '使用知识库',
    knowledgeBaseSettingsMasterHelp: '关闭时不向 AI 传递知识库内容；开启后可设置下方知识库文件与 Dataset。',
    knowledgeBaseSettingsQueryDivider: '查询条件',
    knowledgeBaseSettingsSectionCalendar: '日历事件',
    knowledgeBaseCalendarEnabledSwitch: '启用日历事件作为知识库',
    knowledgeBaseCalendarEnabledHelp: '开启后，执行时会依筛选模式查询日历事件，将事件清单以 JSON 传给 AI，供聊天机器人回答工作安排等问题。',
    knowledgeBaseCalendarFilterModeLabel: '人员筛选模式',
    knowledgeBaseCalendarFilterModeSelf: '查询本人（自动以触发流程的 WhatsApp 用户筛选）',
    knowledgeBaseCalendarFilterModeGroupTag: '指定群组／标签（可建不同流程给不同权限的人）',
    knowledgeBaseCalendarGroupIds: 'Broadcast Group',
    knowledgeBaseCalendarGroupIdsPlaceholder: '选择广播群组（可多选）',
    knowledgeBaseCalendarHashtags: 'Hashtag 标签',
    knowledgeBaseCalendarHashtagsPlaceholder: '输入标签后按 Enter，可多个',
    knowledgeBaseCalendarRelativeDays: '查询未来几天',
    knowledgeBaseCalendarRelativeDaysPlaceholder: '留空 = 不限日期',
    knowledgeBaseSettingsSummaryCalendarSelf: '日历：查本人',
    knowledgeBaseSettingsSummaryCalendarGroup: '日历：{n} 群组{tags}',
    eFormDescription1: '1. 选择要发送的 e-Form 表单',
    eFormDescription2: '2. 选择接收表单的用户（电话号码）',
    eFormDescription3: '3. 系统会将表单链接发送给指定用户',
    eFormDescription4: '4. 用户可以点击链接填写表单',
    eFormDescription5: '5. 表单提交后会触发后续流程',
    eFormDescription6: '6. 可设置审批结果变量来记录审批状态（approve/reject/pending）',
    eFormDescription7: '7. 审批结果可用于后续 Switch 节点进行流程分支',
    
    // 审批结果收集
    approvalResultVariable: '审批结果流程变量',
    selectApprovalResultVariable: '选择流程变量来记录审批结果',
    approvalResultInfo: '审批结果信息',
    approvalResultDescription1: '1. 当表单审批完成时，系统会自动将审批结果写入选定的流程变量',
    approvalResultDescription2: '2. 审批结果值：approve（已批准）、reject（已拒绝）、pending（待审批）',
    approvalResultDescription3: '3. 此变量可用于后续 Switch 节点进行流程分支',
    
    // 启动方式配置
    activationConfig: '启动方式配置',
    activationType: '启动方式',
    manualActivation: '手动启动',
    metaWebhookCall: '从 WhatsApp 启动',
    scheduledTableWatch: '定时监看数据表',
    emailMonitor: 'Email 监控',
    emailProvider: '邮件服务提供商',
    emailProviderPlaceholder: '请选择邮件服务提供商',
    emailNoProviderConfigured: '未配置邮件服务提供商，请在 API 管理中添加',
    emailMonitorMailbox: '监听的 Email Box (email address)',
    emailMonitorMailboxPlaceholder: '要监听的信箱地址，例如 user@company.com；留空则依提供商设定',
    emailFilterSender: '筛选发件人',
    emailFilterSenderPlaceholder: '留空则不筛选；可输入部分比对',
    emailFilterSubject: '筛选关键词（任一命中）',
    emailFilterSubjectPlaceholder: '留空则不筛选；任一关键词出现在主旨或内文即可',
    emailFilterKeywordsRequired: '必要关键词（全部必须）',
    emailFilterKeywordsRequiredPlaceholder: '留空则不强制；每个关键词都须出现在主旨或内文',
    emailFilterKeywordsMatchHint: '两栏之间为 AND：先通过「任一命中」，再检查「全部必须」；关键词会在主旨与内文搜索',
    emailFilterSenderNot: '发件人不包含',
    emailFilterSenderNotPlaceholder: '留空则不筛选；任一出现则排除',
    emailFilterSubjectNot: '主旨不包含',
    emailFilterSubjectNotPlaceholder: '留空则不筛选；任一出现则排除',
    emailFilterBodyKeywordsNot: '内文不包含',
    emailFilterBodyKeywordsNotPlaceholder: '留空则不筛选；任一出现则排除',
    emailFilterHasAttachment: '仅有附件的邮件',
    emailFilterAttachmentExtensions: '附件副档名筛选',
    emailFilterAttachmentExtensionsPlaceholder: '留空则不筛选；多个为 OR（任一副档名符合即可）',
    emailFilterAttachmentFileName: '附件档名包含',
    emailFilterAttachmentFileNamePlaceholder: '留空则不筛选；多个为 OR（档名包含任一关键词即可）',
    emailFilterAttachmentFileNameNot: '附件档名不包含',
    emailFilterAttachmentFileNameNotPlaceholder: '留空则不筛选；档名包含任一则排除',
    emailMonitorInfo: 'Email 监控说明',
    emailMonitorDescription1: '1. 系统会定期检查所选信箱，符合筛选条件的邮件将触发此流程',
    emailMonitorDescription2: '2. 触发后邮件内容与附件会写入流程，可搭配「整合 Email 监看 (AI 填表)」节点使用',
    watchTable: '监看数据表',
    queryCondition: '查询条件',
    checkInterval: '检查间隔 (秒)',
    
    // Webhook 相关
    webhookToken: 'Webhook Token',
    webhookTokenPlaceholder: '请输入 Webhook Token',
    whatsAppMenuName: 'WhatsApp 选单名称',
    whatsAppMenuNamePlaceholder: '选填，显示在 WhatsApp 选单的选项名称（留空则使用流程名称）',
    webhookInfo: 'Webhook 信息',
    webhookDescription1: '1. 请在公司设置页面配置 Meta Webhook URL',
    webhookDescription2: '2. 当收到 WhatsApp 消息时，系统会回复菜单让用户选择功能',
    webhookDescription3: 'Webhook Token 已在公司层级配置，流程将自动使用公司的 Webhook 设定',

    // Webhook 流程使用权限
    webhookAccess: {
      modalTitle: '选择允许启动本流程的联络人',
      modalIntro: '只有电话号码属于以下任一条件的联络人，才会在 WhatsApp 菜单中看到并可以启动此流程。',
      modeLabel: '流程使用权限',
      modePublic: '公众可用',
      modeRestricted: '限定指定联络人',
      allowedRecipientsLabel: '允许启动的联络人 / 群组 / 标签',
      allowedRecipientsHelp: '可勾选个别联络人、广播群组或联络人标签；只要符合任一条件即视为有权使用。',
      restrictedInfo: '此流程已限定使用对象，不在名单内的 WhatsApp 用户将看不到此选项。',
      fieldPlaceholder: '尚未选择任何联络人 / 群组 / 标签',
      fieldButton: '选择',
      selectedSummary: '已选择的允许名单',
      summaryGroups: '{count} 个群组',
      summaryHashtags: '{count} 个标签',
      summaryContacts: '{count} 个联络人',
    },

    scheduledTable: '监看数据表（旧）',
    scheduledTablePlaceholder: '例如: dbo.SoOrderManage',
    scheduledQuery: '查询条件（旧）',
    scheduledQueryPlaceholder: '例如: WHERE status = \'PENDING\'',
    scheduledInterval: '检查间隔',
    seconds: '秒',
    scheduledInfo: 'Dataset 定时触发（条件 + 写回）',
    scheduledDataSet: '要监看的 Dataset',
    scheduledTriggerConditions: '触发条件（哪些行会启动流程）',
    scheduledFieldMapping: '将列字段映射到流程变量',
    scheduledPostSuccessWriteBack: '流程创建成功后 — 写回该行',
    scheduledPostSuccessSetWriteBack: '设置写回字段',
    scheduledPostSuccessWriteBackSummary: '流程执行创建后将更新该行共 {count} 个字段。',
    scheduledPostSuccessOperationSaved: '已保存写回字段。',
    scheduledLegacySqlDeprecated: '此流程仍包含旧版自由填写的表名/SQL 字段。请改选 Dataset 并在下方配置条件组；服务器将忽略旧字段。',
    scheduledDescription1: '1. 选择一个 Dataset（类似从 Excel 上传的表格）。系统会按您设定的间隔扫描其中的行。',
    scheduledDescription2: '2. 触发条件：与 DataSet 节点相同的查询条件组。例如：状态 等于 待处理 且 部门 等于 销售 —— 只有符合条件的行才会新建一条流程执行。',
    scheduledDescription3: '3. 字段映射：把命中行上的列写入流程变量（如订单号、客户名），后续节点才能使用。',
    scheduledDescription4: '4. 写回：执行实例成功创建后，系统会更新同一行（例如把状态改为处理中），下一轮扫描便不会再次触发。请至少配置一个写回字段，避免重复开跑。',
    scheduledDescription5: '示例：Dataset「订单」有列状态、金额。触发条件为状态=新建；写回把状态改为处理中。某行首次符合条件时会开跑，写回后不再等于新建，便不会重复触发。',
    
    // 配置说明
    metaWebhookConfigTitle: 'Meta Webhook 配置说明',
    metaWebhookConfig1: '1. 请在公司设置页面配置 Meta Webhook URL',
    metaWebhookConfig2: '2. 当收到 WhatsApp 消息时，系统会回复菜单让用户选择功能',
    metaWebhookConfig3: '3. 根据用户选择启动对应的流程',
    metaWebhookConfig4: '4. 此流程将在用户选择后执行',
    scheduledWatchTitle: '定时监看说明',
    scheduledWatchDescription: '此功能正在开发中，将在后续版本中实现',
    
    // 模态框
    selectWhatsAppTemplate: '选择 WhatsApp 模板',
    selectEForm: '选择 e-Form 表单',
    noTemplatesAvailable: '暂无可用的模板，请先创建模板',
    noUsersAvailable: '暂无可用的用户，请先添加用户',
    noEFormsAvailable: '暂无可用的 e-Form 表单，请先创建表单',
    internalTemplate: '内部模板',
    
    // Meta 模板相关
    metaTemplate: {
      title: 'Meta 官方模板',
      edit: '编辑',
      editTitle: '编辑 Meta 模板',
      update: '更新',
      updating: '更新中...',
      updateSuccess: 'Meta 模板已更新并重新提交审核',
      updateFailed: '更新失败',
      approved: '已审核',
      pending: '审核中',
      rejected: '已拒绝',
      totalTemplates: "共 {count} 个模板",
      pageRange: "第 ",
      total: " 个模板",

      // 官方范本资料库
      fromLibrary: "从官方资料库建立",
      libraryTitle: "Meta 官方范本资料库",
      libraryHint: "从 Meta 官方资料库选择模板，建立后将成为您的自定模板并提交审核。",
      librarySearchPlaceholder: "搜索模板名称…",
      libraryTopic: "主题",
      libraryUsecase: "用途",
      libraryIndustry: "行业",
      libraryLanguage: "语言",
      libraryApplyFilters: "筛选",
      libraryEmpty: "没有符合条件的范本",
      libraryUse: "建立",
      libraryLoadFailed: "载入范本资料库失败",
      libraryCreateSuccess: "已从资料库建立模板",
      noData: "暂无模板",
    },

    templateLibraryTab: '范本资料库',
    templateLibrarySearchPlaceholder: '搜寻范本关键字',
    templateLibraryTopic: '主题',
    templateLibraryUsecase: '用途',
    templateLibraryIndustry: '行业',
    templateLibraryLanguage: '语言代码',
    templateLibraryApplyFilters: '套用筛选',
    templateLibraryHint: '选择后会向 Meta 提交建立至您的 WABA（含公司识别后缀）；通过审核后即可如一般 Meta 模板发送。',
    templateLibraryCatalog: '资料库',
    templateLibraryLoadFailed: '无法载入范本资料库',
    templateLibraryCreateFailed: '自范本资料库建立失败（若范本含按钮，可能需在 Meta 后台补齐 URL／电话等）',
    templateLibraryEmpty: '没有符合条件的范本',

    libTopic_ACCOUNT_UPDATE: '帐户更新',
    libTopic_CUSTOMER_FEEDBACK: '客户回馈',
    libTopic_ORDER_MANAGEMENT: '订单管理',
    libTopic_PAYMENTS: '付款',

    libUsecase_ACCOUNT_CREATION_CONFIRMATION: '帐户建立确认',
    libUsecase_AUTO_PAY_REMINDER: '自动付款提醒',
    libUsecase_DELIVERY_CONFIRMATION: '送达确认',
    libUsecase_DELIVERY_FAILED: '送达失败',
    libUsecase_DELIVERY_UPDATE: '配送更新',
    libUsecase_FEEDBACK_SURVEY: '回馈问卷',
    libUsecase_FRAUD_ALERT: '诈骗警示',
    libUsecase_LOW_BALANCE_WARNING: '余额不足警示',
    libUsecase_ORDER_CONFIRMATION: '订单确认',
    libUsecase_ORDER_DELAY: '订单延迟',
    libUsecase_PAYMENT_DUE_REMINDER: '付款到期提醒',
    libUsecase_SHIPMENT_CONFIRMATION: '出货确认',
    libUsecase_TRANSACTION_ALERT: '交易警示',

    libIndustry_E_COMMERCE: '电子商务',
    libIndustry_FINANCIAL_SERVICES: '金融服务',

    libLang_af: '南非荷兰语',
    libLang_sq: '阿尔巴尼亚语',
    libLang_ar: '阿拉伯语',
    libLang_az: '阿塞拜疆语',
    libLang_bn: '孟加拉语',
    libLang_bg: '保加利亚语',
    libLang_ca: '加泰罗尼亚语',
    libLang_zh_CN: '简体中文',
    libLang_zh_HK: '繁体中文（香港）',
    libLang_zh_TW: '繁体中文（台湾）',
    libLang_hr: '克罗地亚语',
    libLang_cs: '捷克语',
    libLang_da: '丹麦语',
    libLang_nl: '荷兰语',
    libLang_en: '英语',
    libLang_en_GB: '英语（英国）',
    libLang_en_US: '英语（美国）',
    libLang_et: '爱沙尼亚语',
    libLang_fil: '菲律宾语',
    libLang_fi: '芬兰语',
    libLang_fr: '法语',
    libLang_ka: '格鲁吉亚语',
    libLang_de: '德语',
    libLang_el: '希腊语',
    libLang_gu: '古吉拉特语',
    libLang_ha: '豪萨语',
    libLang_he: '希伯来语',
    libLang_hi: '印地语',
    libLang_hu: '匈牙利语',
    libLang_id: '印尼语',
    libLang_ga: '爱尔兰语',
    libLang_it: '意大利语',
    libLang_ja: '日语',
    libLang_kn: '卡纳达语',
    libLang_kk: '哈萨克语',
    libLang_rw_RW: '卢旺达语',
    libLang_ko: '韩语',
    libLang_ky_KG: '吉尔吉斯语',
    libLang_lo: '老挝语',
    libLang_lv: '拉脱维亚语',
    libLang_lt: '立陶宛语',
    libLang_mk: '马其顿语',
    libLang_ms: '马来语',
    libLang_ml: '马拉雅拉姆语',
    libLang_mr: '马拉地语',
    libLang_nb: '挪威语',
    libLang_fa: '波斯语',
    libLang_pl: '波兰语',
    libLang_pt_BR: '葡萄牙语（巴西）',
    libLang_pt_PT: '葡萄牙语（葡萄牙）',
    libLang_pa: '旁遮普语',
    libLang_ro: '罗马尼亚语',
    libLang_ru: '俄语',
    libLang_sr: '塞尔维亚语',
    libLang_sk: '斯洛伐克语',
    libLang_sl: '斯洛文尼亚语',
    libLang_es: '西班牙语',
    libLang_es_AR: '西班牙语（阿根廷）',
    libLang_es_ES: '西班牙语（西班牙）',
    libLang_es_MX: '西班牙语（墨西哥）',
    libLang_sw: '斯瓦希里语',
    libLang_sv: '瑞典语',
    libLang_ta: '泰米尔语',
    libLang_te: '泰卢固语',
    libLang_th: '泰语',
    libLang_tr: '土耳其语',
    libLang_uk: '乌克兰语',
    libLang_ur: '乌尔都语',
    libLang_uz: '乌兹别克语',
    libLang_vi: '越南语',
    libLang_zu: '祖鲁语',

    // 讯息模式
    directMessage: '直接输入讯息',
    useTemplate: '使用模板',
    sendEmail: '发送邮件',
    
    // 邮件配置
    email: {
      provider: '邮件服务提供商',
      providerRequired: '请选择邮件服务提供商',
      selectProvider: '选择邮件服务提供商',
      noProviderConfigured: '未配置邮件服务提供商。请在 API 管理中添加。',
      subject: '邮件主题',
      subjectRequired: '请输入邮件主题',
      subjectPlaceholder: '输入邮件主题',
      body: '邮件内容',
      bodyRequired: '请输入邮件内容',
      bodyPlaceholder: '输入邮件内容（支持流程变量，如 ${variableName}；若为 JSON 类型可用 ${JsonName.JsonFieldName}）',
      bodyHelp: '您可以在邮件内容中使用流程变量。点击上方的变量标签即可插入。支持富文本格式（粗体、斜体、颜色等）。若流程变量为 JSON，可使用 ${JsonName.JsonFieldName} 格式读取字段。',
      insertReceivedMediaTokenButton: '已接收媒体',
      insertReceivedMediaTokenTitle: '插入已接收媒体链接 token',
      richTextToolbarBold: '粗体',
      richTextToolbarItalic: '斜体',
      richTextToolbarUnderline: '下划线',
      richTextToolbarStrike: '删除线',
      richTextToolbarHeader: '标题级别',
      richTextToolbarTextColor: '文字颜色',
      richTextToolbarBackgroundColor: '背景颜色',
      richTextToolbarOrderedList: '有序列表',
      richTextToolbarBulletList: '无序列表',
      richTextToolbarAlign: '对齐方式',
      richTextToolbarLink: '插入链接',
      richTextToolbarClean: '清除格式（移除粗体、颜色、链接等样式）'
    },
    
    // 其他界面元素
    inDevelopment: '开发中',
    loadingWorkflow: '载入流程中…',
    clickToSelectConnection: '点击选择连接线',
    template: '模板',
    templateInfo: '模板信息',
    templatePreview: '模板预览',
    templateContent: '模板内容',
    templatePreviewNoData: '无模板资料可预览',
    templateId: '模板ID：',
    templateName: '模板名称：',
    formInfo: '表单信息',
    formId: '表单ID：',
    formName: '表单名称：',
    formDescription: '描述：',
    
    // 默认值和提示
    enterValidContent: '请输入有效内容',
    inputIncorrectRetry: '输入不正确，请重新输入',
    dateFormatExample: '例如：请输入请假日期，格式：YYYY-MM-DD',
    formatExample: '例如：格式不正确，请重新输入，例如：2024-01-15',
    tableExample: '例如: dbo.SoOrderManage',
    queryExample: '例如: WHERE status = \'PENDING\' AND created_at > @lastCheckTime',
    
    // 默认节点数据
    defaultStartNode: '开始',
    defaultEndNode: '结束',
    defaultSendWhatsAppNode: '发送消息',
    defaultSendTemplateNode: '发送 WhatsApp 模板',
    defaultWaitReplyNode: '等待用户回复',
    defaultWaitForQRCodeNode: '等待 QR Code 扫描',
    defaultWaitForEmailReplyNode: '等待 Email 回复',
    defaultQRCodeMessage: '请上传包含 QR Code 的图片',
    defaultSwitchNode: '条件分支',
    defaultDataSetQueryNode: 'DataSet 查询/更新',
    defaultCallApiNode: '触发外部 API',
    defaultSendEFormNode: '发送 e-Form',
    defaultEFormResultNode: 'e-Form 核准/拒绝',
    
    // 验证消息
    defaultReplyMessage: '请输入您的回复',
    defaultValidationPrompt: '请输入有效内容',
    defaultRetryMessage: '输入不正确，请重新输入',
    
    // 注释说明
    specifiedUsersComment: '指定人员的电话号码，用逗号分隔',
    scheduledIntervalComment: '5分钟',
    
    // 状态和其他标签
    statusEnabled: '启用',
    statusDisabled: '停用',
    designer: '设计者',
    functionDescription: '功能说明',
    
    // 错误消息
    saveFailed: '保存失败',
    updateFailed: '更新失败',
    createFailed: '创建失败',
    getTemplatesFailed: '获取模板列表失败',
    unknownError: '未知错误',
    
    // 验证错误消息
    missingStartNode: '缺少开始节点 (Start)',
    missingEndNode: '缺少结束节点 (End)',
    noConnections: '没有连接线',
    circularConnection: '发现循环连接：节点 "{nodeName}" 参与循环',
    isolatedNodes: '发现孤立节点：{nodeNames}',
    startNodeNoOutput: '开始节点 "{nodeName}" 没有输出连接',
    endNodeNoInput: '结束节点 "{nodeName}" 没有输入连接',
    
    // 节点类型说明
    nodeDescriptions: {
      start: '流程的开始点，只能有一个',
      end: '流程的结束点，可以有多个',
      waitReply: '等待用户回复的节点',
      sendMessage: '发送消息给用户的节点',
      condition: '根据条件决定流程方向的节点',
      form: '显示表单给用户填写的节点',
      webhook: '调用外部 API 的节点'
    },
    // 节点配置说明
    nodeConfigDescriptions: {
      waitReply: '1. 流程执行到此节点时会暂停等待用户回复\n2. 只有指定的用户回复才会继续执行流程',
      sendMessage: '1. 发送消息给用户\n2. 可以包含文字、图片、文件等\n3. 支持变量替换',
      condition: '1. 根据条件决定下一步流程\n2. 支持多个分支\n3. 可以根据用户输入、时间等条件判断',
      form: '1. 显示表单给用户填写\n2. 支持多种表单类型\n3. 表单提交后会触发后续流程',
      webhook: '1. 调用外部 API\n2. 可以发送数据到其他系统\n3. 根据 API 响应决定流程方向'
    },
    // 流程启动人选项
    initiatorOptions: {
      initiator: '流程启动人',
      anyUser: '任何用户',
      specificUser: '指定用户'
    },
    
    // 缺少的翻译键
    conditionLabel: '条件标签',
    conditionLabelPlaceholder: '请输入条件标签（可选）',
    cancel: '取消',
    add: '添加',
    selectDefaultPath: '选择默认路径',
    defaultPath: '默认路径',
    defaultPathDescription: '当所有条件群组都不满足时，将执行此默认路径',
    conditionValuePlaceholder: '请输入条件值',
    selectProcessVariable: '选择流程变量',
    qrCodeVariable: 'QR Code 变量',
    qrCodeMessagePlaceholder: '输入提示消息，例如：请上传包含 QR Code 的图片',
    qrCodeAiValidatorPromptHelp: 'AI 将验证 QR Code 图像解析出来的「QR Code 变量」中的值是否符合要求。请描述验证规则，例如「QR Code 内容必须是 6 位数字验证码」。',
    qrCodeAiValidatorPromptPlaceholder: '描述 QR Code 变量值需要满足的验证条件，例如「QR Code 内容必须是 6 位数字验证码」。',
    qrCodeDescription1: '此节点会等待用户上传包含 QR Code 的图片',
    qrCodeDescription2: '系统会自动扫描图片中的 QR Code 并提取内容',
    qrCodeDescription3: '扫描结果会保存到指定的流程变量中供后续节点使用',
    qrCodeSuccessMessage: 'QR Code 成功消息',
    qrCodeErrorMessage: 'QR Code 错误消息',
    seconds: '秒',
    messageWithVariablesPlaceholder: '输入消息内容，使用 ${variableName} 引用流程变量；若为 JSON 类型可用 ${JsonName.JsonFieldName}',
    availableVariables: '可用变量',
    variableSyntaxHelp: '点击变量标签插入到消息中，使用 ${variableName} 语法；JSON 流程变量可使用 ${JsonName.JsonFieldName}',
    switchConditions: '条件设置',
    equals: '等于',
    notEquals: '不等于',
    greaterThan: '大于',
    lessThan: '小于',
    contains: '包含',
    isEmpty: '为空',
    isNotEmpty: '不为空',
    conditionValue: '条件值',
    conditionLabel: '条件标签',
    remove: '移除',
    addCondition: '添加条件',
    newCondition: '新条件',
    defaultPath: '默认路径',
    defaultPathPlaceholder: '所有条件都不满足时的路径',
    switchDescription1: '此节点根据流程变量值决定执行路径',
    switchDescription2: '可设置多个条件，系统会按顺序检查每个条件',
    switchDescription3: '如果所有条件都不满足，将执行默认路径',
    timeout: '超时时间',
    condition1: '条件 1',
    
    // Switch 节点新 UI 翻译键
    conditionGroups: '条件群组',
    conditionGroup: '条件群组',
    conditions: '条件',
    outputPath: '输出路径',
    selectOutputPath: '选择输出路径',
    selectDefaultPath: '选择默认路径',
    addConditionGroup: '添加条件群组',
    
    // 图片相关
    loadingImages: '载入图片中...',
    noImagesReceived: '暂无接收的图片',
    imagePreview: '图片预览',
    previewImage: '预览图片',
    downloadImage: '下载图片',
    imageLoadFailed: '图片载入失败',
    imageStatusSuccess: '成功',
    imageStatusFailed: '失败',
    imageStatusProcessing: '处理中',
    imageStatusPending: '等待中',
    imagesApiNotExists: '图片 API 不存在',
    imagesApiNotImplemented: '图片 API 尚未实现',
    loadImagesFailed: '载入图片失败',
    loadedImagesData: '已载入图片数据',
    loadingImagesData: '正在载入图片数据',
    previousImage: '上一张图',
    nextImage: '下一张图',
    flipVertical: '垂直翻转',
    flipHorizontal: '水平翻转',
    rotateLeft: '逆时针旋转',
    rotateRight: '顺时针旋转',
    zoomOut: '缩小',
    zoomIn: '放大',
    editCondition: '编辑条件',
    operator: '操作符',
    operatorRequired: '请选择操作符',
    selectProcessVariableRequired: '请选择流程变量',
    noProcessVariables: '暂无可用的流程变量',
    noProcessVariablesHint: '请先在流程变量管理中创建流程变量',
    conditionValueRequired: '请输入条件值',
    conditionValuePlaceholder: '请输入条件值',
    conditionLabelPlaceholder: '请输入条件标签（可选）',
    jsonPvMapping: 'JSON 流程数据映射',
    jsonKeyPlaceholder: '请输入 JSON 键名（例如：amount、status、date）',
    jsonKeyDescription: '当流程数据为 JSON 类型时，请输入要提取的 JSON 键名。系统会从 JSON 对象中提取该键对应的值再与条件值比对。支持以 "." 分隔的嵌套键，例如 "order.amount"。',
    cancel: '取消',
    update: '更新',
    add: '添加',
    
    // Switch 节点新 UI 翻译键
    conditionGroups: '条件群组',
    conditionGroup: '条件群组',
    addConditionGroup: '添加条件群组',
    clickToSelectDefaultPath: '点击选择默认路径',
    
    // QR Code 节点翻译键
    qrCodeErrorMessage: 'QR Code 错误消息',
    waitReplySuccessMessage: '等待回复成功消息',
    waitReplyErrorMessage: '等待回复错误消息',
    waitReplySuccessMessagePlaceholder: '输入验证成功时发送的消息',
    waitReplyErrorMessagePlaceholder: '输入验证失败时发送的消息',
    
    // 通用翻译
    yes: '是',
    no: '否'
  },

  // 文档中心
  documentLibrary: {
    treeTitle: '文档目录',
    collapseTree: '收起目录',
    expandTree: '展开文档目录',
    resizeTree: '拖拽调整目录宽度',
    clearLocationFilter: '清除位置筛选',
    noData: '暂无数据',
    searchPlaceholder: '搜索文件名称、PV 值、表单字段、使用者…',
    filterType: '类型',
    filterUser: '使用者',
    filterModifiedDate: '修改日期',
    typeEForm: '表单 eForm',
    typeDoc: '文件 Doc',
    typeReport: '报表 Report',
    totalDocuments: '共 {count} 份文件',
    totalRows: '共 {count} 笔',
    noDocuments: '暂无文件',
    loadMore: '加载更多',
    colThumbnail: '缩图',
    colNameKeyValues: '名称 / 关键值',
    noPreviewImage: '无预览图',
    colWorkflow: '流程',
    colUser: '使用者',
    colStatus: '状态',
    colUpdated: '更新',
    colActions: '操作',
    definitionFallback: '定义 #{id}',
    executionLabel: '执行 #{id}',
    open: '打开',
    download: '下载',
    emptyValue: '—',
    datePresetToday: '今天',
    datePreset7d: '过去 7 天',
    datePreset30d: '过去 30 天',
    datePresetThisYear: '今年',
    datePresetLastYear: '去年',
    treeEFormCount: 'eForm×{count}',
    treeDocCount: 'Doc×{count}',
    treeReportCount: 'Report×{count}',
    errorTreeLoad: '加载目录树失败',
    errorSearch: '搜索失败',
    statusApproved: '已核准',
    statusCompleted: '已完成',
    statusRejected: '已拒绝',
    statusPending: '待处理',
    statusSubmitted: '已提交',
    valueSeparator: '：',
    exportPdfSuccess: 'PDF 导出成功',
    exportPdfFailed: 'PDF 导出失败',
    metaFlowsPdfNotSupported: 'MetaFlows 表单不支持 PDF 导出',
    saveSuccess: '表单已保存',
    saveFailed: '保存失败',
    selectedCount: '已选 {count} 份',
    batchDownloadZip: '下载 ZIP',
    clearSelection: '取消选择',
  },

  // Workflow Monitor (运行中的应用)
  workflowMonitor: {
    title: '运行中的应用',
    description: '监控和管理您的 WhatsApp 工作流程实例',
    runningAppsTitle: '运行中的应用',
    runningAppsDescription: '监控正在运行的工作流程应用状态',
    overview: '概览',
    activeInstances: '活跃实例',
    completedInstances: '已完成实例',
    failedInstances: '失败实例',
    totalInstances: '总实例数',
    runningInstances: '运行中实例',
    waitingInstances: '等待中实例',
    errorInstances: '错误实例',
    
    // Instance list
    instanceList: '实例列表',
    horizontalBoardTab: '流程活动横向看板',
    instanceListTab: '实例列表',
    selectWorkflowName: '选择流程名称',
    horizontalBoardDescription: '实时显示每个流程实例已开始的节点，节点开始后会自动加入。',
    loadingHorizontalBoard: '加载横向看板中...',
    loadHorizontalBoardFailed: '加载横向看板失败',
    noHorizontalBoardSteps: '目前没有已开始的流程节点',
    viewChatBotConversation: '查看对话',
    viewChatOrderingCartConversation: '查看购物车对话',
    chatBotConversationTitle: '聊天机器人对话',
    chatOrderingCartConversationTitle: '聊天购物车对话',
    chatBotSessions: '对话列表',
    chatBotMessages: '条消息',
    chatBotStateCollecting: '进行中',
    chatBotStateDone: '已结束',
    chatBotAiStaff: 'AI 员工',
    chatBotUser: '用户',
    chatBotNoMessages: '尚无对话消息',
    chatBotInputPlaceholder: '输入消息（Enter 发送，Shift+Enter 换行）',
    chatBotMessageSent: '消息已发送',
    chatBotMessageSendFailed: '消息发送失败',
    chatBotMessageFailed: '发送失败',
    chatBotMissingWaId: '此对话缺少 WhatsApp 号码，无法发送',
    chatBotAdminIntervention: 'Admin 介入',
    chatBotAdminInterventionHint: '此处发送的消息为 admin 介入，不会写入 ChatBot 对话历史',
    chatOrderingCartAdminInterventionHint: '此处发送的消息为 admin 介入，不会写入聊天购物车对话历史',
    noChatBotSessions: '此节点暂无对话记录',
    noChatOrderingCartSessions: '此节点暂无购物车对话记录',
    loadChatBotSessionsFailed: '加载聊天机器人对话失败',
    loadChatOrderingCartSessionsFailed: '加载聊天购物车对话失败',
    send: '发送',
    artifactLinks: '产物链接',
    htmlReport: 'HTML Report',
    htmlReportInstances: 'HTML Report 实例',
    generatedDocument: '生成文件',
    generatedDocumentInstances: '生成文件实例',
    loadingReportInstances: '加载 HTML Report 实例中...',
    loadingDocInstances: '加载生成文件实例中...',
    loadReportInstancesFailed: '加载 HTML Report 实例失败',
    loadDocInstancesFailed: '加载生成文件实例失败',
    openHtmlReport: '打开 HTML Report',
    openGeneratedDocument: '打开生成文件',
    noReportInstances: '暂无 HTML Report 实例',
    noDocInstances: '暂无生成文件实例',
    artifactPreview: '产物预览',
    executionTime: '执行时间',
    waitingFor: '等待',
    workflowName: '流程名称',
    instanceId: '实例ID',
    status: '状态',
    currentStep: '当前步骤',
    startedAt: '开始时间',
    endedAt: '结束时间',
    duration: '执行时间',
    createdBy: '创建者',
    errorMessage: '错误消息',
    
    // 统计卡片
    totalInstancesCount: '总实例数',
    runningCount: '运行中',
    completedCount: '已完成',
    successRate: '成功率',
    
    // Status
    statusRunning: '运行中',
    statusCompleted: '已完成',
    statusFailed: '失败',
    statusWaiting: '等待中',
    statusPaused: '已暂停',
    statusCancelled: '已取消',
    statusPending: '等待中',
    statusSent: '已发送',
    statusDelivered: '已送达',
    statusRead: '已读',
    statusPartiallyFailed: '部分失败',
    
    // Actions
    viewDetails: '查看详情',
    pause: '暂停',
    resume: '恢复',
    cancel: '取消',
    retry: '重试',
    viewLogs: '查看日志',
    
    // Filters
    filterAll: '全部',
    filterRunning: '运行中',
    filterCompleted: '已完成',
    filterFailed: '失败',
    filterWaiting: '等待中',
    searchPlaceholder: '搜索流程名称、实例ID...',
    selectStatus: '选择状态',
    startDateRange: '开始日期范围',
    endDateRange: '结束日期范围',
    refresh: '刷新',
    clearFilters: '清空',
    autoRefreshSettings: '自动刷新设置',
    
    // Instance details
    instanceDetails: '实例详情',
    basicInfo: '基本信息',
    triggerSource: '启动来源',
    executionHistory: '执行历史',
    triggerSourceEmail: 'Email',
    triggerSourceWhatsApp: 'WhatsApp 消息',
    triggerSourceUnknown: '未知来源',
    triggerSourceFrom: '发件人',
    triggerSourceTo: '收件人',
    triggerSourceSubject: '主旨',
    triggerSourceBody: '正文',
    triggerSourceReceivedAt: '接收时间',
    triggerSourceMessageId: '消息 ID',
    triggerSourceAttachments: '附件',
    triggerSourceContact: '联系人',
    triggerSourceMessageText: '消息内容',
    triggerSourceTimestamp: '时间',
    triggerSourceNoInput: '无启动数据',
    triggerSourceRawJson: '原始 JSON',
    triggerSourceStructured: '启动资料（表格）',
    triggerSourcePublishedManual: '已发布应用（手动）',
    triggerSourceUserMessage: '用户输入',
    manualTrigger: '手动触发',
    stepDetails: '步骤详情',
    formInstances: '表单实例',
    receivedImages: '接收图片',
    inputData: '输入数据',
    outputData: '输出数据',
    processVariables: '流程变量',
    workflowStarted: '流程启动',
    workflowCompleted: '流程完成',
    executionStep: '执行步骤',
    stepStatus: '状态',
    stepStartTime: '开始时间',
    stepEndTime: '完成时间',
    information: '信息',
    error: '错误',
    switchEvaluationResult: '条件分支结果',
    evaluatedAt: '判断时间',
    conditionGroupsCount: '条件群组数',
    defaultPathUsed: '使用默认路径',
    conditionMatched: '条件符合',
    selectedPathTarget: '选中路径',
    
    // Step details
    stepIndex: '步骤索引',
    stepType: '步骤类型',
    stepStatus: '步骤状态',
    stepStartedAt: '开始时间',
    stepEndedAt: '结束时间',
    stepDuration: '执行时间',
    stepInput: '输入数据',
    stepOutput: '输出数据',
    stepError: '错误消息',
    
    // Form instances
    formName: '表单名称',
    formStatus: '表单状态',
    formSubmittedAt: '提交时间',
    formApprovedAt: '批准时间',
    formRejectedAt: '拒绝时间',
    formApprovedBy: '批准者',
    formRejectedBy: '拒绝者',
    formApprovalNote: '批准备注',
    formRejectNote: '拒绝备注',
    
    // Statistics
    statistics: '统计信息',
    todayInstances: '今日实例',
    weekInstances: '本周实例',
    monthInstances: '本月实例',
    averageExecutionTime: '平均执行时间',
    successRate: '成功率',
    errorRate: '错误率',
    
    // Action confirmations
    confirmPause: '确定要暂停此流程实例吗？',
    confirmResume: '确定要恢复此流程实例吗？',
    confirmCancel: '确定要取消此流程实例吗？',
    confirmRetry: '确定要重试此流程实例吗？',
    cancelConfirmTitle: '取消流程实例',
    cancelConfirmMessage: '确定要取消此流程实例吗？流程将立即停止且无法恢复。',
    
    // Action results
    pauseSuccess: '流程实例已暂停',
    resumeSuccess: '流程实例已恢复',
    cancelSuccess: '流程实例已取消',
    retrySuccess: '流程实例重试已开始',
    operationFailed: '操作失败',
    whatsappChat: 'WhatsApp 对话',
    pause: '暂停',
    resume: '恢复',
    retry: '重试',
    cancel: '取消',
    delete: '删除',
    deleteSuccess: '流程实例已删除',
    deleteFailed: '删除流程实例失败',
    deleteConfirmTitle: '删除流程实例',
    deleteConfirmMessage: '确定要删除实例 {instanceId}（{workflowName}）吗？此操作将移除相关记录且无法恢复。',
    
    // Real-time updates
    realTimeUpdate: '实时更新',
    autoRefresh: '自动刷新',
    refreshInterval: '刷新间隔',
    lastUpdated: '最后更新',
    
    // Export functionality
    exportData: '导出数据',
    exportToExcel: '导出到Excel',
    exportToCsv: '导出到CSV',
    exportToPdf: '导出到PDF',
    
    // Batch operations
    batchOperations: '批量操作',
    batchPause: '批量暂停',
    batchResume: '批量恢复',
    batchCancel: '批量取消',
    batchRetry: '批量重试',
    batchDelete: '批量删除',
    clearSelection: '清除选择',
    selectInstances: '选择实例',
    selectedCount: '已选择 {count} 个实例',
    batchNoApplicableInstances: '所选实例中无可执行「{action}」的项',
    batchOperationSuccess: '已成功对 {count} 个实例执行「{action}」',
    batchOperationPartialFail: '部分操作失败：成功 {success} 个，失败 {fail} 个',
    batchCancelConfirmTitle: '批量取消流程实例',
    batchCancelConfirmMessage: '确定要取消所选的 {count} 个运行中实例吗？流程将立即停止且无法恢复。',
    batchDeleteConfirmTitle: '批量删除流程实例',
    batchDeleteConfirmMessage: '确定要删除所选的 {count} 个实例吗？此操作将移除相关纪录且无法复原。',
    emailDeleteConfirmTitle: '删除以 Email 触发的执行',
    emailDeleteConfirmContent: '此执行由 Email 触发。删除后是否允许该邮件再次触发流程？',
    emailDeleteAllowRetrigger: '是，删除后允许再次触发',
    emailDeleteKeepProcessed: '否，保留记录（该邮件不会再次触发）',
    batchDeleteEmailConfirmTitle: '批量删除（含 Email 触发）',
    batchDeleteEmailConfirmContent: '所选 {total} 笔中有 {emailCount} 笔为 Email 触发。删除后是否允许这些邮件再次触发流程？',
    deleteFilesChoiceTitle: '是否同时删除相关文件？',
    deleteFilesChoiceContentSingle: '实例 {instanceId}（{workflowName}）可能包含已接收的图片、视频、文件等档案。删除实例记录后，这些档案默认会保留在服务器上（不会自动删除）。请选择要如何处理：',
    deleteFilesChoiceContentBatch: '所选 {count} 个实例可能包含已接收的图片、视频、文件等档案。删除实例记录后，这些档案默认会保留在服务器上（不会自动删除）。请选择要如何处理：',
    deleteFilesChoiceKeepFiles: '只删除记录，保留档案',
    deleteFilesChoiceDeleteFiles: '同时删除记录与档案',
    deleteFilesChoiceDownloadThenDelete: '先下载备份，再删除记录与档案',
    deleteFilesBackupSuccess: '备份已下载',
    deleteFilesBackupEmpty: '此范围没有可备份的档案，将直接继续删除',
    deleteFilesBackupFailed: '打包备份档案失败',
    
    // Log viewing
    executionLogs: '执行日志',
    logLevel: '日志级别',
    logTime: '时间',
    logMessage: '消息',
    logDetails: '详情',
    
    // Performance monitoring
    performanceMetrics: '性能指标',
    responseTime: '响应时间',
    throughput: '吞吐量',
    resourceUsage: '资源使用',
    memoryUsage: '内存使用',
    cpuUsage: 'CPU使用',
    
    // Error handling
    errorHandling: '错误处理',
    errorCount: '错误数量',
    errorTrend: '错误趋势',
    errorDetails: '错误详情',
    errorResolution: '错误解决',
    
    // Notification settings
    notifications: '通知设置',
    emailNotifications: '邮件通知',
    smsNotifications: '短信通知',
    webhookNotifications: 'Webhook通知',
    notificationEvents: '通知事件',
    notifyOnError: '错误时通知',
    notifyOnCompletion: '完成时通知',
    notifyOnDelay: '延迟时通知',
    
    // 媒体文件相关
    receivedMedia: '已接收的媒体',
    loadingMediaFiles: '载入媒体文件中...',
    noMediaFiles: '暂无媒体文件',
    mediaFilesApiNotExists: '媒体文件 API 不存在',
    mediaFilesApiNotImplemented: '媒体文件 API 尚未实现',
    loadMediaFilesFailed: '载入媒体文件失败',
    loadedMediaFilesData: '已载入媒体文件数据',
    rootFolder: '根目录',
    files: '个文件',
    totalFiles: '总文件数',
    image: '图片',
    video: '视频',
    audio: '音频',
    document: '文档',
    file: '文件',
    view: '查看',
    download: '下载',
    
    // Lightbox 工具栏
    rotateLeft: '逆时针旋转',
    rotateRight: '顺时针旋转',
    flipHorizontal: '水平翻转',
    flipVertical: '垂直翻转',
    zoomIn: '放大',
    zoomOut: '缩小',
    reset: '重置',
    
    // 用户回复（消息验证）
    userReplies: '用户回复',
    validationPassed: '有效',
    validationFailed: '无效',
    others: '其他',
    caption: '文字：',
    reply: '则回复',
    replies: '则回复',
    
    // 消息发送详情
    viewMessageSendStatus: '查看发送状态',
    viewFormInstance: '查看表单实例',
    viewEmbedded: 'View Form Instance',
    loadingFormInstance: '加载表单实例中...',
    close: '关闭',
    openInNewTab: '在新标签页中打开',
    viewDataSet: '查看数据集',
    messageSendDetails: '消息发送详情',
    messageSendStatusDetails: '消息发送详细状态',
    sendOverview: '发送概览',
    recipientDetails: '收件人详情',
    statusAnalysis: '状态分析',
    totalRecipients: '总收件人数',
    sentCount: '已发送',
    deliveredCount: '已送达',
    readCount: '已读',
    failedCount: '失败',
    pendingCount: '等待中',
    sendBasicInfo: '发送基本信息',
    sendRecordId: '发送记录ID',
    messageSendId: '消息发送ID',
    workflowExecutionId: '工作流程执行ID',
    nodeId: '节点ID',
    nodeType: '节点类型',
    messageType: '消息类型',
    totalRecipientsCount: '总收件人数',
    successSendCount: '成功发送数',
    successCount: '成功数',
    failedSendCount: '失败发送数',
    startTime: '开始时间',
    endTime: '结束时间',
    completedAt: '完成时间',
    messageContent: '消息内容',
    errorInfo: '错误信息',
    recipient: '收件人',
    recipientName: '收件人',
    recipientType: '类型',
    recipientStatus: '状态',
    type: '类型',
    whatsAppMessageId: 'WhatsApp消息ID',
    whatsappMessageId: 'WhatsApp消息ID',
    sentAt: '发送时间',
    sendTime: '发送时间',
    deliveredAt: '送达时间',
    deliveredTime: '送达时间',
    readAt: '已读时间',
    readTime: '已读时间',
    retryCount: '重试次数',
    errorMessage: '错误信息',
    sendStatusDistribution: '发送状态分布',
    timeAnalysis: '时间分析',
    sendStartTime: '发送开始时间',
    sendEndTime: '发送完成时间',
    sendCompleteTime: '发送完成时间',
    totalSendTime: '总发送时间',
    sendSuccessRate: '成功率',
    deliveryRate: '送达率',
    user: '用户',
    contact: '联系人',
    group: '群组',
    hashtag: '标签',
    initiator: '流程启动人',
    phoneNumber: '电话号码',
    recipientTypeUser: '用户',
    recipientTypeContact: '联系人',
    recipientTypeGroup: '群组',
    recipientTypeHashtag: '标签',
    recipientTypeInitiator: '流程启动人',
    recipientTypePhoneNumber: '电话号码',
    pending: '等待中',
    sent: '已发送',
    delivered: '已送达',
    read: '已读',
    failed: '失败',
    retrying: '重试中',
    
    // 状态标签
    statusRunning: '运行中',
    statusCompleted: '已完成',
    statusFailed: '失败',
    statusWaiting: '等待中',
    statusPaused: '已暂停',
    statusCancelled: '已取消',
    
    // 时间单位
    minutes: '分钟',
    hours: '小时',
    
    // 操作结果
    operationSuccess: '操作成功',
    operationFailed: '操作失败',
    loadInstancesFailed: '加载实例失败',
    loadStatisticsFailed: '加载统计数据失败',
    loadDetailsFailed: '加载详情失败',
    loadMessageSendDetailsFailed: '加载消息发送详情失败',
    loadMessageSendStatusFailed: '加载消息发送状态失败',
    
    // 表单状态
    pendingApproval: '待审批',
    approved: '已批准',
    rejected: '已拒绝',
    
    // eForm 状态
    eformStatusPending: '待审批',
    eformStatusApproved: '已批准',
    eformStatusRejected: '已拒绝',
    eformStatusSubmitted: '已提交',
    
    // 布尔值
    yes: '是',
    no: '否',
    
    // 变量相关
    variableName: '变量名称',
    dataType: '数据类型',
    description: '描述',
    currentValue: '当前值',
    defaultValue: '默认值',
    setTime: '设置时间',
    setBy: '设置者',
    sourceType: '来源类型',
    sourceReference: '来源引用',
    required: '必需',
    hasValue: '有值',
    noValue: '无值',
    
    // 表单实例
    formInstance: '表单实例',
    exportPdfSuccess: 'PDF 导出成功',
    exportPdfFailed: 'PDF 导出失败',
    metaFlowsPdfNotSupported: 'MetaFlows 表单不支持 PDF 导出',
    formBasicInfo: '表单基本信息',
    formContent: '表单内容',
    formReplyContent: '表单回复内容',
    formName: '表单名称',
    instanceName: '实例名称',
    fillType: '填充类型',
    createdAt: '创建时间',
    userInput: '用户输入',
    approvalBy: '审批人',
    approvalTime: '审批时间',
    approvalNote: '审批备注',
    unnamedForm: '未命名表单',
    unnamed: '未命名',
    loadingEformInstances: '加载表单实例中...',
    loadingEmbeddedFormInstance: '加载内嵌表单实例中...',
    loadedEmbeddedFormInstance: '已加载内嵌表单实例',
    loadEmbeddedFormInstanceFailed: '加载内嵌表单实例失败',
    loadFormInstanceFailed: '加载表单实例失败',
    cannotLoadFormInstance: '无法加载表单实例',
    setAt: '设置时间',
    
    // 其他
    noStepExecutionRecords: '暂无步骤执行记录',
    loadingProcessVariables: '加载流程变量中...',
    loadingFormInstances: '加载表单实例中...',
    noProcessVariables: '暂无流程变量',
    noEformInstances: '暂无表单实例',
    noFormInstances: '暂无表单实例',
    selectedInstances: '已选择 {count} 个实例',
    paginationTotal: '第 {start}-{end} 项，共 {total} 项',
    pageRange: '第 {start}-{end} 项，共 {total} 项',
    itemsPerPage: '条/页',
    jumpTo: '跳至',
    page: '页',
    confirm: '确定',
    whatsappChat: 'WhatsApp 对话',
    openSettingsModal: '打开设置弹窗',
    cannotFindMessageSendId: '无法找到消息发送记录ID，请检查后端数据',
    
    // MessageSendStatusModal 相关翻译
    messageSendStatus: '消息发送状态',
    loadingMessageSendRecords: '加载消息发送记录中...',
    loadMessageSendRecordsFailed: '加载消息发送记录失败',
    normalSend: '正常发送',
    retrySend: '提醒发送',
    escalationNotification: '升级通知',
    normalSendRecords: '正常消息发送记录',
    retrySendRecords: '提醒消息发送记录',
    escalationSendRecords: '升级消息发送记录',
    totalSendCount: '总发送数',
    successCount: '成功数',
    failureCount: '失败数',
    currentRecord: '当前',
    messageSendId: '消息发送ID',
    nodeId: '节点ID',
    sendReason: '发送原因',
    sendReasonNormal: '正常发送',
    sendReasonRetry: '提醒发送',
    sendReasonEscalation: '升级通知',
    sendReasonOverdue: '逾期通知',
    status: '状态',
    totalRecipients: '总收件人',
    successCount: '成功数',
    failedCount: '失败数',
    creator: '创建者',
    startTime: '开始时间',
    viewDetails: '查看详情',
    noMessageSendRecords: '暂无消息发送记录',
    recipientDetails: '收件人详情',
    recipient: '收件人',
    whatsAppMessageId: 'WhatsApp消息ID',
    sendTime: '发送时间',
    deliveredTime: '送达时间',
    readTime: '已读时间',
    retryCount: '重试次数',
    errorMessage: '错误信息',
    createTime: '创建时间',
    normal: '正常',
    retry: '重试',
    escalation: '升级',
    overdue: '逾期',
    pending: '等待中',
    inProgress: '进行中',
    completed: '已完成',
    failed: '失败',
    partiallyFailed: '部分失败',
    sent: '已发送',
    delivered: '已送达',
    read: '已读',
    retrying: '重试中',
    operation: '操作',
    person: '人',
    time: '时间',
    userResponse: '用户回应',
    error: '错误',
    step: '步骤'
  },

  // Workflow List Page
  workflowList: {
    add: '新增',
    batchDelete: '批量删除',
    batchEnable: '批量启用',
    batchDisable: '批量停用',
    clearFilter: '清除筛选',
    manualStart: '手动启动',
    select: '选择',
    clear: '清除',
    confirmBatchDelete: '确认批量删除',
    confirmBatchEnable: '确认批量启用',
    confirmBatchDisable: '确认批量停用',
    confirmDelete: '确认删除',
    cancel: '取消',
    confirmDeleteSelected: '确定要删除选中的',
    confirmEnableSelected: '确定要启用选中的',
    confirmDisableSelected: '确定要停用选中的',
    workflows: '个流程',
    cannotBeUndone: '此操作无法撤销！',
    successfullyDeleted: '已成功删除',
    successfullyEnabled: '已成功启用',
    successfullyDisabled: '已成功停用',
    batchDeleteFailed: '批量删除失败',
    batchOperationFailed: '批量操作失败',
    pleaseSelectWorkflows: '请选择要删除的流程',
    pleaseSelectWorkflowsToOperate: '请选择要操作的流程',
    workflowStarted: '已成功启动',
    manualStartMessage: '手动启动的流程'
  },

  apiProviders: {
    pageTitle: 'API 供应商管理',
    pageDescription: '集中管理 AI 与云端文档等外部 API，配置各供应商的连接信息、模型与密钥，方便团队共用与扩展。',
    actions: {
      refresh: '重新整理'
    },
    messages: {
      loadFailed: '加载 API 供应商失败，请稍后再试。',
      saveSuccess: '设置已更新。',
      saveFailed: '保存失败，请检查输入或稍后再试。',
      loadDetailFailed: '加载供应商详细设置失败，请稍后重试。',
      validationFailed: '表单验证失败，请检查输入内容。'
    },
    empty: '尚未有可管理的 API 供应商。',
    category: {
      ai: 'AI 服务',
      clouddoc: '云端文档',
      emailserver: '邮件服务器',
      erp: 'ERP 系统',
      voice: '语音 AI',
      embedding: 'Embedding / RAG',
      rag: '托管 RAG（Collections）'
    },
    noDescription: '尚未提供描述。',
    description: {
      'xai': 'Elon AI Grok 官方 API',
      'xai-stt': 'xAI 语音转文字（Speech-to-Text）API',
      'xai-embed': 'xAI Embeddings（⚠️ xAI 目前无 embedding 模型，无法使用；请改用 OpenAI/Gemini Embeddings，或改用「托管 RAG → xAI Collections」）',
      'xai-collections': 'xAI Collections（托管 RAG）：文件上传至 xAI 云端，由 xAI 自动 chunk/embedding/索引，通过 /v1/documents/search 做语意搜索。需 xAI API Key。',
      'openai-embeddings': 'OpenAI Embeddings（知识库 RAG，模型：text-embedding-3-small）',
      'gemini-embeddings': 'Google Gemini Embeddings（知识库 RAG，模型：text-embedding-004）',
      'deepseek-embeddings': 'DeepSeek Embeddings（⚠️ 官方 API 不支持 Embedding，请改用 xai-embed / openai-embeddings）',
      'copilot-embeddings': 'GitHub Models Embeddings（需 GitHub PAT + models:read 权限）',
      'openai': 'OpenAI Chat Completions',
      'openai-whisper': 'OpenAI Whisper 语音转文字（Speech-to-Text）API',
      'deepseek': 'DeepSeek 官方 Chat API',
      'copilot': 'Copilot Chat API（需企业授权）',
      'gemini': 'Google AI Gemini API',
      'google-docs': 'Google Docs 读写 API（Dataset 导入、文档同步）',
      'microsoft-graph': '使用 Microsoft Graph API 通过 Office 365 发送电子邮件，需要 OAuth 2.0 认证与 Mail.Send 权限。',
      'odoo': 'Odoo 19 ERP 集成（PO / 报价单 / 销售单 / 发票 / 出货 / 收货 / 退货 / 信用备忘录 / 收款），支持 XML-RPC 与 JSON-2 双协定。'
    },
    status: {
      active: '启用',
      inactive: '停用',
      activeTip: '此供应商目前可供流程与工具使用。',
      inactiveTip: '此供应商目前未启用。'
    },
    apiKey: {
      set: '已设置密钥',
      missing: '尚未设置密钥',
      setTip: '密钥已保存，可直接使用。',
      missingTip: '尚未设置密钥，将无法完成授权。'
    },
    configure: '设置详情',
    modal: {
      title: '设置 {name}',
      loadingTitle: '载入设置中...',
      save: '保存设置',
      cancel: '取消',
      providerKeyLabel: 'Provider Key',
      defaultUrl: '官方预设 API URL',
      defaultModel: '官方建议模型'
    },
    form: {
      active: '启用状态',
      apiUrl: 'API URL',
      apiUrlRequired: '请输入 API URL。',
      apiUrlEmailServerTip: 'Microsoft Graph API URL 中的 {userPrincipalName} 会在发送邮件时自动替换为发件人的 email 地址。',
      model: '模型',
      modelRequired: '请选择或输入模型。',
      modelPlaceholder: '请输入模型名称',
      temperature: 'Temperature',
      temperatureTip: '控制输出随机度，值越高越具创造性。',
      topP: 'Top P',
      topPTip: '控制采样范围，值越低越保守。',
      enableStreaming: '启用串流输出',
      apiKey: 'API Key',
      apiKeyPlaceholder: '输入新的 API Key',
      clearApiKey: '清除已保存的 API Key',
      maskedKey: '目前已保存的密钥：{key}',
      managementApiKey: 'Management API Key',
      managementApiKeyHint: '用于创建 / 管理 xAI Collections（需 Management Key 权限）。仅 Tenant Admin 可设置。',
      managementApiKeyPlaceholder: '输入 xAI Management API Key',
      clearManagementApiKey: '清除已保存的 Management API Key',
      extraHeaders: '额外 HTTP Headers (JSON)',
      extraHeadersTip: '若需要自定义 Header，请输入 JSON 格式，例如 {"X-Custom-Header":"value"}。',
      authType: '授权类型',
      authTypeTip: '选择此供应商的授权方式，默认采用官方建议。',
      authTypePlaceholder: '选择授权类型',
      authTypeOptions: {
        apiKey: 'API Key',
        bearerToken: 'Bearer Token',
        serviceAccount: 'Service Account JSON',
        oauth: 'OAuth 2.0'
      },
      authConfigJson: '授权配置 (JSON)',
      authConfigTip: '用于存放租户、客户端 ID、Service Account 等授权信息。',
      authConfigJsonEmailServer: 'OAuth 2.0 授权配置 (JSON)',
      authConfigTipEmailServer: 'Microsoft Graph API 需要 OAuth 2.0 认证，请输入 JSON 格式：{"tenantId":"your-tenant-id","clientId":"your-client-id","clientSecret":"your-client-secret"}',
      oauthConfig: 'OAuth 2.0 认证设置',
      tenantId: 'Tenant ID',
      tenantIdRequired: '请输入 Tenant ID',
      tenantIdTip: 'Azure AD 租户 ID，可在 Azure Portal 中找到',
      clientId: 'Application (client) ID',
      clientIdRequired: '请输入 Application (client) ID',
      clientIdTip: '应用程序 (客户端) ID，可在 Azure Portal 的应用程序注册中找到',
      clientSecret: 'Client Secret',
      clientSecretRequired: '请输入 Client Secret',
      clientSecretTip: '应用程序密钥值，可在 Azure Portal 的应用程序注册中创建',
      emailSettings: '邮件发送设置',
      fromEmail: '收及发件人电子邮件',
      fromEmailRequired: '请输入收及发件人电子邮件地址',
      fromEmailInvalid: '请输入有效的电子邮件地址',
      fromEmailTip: '同时用于：发送邮件时的发件人地址；流程 Start 节点 Email 监控时所监听的信箱（收件人）。',
      replyTo: '回复地址',
      replyToInvalid: '请输入有效的电子邮件地址',
      replyToTip: '收件人回复时使用的地址（可选）',
      saveToSentItems: '保存到已发送项目',
      saveToSentItemsTip: '是否将发送的邮件保存到发件人的已发送项目文件夹',
      enabled: '启用',
      disabled: '停用',
      testEmail: '发送测试邮件',
      testEmailModalTitle: '发送测试邮件',
      sendTestEmail: '发送',
      testEmailTo: '收件人',
      testEmailToRequired: '请输入收件人地址',
      testEmailToInvalid: '请输入有效的电子邮件地址',
      testEmailToTip: '测试邮件将发送到此地址',
      testEmailSubjectLabel: '邮件主题',
      testEmailSubject: 'WhattoFlow 邮件发送测试',
      testEmailSubjectRequired: '请输入邮件主题',
      testEmailBodyLabel: '邮件内容',
      testEmailBody: '这是一封测试邮件，用于验证 Microsoft Graph API 邮件发送配置是否正确。',
      testEmailBodyRequired: '请输入邮件内容',
      testEmailSuccess: '测试邮件发送成功！请检查收件箱。',
      testEmailFailed: '测试邮件发送失败，请检查配置。',
      testEmailValidationError: '请先填写必要的配置字段（Tenant ID、Client ID、Client Secret、发件人地址）。',
      settingsJson: '进阶设置 (JSON)',
      settingsJsonTip: '自定义供应商专属参数，例如 temperature、top_p、top_k。',
      settingsJsonEmailServer: '邮件设置 (JSON)',
      settingsJsonTipEmailServer: '邮件发送相关设置，例如：{"fromEmail":"sender@example.com","replyTo":"reply@example.com","saveToSentItems":true}',
      resetSettings: '套用官方预设',
      resetSettingsHint: '将以供应商预设值覆盖当前设置。',
      jsonInvalid: '请输入有效的 JSON 格式。',
      odooSettings: 'Odoo 连线设置',
      odooProtocol: '通讯协定',
      odooProtocolTip: 'XML-RPC：所有 Odoo 部署皆支持。JSON-2：仅 Odoo Custom plan 支持；其他方案请选 XML-RPC（系统会自动 fallback）。',
      odooDatabase: 'Database',
      odooDatabaseRequired: '请输入 Odoo Database 名称。',
      odooDatabaseTip: '与 Odoo 登入页所显示的 db 名称相同。',
      odooDefaultLogin: '服务账号 Login',
      odooDefaultLoginRequired: '请输入服务账号 Login。',
      odooDefaultLoginTip: '建议使用集成专用账号，并在 Odoo Settings → Users → API Keys 产生 API Key。',
      odooDefaultCompanyId: '默认公司 ID（多公司情境）',
      odooDefaultCompanyIdTip: '会强制 Odoo context.allowed_company_ids；单公司可留空。',
      odooPort: 'Port',
      odooPortTip: '默认 443 (HTTPS)；自架/内网 Odoo 常见为 8069。',
      odooTimeoutSeconds: '超时秒数',
      odooApiKeyHint: 'API Key：在 Odoo Settings → Users → API Keys 产生（Odoo 14+）。JSON-2 内 Key 每 3 个月需轮换一次。',
      testOdoo: '测试 Odoo 连线',
      testOdooSuccess: 'Odoo 连线测试成功',
      testOdooFailed: 'Odoo 连线测试失败',
      testOdooValidationError: '请先填写 API URL、Database 与服务账号 Login。',
      voiceSettings: '语音转文字设定',
      embeddingSettings: 'Embedding 设定',
      testEmbedding: '测试 Embedding',
      testEmbeddingOk: 'Embedding 成功（模型：{model}，维度：{dimensions}）',
      testEmbeddingFailed: 'Embedding 测试失败',
      queryAvailableModels: '查询此 Provider 可用模型',
      embeddingModelsTitle: '可用 Embedding 模型',
      embeddingModelsHint: '复制以下模型名称并粘贴到上方「模型」字段。',
      embeddingModelsEmpty: '未找到任何 Embedding 模型，请确认 API 密钥是否有效。',
      embeddingExperimentalHint: 'GitHub Models (copilot-embeddings) 需要具有 models:read 权限的 GitHub PAT。自建 RAG 建议使用 openai-embeddings 或 gemini-embeddings；xAI 请改用「托管 RAG → xAI Collections」。',
      voiceLanguage: '默认语言代码',
      voiceLanguageTip: '语言代码用于启用 ITN（数字/货币格式化）。x.ai 目前支持的格式化语言：en、ja、ko、fr、de 等（不含 zh 中文）。接收粤语 / 中文请留空，模型会自动侦测语言并转录，不影响准确度。',
      voiceFormat: '启用 ITN 格式化（format）',
      voiceFormatTip: '开启后，语音中的数字、货币等会被转换为书写格式（如"一百元"→"$100"）。需设定语言代码。',
      voiceApiKeyHint: 'API Key：x.ai STT 使用与 Chat 相同的 Bearer API Key。',
      testStt: '测试语音转文字',
      testSttSuccess: '语音转文字测试成功',
      testSttFailed: '语音转文字测试失败',
      advanced: '进阶'
    }
  },

  // WhatsApp 电话号码验证管理
  phoneVerification: {
    title: 'WhatsApp 电话号码验证管理',
    refresh: '刷新',
    uploadCertificate: '上传凭证',
    currentCompany: '当前公司：{name}',
    allCompaniesBanner: '以下列表为所有公司之 WhatsApp 电话验证记录。',
    tenantAdminHint: '以下为全系统各公司之验证记录。上传凭证时请于窗口中选择目标公司（目前默认操作脉络：{name}）。',
    filterByCompany: '筛选公司',
    filterCompanyPlaceholder: '全部公司',
    loadVerificationsForbidden: '无权加载验证列表，请确认已登录且具 Tenant_Admin。',
    phoneNumber: '电话号码',
    status: '状态',
    certificateExpiry: '凭证过期时间',
    codeExpiry: '验证码过期时间',
    phoneNumberId: 'Phone Number ID',
    createdAt: '创建时间',
    actions: '操作',
    view: '查看',
    copyUrl: '复制 URL',
    delete: '删除',
    deleteConfirmTitle: '确定删除此条验证记录？',
    deleteConfirmDesc: '删除后无法恢复，若客户仍持有旧链接将无法再使用。',
    deleteOk: '删除',
    deleteSuccess: '已删除验证记录',
    deleteFailed: '删除失败',
    deleteForbidden: '无权删除，请确认已登录且具 Tenant_Admin。',
    uploadModalTitle: '上传凭证和电话号码',
    company: '公司',
    companyRequired: '请选择公司',
    companySelectPlaceholder: '请选择公司',
    currentCompanyPlaceholder: '当前公司',
    phoneNumberIdSelectLabel: 'Phone Number ID（从公司主档选取）',
    phoneNumberIdSelectFromCompany: '公司主档',
    phoneNumberIdSelectPlaceholder: '请选取或输入 Phone Number ID',
    certificate: '数码凭证 (Base64)',
    certificateRequired: '请输入凭证',
    certificateFormatError: '凭证格式可能不正确',
    certificateHelp: '请从 Meta Business Suite 复制 base64 编码的数码凭证',
    certificatePlaceholder: '请粘贴 base64 编码的凭证...',
    submit: '提交',
    cancel: '取消',
    uploadSuccess: '凭证已上传',
    uploadSuccessTitle: '上传成功',
    uploadSuccessMessage: '凭证已成功上传，请将以下 URL 发送给客户：',
    verificationUrl: '验证 URL',
    copyUrlButton: '复制 URL',
    urlCopied: 'URL 已复制到剪贴板',
    uploadFailed: '上传失败',
    loadFailed: '加载失败',
    loadVerificationsFailed: '加载验证记录失败',
    viewDetails: '查看详情',
    loadDetailsFailed: '加载详情失败',
    verificationRecordDetails: '验证记录详情',
    verificationMethod: '验证方式',
    updatedAt: '更新时间',
    errorMessage: '错误信息',
    na: 'N/A',
    detailTitle: '验证记录详情',
    detailPhoneNumber: '电话号码：',
    detailStatus: '状态：',
    detailCertificateExpiry: '凭证过期时间：',
    detailCodeExpiry: '验证码过期时间：',
    detailVerificationMethod: '验证方式：',
    detailPhoneNumberId: 'Phone Number ID：',
    detailCreatedAt: '创建时间：',
    detailUpdatedAt: '更新时间：',
    detailErrorMessage: '错误信息：',
    detailVerificationUrl: '验证 URL：',
    verificationUrlCopied: '验证 URL 已复制到剪贴板',
    totalRecords: '共 {total} 条记录',
    
    // 状态标签
    statusPending: '待处理',
    statusRequested: '已请求验证码',
    statusVerified: '已验证',
    statusExpired: '已过期',
    statusFailed: '失败',
    
    // 表单验证和提示
    phoneNumberRequired: '请输入电话号码（Company.WA_PhoneNo_ID 未配置）',
    phoneNumberInvalid: '请输入有效的电话号码（例如：+85296062000 或 85296062000）',
    phoneNumberOptional: '可选：如果留空，系统将从 Meta API 或 Company.Phone 自动获取',
    phoneNumberRequiredWhenNoId: '必需：因为 Company.WA_PhoneNo_ID 未配置',
    phoneNumberPlaceholderOptional: '可选：留空将自动从 Meta API 获取',
    phoneNumberPlaceholderRequired: '例如：+85296062000 或 85296062000',
    
    // 错误信息
    loadCompanyInfoFailed: '加载公司信息失败',
    cannotGetCompanyId: '无法获取公司 ID',
    cannotGetCompanyInfo: '无法获取公司信息，请重新登录',
    cannotLoadVerifications: '无法加载验证记录：公司 ID 为空',
    unknownError: '未知错误',
    
    // 国家代码检测
    duplicateCountryCodeDetected: '检测到重复的国家代码，已自动移除'
  },

  // 权限管理
  permissionManagement: {
    title: '权限管理',
    roleName: '角色名称',
    description: '描述',
    pageDescription: '管理角色与界面权限',
    interfaces: '界面权限',
    actions: '操作',
    systemDefault: '系统默认',
    companyCustom: '公司自定义',
    selectCompany: '选择公司',
    noPermissions: '无权限',
    saveSuccess: '权限保存成功',
    saveFailed: '保存权限失败',
    loadFailed: '加载权限失败',
    editingCompany: '编辑公司'
  },
  reports: {
    noPermission: '您沒有權限訪問報表功能',
    loadPermissionFailed: '載入權限失敗',
    unauthorized: '未授權',
    noDailyReportsPermission: '您沒有權限訪問任何每日報表',
    noMonthlyReportsPermission: '您沒有權限訪問任何每月報表',
    noEformInstanceReportsPermission: '您沒有權限訪問表單實例報表',
    loadStatisticsFailed: '載入統計數據失敗',
    loadDataFailed: '載入報表數據失敗',
    exportComingSoon: '匯出功能即將推出',
    totalPending: '待處理總數',
    overdue: '逾期事項',
    urgent: '緊急事項',
    todayNew: '今日新增',
    totalRecords: '共 {total} 條記錄',
    dateRange: '时间范围',
    eformInstancesTitle: 'EForm Instance 报表',
    eformInstancesDescription: '查询并预览表单填写结果，支持一页一张 PDF 导出',
    eformInstancesFilters: '查询条件',
    eformInstancesKeyword: '关键字',
    eformInstancesKeywordPlaceholder: '表单名称 / 实例名称 / 表单栏位内容',
    eformInstancesStatus: '状态',
    eformInstancesPreview: '预览',
    eformInstancesNoPreview: '没有可预览的内容',
    eformInstancesNoData: '没有符合条件的表单资料',
    eformInstanceManualPending: '待回应表单',
    eformInstanceManualResponded: '已收到回应表单',
    // EForm Pivot Reports
    eformPivot: '表单枢纽分析',
    eformPivotTitle: 'EForm 枢纽分析报表',
    eformPivotDescription: '自定度量与维度，对表单实例进行分组汇总分析',
    noEformPivotPermission: '您没有权限访问表单枢纽分析报表',
    pivotMeasure: '度量 (Measure)',
    pivotCount: '笔数',
    pivotRowDimension: '列维度 (Rows)',
    pivotColDimension: '栏维度 (Columns)',
    pivotSystemFields: '系统栏位',
    pivotFormFields: '表单栏位',
    pivotSwapAxes: '交换列/栏',
    pivotTotal: 'Total',
    pivotRecords: '笔',
    pivotDrillDownTitle: '明细记录',
    pivotDateYear: '年',
    pivotDateQuarter: '季',
    pivotDateMonth: '月',
    pivotDateDay: '日',
    pivotFilterByForms: '选择表单（可多选）',
    pivotFilterByFormsPlaceholder: '不选＝全部表单',
    exportExcel: '导出 Excel',
    exportExcelSuccess: '已导出 Excel',
    exportExcelFailed: '导出 Excel 失败',
    noCommerceReportsPermission: '您没有权限访问商务管理报表',
    commerce: {
      title: '商务管理报表',
      statement: 'Statement 月结',
      salesPivot: '销售订单 Pivot',
      noStatementPermission: '您没有权限访问 Statement 月结报表',
      noSalesPivotPermission: '您没有权限访问销售订单 Pivot',
      monthRange: '送货月份范围',
      month: '月份',
      customers: '客户',
      allCustomers: '全部客户',
      selectCustomers: '选择客户',
      loadFailed: '加载报表失败',
      grandTotal: '总计',
      monthTotal: '月小计',
      customerTotal: '客户小计',
      orderNo: '订单编号',
      deliveryDate: '送货日期',
      amount: '金额',
      paymentTerm: '付款条款',
      lineCount: '明细行数',
      qty: '数量',
      total: '金额',
      orderCount: '订单数',
      pivotMeasure: '度量',
      pivotRowDimension: '列维度',
      pivotColDimension: '栏维度',
      pivotTotal: 'Total',
      exportExcel: '导出 Excel',
      exportPdf: '导出 PDF',
      exportSuccess: '导出成功',
      exportFailed: '导出失败',
      noData: '没有符合条件的数据',
      company: '公司',
      selectCompany: '选择公司',
      dateRange: '送货日期范围'
    },
    expandCollapseAll: '全部展开/收合',
    noFieldSummary: '无栏位摘要设定',
    pdfExportCount: '导出次数',
    daily: {
      pendingOverview: '待批事项总览',
      workflowExecution: '工作流执行日报',
      formEfficiency: '表单处理效率',
      workflowHealth: '工作流健康度监控',
      whatsappInteraction: 'WhatsApp 互动分析'
    },
    monthly: {
      workflowPerformance: '工作流效能月报',
      formApproval: '表单审批分析月报',
      businessInsights: '业务流程洞察',
      systemUsage: '系统使用统计',
      operationalOverview: '营运效能总览'
    },
    realtime: {
      workflowActivity: '工作流活动看板',
      description: '实时监控所有正在运行的步骤执行（每 3 秒自动更新）',
      totalActive: '活跃步骤',
      running: '运行中',
      waiting: '等待中',
      completed: '已完成',
      failed: '失败',
      noActiveWorkflows: '目前没有活跃的流程',
      noActiveSteps: '目前没有活跃的步骤执行',
      noItems: '无项目',
      selectWorkflow: '选择流程定义',
      allWorkflows: '全部流程',
      dateRange: '时间范围:',
      workflowDefinition: '流程定义:',
      createdAt: '创建时间:',
      executionTime: '执行时间:',
      stepIndex: '步骤索引:',
      initiatedBy: '启动者:',
      waitingFor: '等待:',
      executionFailed: '执行失败',
      failedAlert: '有 {count} 个流程执行失败，请及时处理',
      userReplies: '用户回复:'
    },
    actionType: {
      startWorkflow: '启动流程',
      replyQrcode: '回复QR码',
      replyMsg: '回复消息',
      receiveNotification: '接收通知',
      receiveEform: '接收表单',
      fillEform: '填写表单',
      unknown: '未知操作'
    },
    actionTypes: '种操作类型',
    
    // 流程变量过滤器
    selectWorkflowFirst: '请先选择工作流名称以加载流程变量',
    processVariableFilters: '流程变量过滤（用于分组）',
    loadingProcessVariables: '加载流程变量中...',
    noProcessVariables: '该工作流没有定义流程变量',
    selectProcessVariablesForGrouping: '选择用于分组的流程变量',
    pvFilterHelp: '选择的流程变量将用于对媒体文件进行分组',
    selectedForGrouping: '已选用于分组:',
    groupingNote: '媒体文件将按选中的流程变量值进行分组显示',
    removeFilter: '移除',
    columnName: '字段名称',
    columnNameRequired: '请选择字段名称',
    selectColumn: '选择字段',
    operator: '运算符',
    operatorRequired: '请选择运算符',
    selectOperator: '选择运算符',
    equals: '等于',
    contains: '包含',
    greaterThan: '大于',
    lessThan: '小于',
    notEquals: '不等于',
    value: '值',
    valueRequired: '请输入搜索值',
    enterSearchValue: '输入搜索值',
    addSearchCondition: '添加搜索条件',
    
    // App's Media Reports
    appsMedia: '应用媒体报表',
    eformInstances: '表单实例报表',
    eformPivotReports: '表单枢纽分析报表',
    appsMediaDescription: '按流程实例和流程变量分组展示图片媒体文件，支持 Windows Gallery 效果的自适应排版，以及 PDF、Word、ZIP 导出',
    instanceFilters: '流程实例过滤',
    pleaseSetFilters: '请先设置过滤条件',
    loading: '加载中...',
    processingGroup: '正在处理分组',
    found: '找到',
    groups: '个分组',
    statusSubGroups: '个状态子组',
    images: '张图片',
    noMediaFound: '没有找到符合条件的媒体文件',
    loadFailed: '加载失败',
    noDataToExport: '没有数据可导出',
    exportingPdf: '正在导出 PDF...',
    exportSuccess: 'PDF 导出成功',
    exportFailed: 'PDF 导出失败',
    exportPdf: '导出 PDF',
    exportPdfLandscape: '导出 PDF (横向)',
    exportPdfPortrait: '导出 PDF (纵向)',
    exportDocx: '导出 Docx',
    exportDocxTooltip: '导出为 Word，可自行删除图片与调整版面',
    exportingDocx: '正在导出 Word...',
    exportDocxSuccess: 'Word 导出成功',
    exportDocxFailed: 'Word 导出失败',
    exportZip: '下载 ZIP',
    exportZipTooltip: '按分组目录打包下载所有图片',
    exportingZip: '正在打包 ZIP...',
    exportZipSuccess: 'ZIP 下载成功',
    exportZipFailed: 'ZIP 下载失败',
    noMediaData: '没有媒体数据，请设置过滤条件并点击「查询」',
    
    // 画廊设置
    gallerySettings: '画廊设置',
    displaySettings: '显示设置',
    pdfExportSettings: 'PDF 导出设置',
    maxImagesPerPage: '每页最多图片数量',
    maxImagesPerPageTooltip: '控制每页最多显示的图片数量，实际数量会根据图片大小自动调整',
    imageGap: '图片间距（mm）',
    imageGapTooltip: 'PDF 导出时图片之间的间距',
    minImageWidth: '最小图片宽度（mm）',
    minImageWidthTooltip: '防止图片过小看不清，PDF 导出时图片不会小于此宽度',
    pdfOrientation: 'A4 方向',
    pdfOrientationTooltip: 'PDF 导出时的纸张方向',
    landscape: '横向',
    portrait: '纵向',
    imageQuality: '图片质量',
    imageQualityTooltip: 'PDF 导出时图片的压缩质量（0.1-1.0），值越大质量越高但文件也越大',
    expand: '展开',
    collapse: '收合',
    
    // 流程实例过滤器
    workflowName: '工作流名称',
    selectWorkflowName: '选择工作流名称',
    selectStatus: '选择状态',
    all: '全部',
    startedDateRange: '开始时间范围',
    startDate: '开始日期',
    endDate: '结束日期',
    
    // 流程变量过滤器 - 分组
    selectGroupingVariables: '选择用于分组的流程变量',
    groupingVariablesHelp: '选择的流程变量将用于对媒体文件进行分组，相同 PV 组合的流程实例会合并到同一组',
    groupedProcessVariables: '分组的流程变量',
    filterConditions: '过滤条件',
    filterConditionsHelp: '设置过滤条件来筛选符合条件的流程实例',
    selectWorkflowNameFirst: '请先选择工作流名称以开始查询',
    printOutSettings: 'Print Out Settings',
    excludeImage: '剔除不打印',
    restoreImage: '还原图片',
    excludedTag: '已剔除',
    excludedCompanyShared: '点击图片右上角可剔除不打印项目；剔除设置全公司共用',
    excludedSaveFailed: '保存剔除设置失败',
    excludedSaving: '保存剔除设置中...',
    eformInstancePdfSettings: 'PDF 导出设置',
    eformInstancePdfSettingsDescription: '版面依表单 HTML/CSS 与预设边距。',
    eformInstancePdfFitToPage: '缩放以塞进一页 (Fit to page)',
    eformInstancePdfFitToPageDescription: '开启时，每个表单会缩放以塞进一页 PDF。（Fit to one page）',
    eformInstanceDisplaySettings: '显示设置',
    eformInstanceBaseFontSize: '基础字体大小（px）',
    eformInstanceBaseFontSizeTooltip: 'PDF 导出时表单的基础字体大小，值越大文字越大',
    eformInstanceContentPadding: '内容内距（px）',
    eformInstanceContentPaddingTooltip: 'PDF 导出时表单内容与边缘的间距，值越大间距越大',
    eformInstanceZoomScale: '缩放比例',
    eformInstanceZoomScaleTooltip: 'PDF 导出时的整体缩放比例，值越大内容越大（建议 1.0-2.0）',
    eformInstanceFillWidth: '优先填满宽度',
    eformInstanceFillWidthTooltip: '开启后内容会填满左右宽度，减少两侧留白；若表单较长会自动分多页',
    eformInstanceAdvancedSettings: '进阶设置',
    eformInstanceMargin: '页面边距（mm）',
    eformInstanceMarginTooltip: 'PDF 页面的边距，值越小可用空间越大',
    eformInstanceRenderViewportPx: '虚拟视窗宽度（px）',
    eformInstanceRenderViewportPxTooltip: '生成 PDF 时用来排版的虚拟视窗宽度，太窄会使表头两栏塌成单栏，可调大直到版面满意',
    eformInstanceRenderScale: '渲染分辨率',
    eformInstanceRenderScaleTooltip: 'HTML 转换为图片的分辨率倍数，值越大品质越高但处理时间越长（建议 2-3）'
  },
  
  // MetaFlowBuilder 相关
  metaFlowBuilder: {
    componentPropertyEditor: {
      labels: {
        inputType: '输入类型',
        required: '必填',
        validationPattern: '验证模式 (Pattern)',
        helperText: '帮助文字',
        defaultValue: '默认值',
        richTextContent: '富文本内容',
        options: '选项',
        maxSelectedItems: '最大选择数量',
        description: '描述',
        image: '图片',
        width: '宽度 (width)',
        height: '高度 (height)',
        imageList: '图片列表',
        altText: '替代文字',
        aspectRatio: '宽高比',
        scaleType: '缩放类型',
        componentId: '组件 ID',
        fieldName: '字段名称 (Name)',
        title: '标题',
        maxLength: '最大字数',
        actionType: '操作类型',
        targetScreen: '目标 Screen',
        payload: 'Payload',
        httpMethod: 'HTTP 方法',
        endpointUrl: '端点 URL',
        commerceCollection: 'Commerce 集合 (Collection)',
        metaCollectionLimit: '最大返回数量'
      },
      placeholders: {
        patternExample: '例如: [0-9]+',
        helperTextHint: '显示在输入框下方的提示文字',
        defaultValueHint: '用户打开表单时预填的值，例如区号 852',
        richTextContentHint: '输入富文本内容，支持 Markdown 语法\n例如：\n# 标题\n这是 *粗体* 和 _斜体_ 文本\n~删除线~',
        optionId: '选项 ID',
        optionTitle: '选项标题',
        maxSelectedItemsExample: '例如: 2',
        descriptionHint: '选择器的描述文字',
        widthHeightExample: '例如: 200',
        altTextHint: '图片描述（用于无障碍访问）',
        fieldNameExample: '例如: customer_name',
        selectScreen: '选择 Screen',
        payloadHint: '可选的 payload 数据',
        endpointUrlHint: 'API 端点 URL',
        selectCommerceCollection: '请选择 Commerce 集合'
      },
      tooltips: {
        bold: '粗体 (**文字**)',
        italic: '斜体 (*文字*)',
        strikethrough: '删除线 (~~文字~~)',
        code: '行内代码 (`代码`)',
        heading1: '标题 1 (# 标题)',
        heading2: '标题 2 (## 标题)',
        list: '无序列表 (- 项目)',
        link: '链接 ([文字](URL))',
        richTextHint: '支持 Markdown 语法：*粗体*、_斜体_、~删除线~、# 标题等。每行将作为数组中的一个元素。',
        imageUpload: '上传图片，将自动转换为 base64 格式并作为 src 属性生成到 JSON 中',
        fieldNameHint: '此名称将用于 Meta Flow JSON 和 webhook 回复数据。建议使用有意义的名称，如 \'customer_name\', \'order_date\' 等。',
        targetScreenHint: '选择导航到的 Screen ID',
        textAreaMaxLength: '默认 600 字，官方上限 600'
      },
      selectOptions: {
        inputTypes: {
          text: '文字',
          email: '电子邮件',
          phone: '电话',
          number: '数字',
          url: 'URL'
        },
        actionTypes: {
          navigate: '导航到 Screen',
          submit: '提交',
          call: '调用',
          url: '打开 URL'
        },
        scaleTypes: {
          contain: 'Contain（完整显示）',
          cover: 'Cover（填充）'
        },
        httpMethods: {
          get: 'GET',
          post: 'POST',
          put: 'PUT',
          delete: 'DELETE'
        }
      },
      buttons: {
        list: '列表',
        link: '链接',
        addOption: '添加选项',
        remove: '移除',
        uploadImage: '上传图片',
        deleteImage: '删除此图片',
        addImage: '添加图片',
        saveChanges: '保存更改'
      },
      messages: {
        optionIdRequired: '选项 ID 必填',
        optionTitleRequired: '选项标题必填',
        altTextRequired: '替代文字必填',
        fieldNameRequired: '请输入字段名称',
        fieldNamePattern: '名称只能包含字母、数字和下划线，且必须以字母开头',
        titleRequired: '请输入标题',
        imageReadFailed: '图片读取失败',
        imageFormatError: '只支持 JPEG 和 PNG 格式的图片！',
        imageSizeExceeded: '图片大小不能超过 {maxSizeKB}KB（1MB）！',
        imageSizeWarning: '图片大小 {fileSizeKB}KB 超过推荐值 300KB，可能影响性能',
        maxImagesWarning: '最多只能添加 3 张图片！'
      },
      helperText: {
        richTextHint: '提示：每行将作为数组中的一个元素。支持 Markdown 语法。选中文字后点击上方按钮进行格式化。',
        imageConverted: '提示：图片已转换为 base64 格式',
        photoPickerRequiredHint: '对应 Meta Flows PhotoPicker 的 min-uploaded-photos：开启为至少 1 张（必填），关闭为 0（选填）。',
        documentPickerRequiredHint: '对应 Meta Flows DocumentPicker 的 min-uploaded-documents：开启为至少 1 个（必填），关闭为 0（选填）。',
        commerceCollectionHint: '选项内容对应「Commerce 集合」（CommerceCollections）下的商品，显示为「商品名称 - 单位」，回传值为商品 ID（commerce_products.Id）。'
      },
      defaultValues: {
        richTextDefault: '请输入富文本内容',
        richTextDefaultLine2: '支持 *粗体*、_斜体_、~删除线~ 等 Markdown 语法',
        imageAltDefault: '图片 {index}'
      },
      dividers: {
        actionSettings: '操作设置'
      }
    },
    screenEditor: {
      cardTitles: {
        header: 'Header（可选）',
        body: 'Body（必填）',
        footer: 'Footer（必填）',
        actions: 'Actions（操作组件）'
      },
      labels: {
        headerType: 'Header 类型:',
        headerText: 'Header 文字:',
        mediaUrl: '媒体 URL:',
        bodyExamplesTitle: 'Body 变量范例值（送 Meta 审核用）',
        flowHeaderText: 'Flow 表单内 Header（在 Flow popup 显示）',
        flowBodyText: 'Flow 表单内 Body（在 Flow popup 显示，建议写固定话术）',
        templateHeaderText: 'WhatsApp 消息 Header（送 Template 用，可含 {{1}}）',
        templateBodyText: 'WhatsApp 消息 Body（送 Template 用，可含 {{N}} placeholder）'
      },
      selectOptions: {
        headerTypes: {
          text: '文字',
          image: '图片',
          video: '视频',
          document: '文档'
        }
      },
      placeholders: {
        headerText: 'Header 文字',
        mediaUrl: '媒体 URL',
        bodyContent: '输入 Body 内容',
        footerContent: '输入 Footer 内容（必填）',
        addComponent: '请输入组件类型 (text_input, rich_text, date_picker, select, checkbox, radio):',
        dropZone: '从左侧组件库拖放组件到此处',
        bodyExampleValue: '{{{n}}} 的范例值',
        templateHeaderText: '例：客户 {{1}} 您好',
        templateBodyText: '例：Product: {{1}}\\nQuantity: {{2}}\\nDate: {{3}}'
      },
      buttons: {
        removeHeader: '移除 Header',
        addHeader: '添加 Header',
        addComponent: '添加组件'
      },
      tooltips: {
        dragToReorder: '拖拽以调整顺序'
      },
      messages: {
        maxImagesError: '每个屏幕最多只能添加 3 张图片！',
        addRichTextSuccess: '已添加 {componentType} 组件，已自动移除 Header 和 Body',
        addComponentSuccess: '已添加 {componentType} 组件',
        deleteRichTextSuccess: '已删除 RichText 组件，已自动恢复 Header 和 Body',
        deleteComponentSuccess: '已删除组件',
        richTextConflict1: 'RichText 组件只能与 Footer 配对使用，不能与其他组件共存',
        richTextConflict2: 'RichText 组件只能与 Footer 配对使用，请先移除 RichText'
      },
      helperText: {
        footerRequired: '* Footer 是必填项，不能为空',
        bodyExamplesHint: 'Body 含 {{N}} placeholder 时，这里的范例值只用于送 Meta 审核 Flow Template，执行时实际值仍由发送节点的流程变量映射注入。',
        flowHeaderHint: '{{N}} 在这里不会被替换（会原样显示），建议写成固定标题。',
        flowBodyHint: '{{N}} 在这里不会被替换（会原样显示），建议写成固定话术，例如"请确认以下资料并按 Reserve"。',
        templateHeaderHint: '出现在 WhatsApp 消息气泡上方；发送时会由 body.parameters 动态替换 {{1}}（Meta 限制 HEADER 仅支持单一 {{1}}）。未填则沿用 Flow 表单内 Header（向后兼容）。',
        templateBodyHint: '出现在 WhatsApp 消息气泡内文；发送时会由 body.parameters 动态替换 {{N}}。{{N}} 必须与发送节点的"模板变量"对应。未填则沿用 Flow 表单内 Body（向后兼容）。',
        templateHeaderTooManyPlaceholders: 'Meta API 限制 HEADER 仅支持单一 {{1}}，多余的 placeholder 不会被替换，请只保留一个。'
      },
      defaultValues: {
        headerText: '标题',
        bodyText: '请输入内容',
        footerText: '提交'
      }
    },
    componentRenderer: {
      placeholders: {
        button: '按钮',
        textInput: '文字输入',
        textArea: '多行文字',
        richText: '富文本内容（支持 Markdown）',
        select: '下拉选择',
        datePicker: '日期选择',
        option: '选项',
        image: '图片',
        imageIndex: '图片 {index}',
        addImages: '请添加图片（最少 1 张，最多 3 张）',
        unknownComponent: '未知组件',
        component: '组件'
      },
      cardTitles: {
        edit: '编辑 {componentType}'
      },
      buttons: {
        cancel: '取消'
      },
      helperText: {
        imageCarouselSettings: '宽高比: {aspectRatio}, 缩放: {scaleType}'
      },
      altText: {
        preview: '预览'
      }
    },
    componentPalette: {
      componentLabels: {
        textInput: '文字输入',
        textArea: '多行文字',
        datePicker: '日期选择',
        calendarPicker: '日历选择',
        select: '下拉选择',
        checkbox: '复选框组',
        radio: '单选框组',
        chipsSelector: '小标签选择器',
        image: '图片',
        imageCarousel: '图片轮播',
        photoPicker: '照片选择器',
        documentPicker: '文档选择器',
        embeddedLink: '嵌入式链接',
        optIn: '选择加入',
        if: '条件判断 (If)',
        switch: '条件渲染 (Switch)',
        navigationList: '导航列表',
        richText: '富文本显示'
      },
      categories: {
        input: '输入',
        select: '选择',
        media: '媒体',
        mediaUpload: '媒体上传',
        link: '链接',
        logic: '逻辑',
        container: '容器',
        textDisplay: '文本显示',
        other: '其他'
      },
      sectionTitles: {
        componentLibrary: '组件库'
      }
    },
    page: {
      formInfo: '表单信息',
      flowName: 'Flow 名称:',
      flowNamePlaceholder: 'Flow 名称',
      description: '描述:',
      descriptionPlaceholder: '描述',
      screens: 'Screens',
      editScreen: '编辑 Screen: {title}',
      selectScreenToEdit: '请选择一个 Screen 进行编辑',
      componentProperties: '组件属性',
      back: '返回',
      screenProperties: 'Screen 属性',
      screenId: 'Screen ID:',
      screenTitle: 'Screen Title:',
      screenTitlePlaceholder: 'Screen 标题',
      componentList: '组件列表',
      noComponents: '暂无组件，请在左侧组件库添加',
      delete: '删除',
      defaultFlowName: '新 Flow',
      defaultScreenTitle: '新 Screen',
      defaultComponentName: '组件 {index}',
      fieldDisplaySetting: '表单字段显示设定',
      messages: {
        flowNameRequired: '请输入 Flow 名称',
        screenAdded: '已添加新 Screen',
        selectScreenFirst: '请先选择一个 Screen',
        componentUpdated: '组件已更新',
        noFieldsToConfigure: '请先设计 Flow 并加入输入组件',
        fieldDisplaySettingPendingSave: '字段设定已暂存，请按「保存」按钮让变更生效'
      }
    },
    formTypeSelection: {
      title: '选择表单类型',
      htmlFormDesigner: {
        title: 'HTML 表单设计器',
        description: '使用现有的 HTML 表单设计器创建表单'
      },
      metaFlowBuilder: {
        title: 'Meta Flow Builder',
        description: '创建 WhatsApp Flows 表单（JSON 格式）'
      }
    }
  },

  wpaPermissions: {
    title: 'PWA 权限管理',
    pageTitle: 'PWA 权限管理',
    tabRoles: '角色',
    tabGroups: '群组',
    tabAccounts: 'PWA 帐号',
    rolesTitle: 'PWA 角色',
    groupsTitle: '权限群组',
    accountsTitle: 'PWA 帐号',
    roleKey: '角色代码',
    displayName: '显示名称',
    description: '说明',
    groupCount: '群组数',
    contactCount: '帐号数',
    accounts: 'PWA 帐号',
    accountCount: '帐号数',
    editRole: '编辑角色',
    groupName: '群组名称',
    role: '角色',
    memberCount: '成员数',
    customerCount: '客户数',
    status: '状态',
    active: '启用',
    inactive: '停用',
    disabled: '停用',
    createGroup: '新增群组',
    editGroup: '编辑群组',
    members: '成员',
    customers: '客户',
    addMember: '新增成员',
    addMembers: '新增成员',
    addCustomer: '新增客户',
    addCustomers: '新增客户',
    remove: '移除',
    search: '搜索',
    name: '名称',
    phone: '电话',
    phonePlaceholder: '例如 85291234567（不含 +）',
    email: '邮箱',
    customerNo: '客户编号',
    branchNo: '分店',
    customerName: '客户名称',
    selectCustomersTable: '以表格选择客户',
    selectCustomersTableHint: '开启与客户主档相同的列表，可搜索、筛选公司（租户管理员）、多选',
    selectDefaultCustomer: '选择默认客户',
    selectDefaultCustomerTable: '以表格选择默认客户',
    selectDefaultCustomerOverrideHint: '须为已指派客户之一；若选择尚未指派的客户，将一并加入指派清单',
    effectiveRole: '有效角色',
    roleSource: '来源',
    override: '个别设置',
    accountOverride: '帐号',
    group: '群组继承',
    overrideCustomerCount: '指定客户数',
    items: '笔',
    details: '明细',
    createAccount: '新增帐号',
    editAccountFor: '编辑帐号',
    deleteAccount: '删除帐号',
    deleteAccountConfirm: '确定删除此 PWA 帐号吗？相关角色／客户／群组成员将一并删除',
    accountSaved: '帐号已保存',
    saveAndSendNotification: '保存并发出通知',
    saveAndResendPassword: '保存并重发密码',
    saveAndResendPasswordConfirm: '将保存变更、自动生成新密码并重发 welcome 消息（含电邮）。确定继续？',
    saveAndResendPasswordSuccess: '已保存、重设密码并重发 welcome 消息',
    accountDeleted: '帐号已删除',
    accountTabIdentity: '帐号／角色',
    accountTabCustomers: '客户／默认客户',
    accountIdentityHint: 'PWA 登录帐号（与联系人主档解耦）。Phone 用于 WhatsApp OTP 登录比对。',
    searchAccount: '搜索 PWA 帐号…',
    loginId: '登录帐号',
    loginIdField: '登录帐号',
    loginIdRequired: '请填写登录帐号',
    password: '密码',
    passwordRequiredForCreate: '建立帐号须设置密码',
    newPassword: '新密码',
    newPasswordHint: '留空则不变更密码',
    defaultCustomer: '默认客户',
    selectCustomers: '选择客户',
    selectRole: '选择角色',
    removeMemberConfirm: '确定移除此成员吗？',
    removeCustomerConfirm: '确定移除此客户吗？',
    deleteGroupConfirm: '确定删除此群组吗？',
    memberAdded: '成员已加入',
    memberRemoved: '成员已移除',
    customerAdded: '客户已加入',
    customerRemoved: '客户已移除',
    groupSaved: '群组已保存',
    groupDeleted: '群组已删除',
    groupCustomersUpdated: '群组客户已更新',
    roleSaved: '角色已保存',
    contactName: '联系人名称',
    loginName: '登录帐号',
    loginNamePlaceholder: '请输入登录帐号',
    hasPassword: '已设密码',
    selectContact: '选择联系人',
    noData: '无数据',
    saveSuccess: '保存成功',
    deleteSuccess: '删除成功',
    confirmDelete: '确定要删除吗？',
    tabOtpSettings: 'OTP',
    otpSettingsTitle: 'OTP 设置',
    otpTabWhatsapp: 'WhatsApp',
    otpTabEmail: '电邮模板',
    otpEmailHint: '用于 PWA「忘记密码」电邮验证码。主旨或正文须含 {{1}}，发送时会替换为 6 位 OTP。',
    otpEmailTemplateTitle: '电邮 OTP 模板',
    otpEmailSubject: '邮件主旨',
    otpEmailSubjectPlaceholder: '例如：【公司名称】密码重设验证码 {{1}}',
    otpEmailBody: '邮件正文（支持 HTML）',
    otpEmailBodyPlaceholder: '<p>您好，</p><p>您的验证码为：<strong>{{1}}</strong></p><p>验证码 5 分钟内有效。</p>',
    otpEmailPreview: '效果预览（{{1}} → 123456）',
    otpEmailRequired: '请填写电邮主旨与正文',
    otpEmailPlaceholderRequired: '主旨或正文至少须包含 {{1}} 作为 OTP 验证码占位符',
    otpEmailSaved: '电邮 OTP 模板已保存',
    otpWhatsappSaved: 'WhatsApp OTP 设置已保存',
    tabWelcomeSettings: 'Welcome Message',
    welcomeSettingsTitle: 'Welcome Message',
    welcomeWhatsappHint: '新 PWA 账号建立成功后，若账号有电话且已设定模板，将自动发送 WhatsApp 欢迎消息。正文可使用 {{1}}=登录账号、{{2}}=显示名称。',
    welcomeWhatsappPolicyWarning: 'WhatsApp 模板仅适用于一般通知、说明或介绍，不得传送密码等敏感凭证；初始密码请改以「Welcome Message → 电邮模板」发送。',
    welcomeActiveTemplate: '目前启用的欢迎 Template',
    welcomeNoTemplate: '尚未设定欢迎 Template',
    welcomeCreateTemplate: '建立新 Welcome Template',
    welcomeCatMarketing: '市场 MARKETING',
    welcomeCatUtility: '工具 UTILITY',
    welcomeCatAuth: '验证 AUTHENTICATION',
    welcomeAuthHint: 'AUTHENTICATION 类别由 Meta 产生安全文案，不建议用于一般欢迎消息。',
    welcomeTemplateList: '已建立的 Templates',
    welcomeSelectTemplate: '请先选择已审批的 Template',
    welcomeWhatsappSaved: 'WhatsApp 欢迎消息设定已保存',
    welcomeEmailRequired: '请填写电邮主旨与正文',
    welcomeEmailSaved: '电邮欢迎消息模板已保存',
    welcomeBodyRequired: '请输入模板正文',
    welcomeTplSubmitted: 'Template 已提交 Meta 审核',
    welcomeEmailHint: '新账号有电邮时发送。{{login_id}}/{{1}}=账号、{{display_name}}/{{2}}=名称、{{password}}/{{3}}=建立时密码（仅当次）。',
    welcomeEmailTemplateTitle: '电邮欢迎模板',
    welcomeEmailRteHint: '工具栏可设置粗体、链接等；右侧按钮可插入账号／名称／密码变量。',
    welcomeInsertLoginId: '插入登录账号 {{login_id}}',
    welcomeInsertDisplayName: '插入显示名称 {{display_name}}',
    welcomeInsertPassword: '插入初始密码 {{password}}',
    welcomeRteBold: '粗体',
    welcomeRteItalic: '斜体',
    welcomeRteUnderline: '下划线',
    welcomeRteStrike: '删除线',
    welcomeRteHeader: '标题',
    welcomeRteColor: '文字颜色',
    welcomeRteBackground: '背景色',
    welcomeRteListOrdered: '编号列表',
    welcomeRteListBullet: '项目符号',
    welcomeRteAlign: '对齐',
    welcomeRteLink: '插入链接',
    welcomeRteClean: '清除格式'
  },
  chatBotInbox: {
    loadFailed: '加载对话列表失败',
    searchPlaceholder: '搜索联系人或号码…',
    filterAll: '全部',
    filterContact: '联系人',
    filterAnonymous: '匿名',
    sourceAll: '全部来源',
    sourceChatBot: 'ChatBot',
    sourceChatOrderingCart: '购物车',
    empty: '暂无对话记录',
    selectSession: '请从左侧选择一个对话',
    pollingActive: '实时更新中（每 30 秒自动检查新消息）',
    newMessagesAvailable: '有新消息，',
    reloadNow: '立即加载'
  }
};

export default zhSC; 